const template = {
	template: 'store',
	title: '',
	description: '',
	name: 'Diamonds Direct Charlotte',
	shortName: 'Charlotte',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Charlotte to shop our latest arrivals and exclusive selection of diamond and fine jewelry.',
		'Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectsouthpark',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	video: null,
	address: {
		line1: '4521 Sharon Road',
		line2: 'Charlotte, NC 28211',
	},
	googleMapsLink: '',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '7045329041',
	email: 'infoCLT@diamondsdirect.com',
	team: [
		{
			name: '',
			title: '',
			picture: '',
			email: '',
			phone: '',
			bio: [
				'',
				'',
				'',
				'',
				'',
			],
		},
	],
	sponsorships: [
		{
			name: '',
			image: '',
		},
	],
	reviews: {
		googleRead: '',
		googleWrite: '',
	}
};


const ATX = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Austin',
	title: 'Diamonds Direct Austin - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Austin Location Today!',
	shortName: 'Austin',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'While you\'re having a great day exploring The Domain, drop by our showroom across the street from the Westin for your daily dose of diamonds. Our diamond experts will hook you with their unmatched knowledge and selections. This location has been planning puppy proposals and keeping Austin weird since 2012.',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectaustin',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '11104 Domain Drive',
		line2: 'Austin, TX 78758',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Austin/@30.3976246,-97.728506,17z/data=!3m1!4b1!4m5!3m4!1s0x8644cc714d92464b:0xb99ab21cf14e8422!8m2!3d30.39762!4d-97.726312',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '5126919950',
	email: 'infoAus@diamondsdirect.com',
	team: [
		{
			name: 'Anat Adi-Atias',
			title: 'Senior Vice President',
			picture: 'anat.jpg',
			email: 'Anat@DiamondsDirect.com',
			phone: '',
			bio: [
				'Anat Adi-Atias, Vice President, was born in Jerusalem, Israel in 1969 and was raised in the Netherlands. In 1987 Anat joined the Israel Defense Force for two years at the IDF Spokesman\'s office, declaring those two years as the years that shaped and formed her into the achiever she is. After the military service, in 1989, Anat moved to Washington, DC and joined the Embassy of Israel for five years at its Congressional Affairs department, working closely with both the US and Israeli diplomatic and political scenes.',
				'Anat graduated from the University of Maryland in 1994 and followed her dreams of joining the Hospitality field of Hotel Management. Her first position was Director of Catering Sales at a prominent Washington, DC Hotel. Once moving back to Israel she was solicited by a prominent Hotel in Jerusalem as Guest & Public Relations Manager hosting the movers and shakers of the world, closely engaging with Presidents, Vice Presidents, Prime Ministers and many heads of States and their staff.',
				'In 2010, Anat was offered a VP position at Distinctive Diamonds (now Diamonds Direct) in Indianapolis, IN. As an experienced diamond wholesaler, who gained extensive experience in the global diamond industry and served high-end diamond and jewelry retailers for over 12 years, joining the retail side of the business was a natural career decision. It was instantly clear that working closely and directly with the end consumers themselves is the true melting point of all her passions combined. \'The emotional factor of meeting the couple ending up wearing a beautiful diamond has taken the thrill of being part of the diamond industry to a totally different level\'.',
				'Anat fell in love with Austin from day one when moving to Austin, TX in 2014 as Vice President of Diamonds Direct. \'Everything feels like home - from the warm weather to the laid back personality of the people of Austin’. She loves checking out the endless BBQ and Texmex restaurants while wearing her Longhorn attire. \'Austin is amazing and I couldn\'t be prouder taking part in "keeping it weird" by exceeding people\'s expectations when it comes to diamonds & jewelry\'.',
				'Anat enjoys spending time with David, her husband of 25 years and long awaited for daughter Zoey. They love to play with their adopted Beagle, Brandy, and spend their time together cooking and traveling. Sponsoring local philanthropy, and especially foundations for kids, is a true passion for Anat ever since her very own won the battle herself.',
			],
		},
		{
			name: 'Lou Verde',
			title: 'General Manager',
			picture: 'lou_verde.jpg',
			email: 'louv@diamondsdirect.com',
			phone: '',
			bio: [
				'Lou was born and raised in Rochester, NY. Immediately after high school, he joined the U.S. Navy in September 2001. After graduating at the top of his class he was selected to attend a specialty school where he became an Advanced Weapons Specialist and played a critical role in several operations throughout the world. Lou really enjoyed making a difference and exploring the different cities he visited.',
				'After his time in the service, Lou returned to his hometown where he met and then married his best friend Kara. He pursued a career in Hospitality while earning his Bachelor’s degree in Organizational Management. He started at the bottom and learned and worked in every position in hotels until he became a General Manager in only four years. During his career in hospitality, he managed hotels in five different cities before he stumbled upon his new passion for luxury jewelry and sales.',
				'Lou joined the Diamonds Direct team in November 2016. After nearly a year of training becoming a Diamonds Expert and graduate from the Gemological Institute of America, Lou took over his first store in Salt Lake City, UT in August 2017. He spends every second of his spare time with his beautiful wife and two children.',
			],
		},
		{
			name: 'Jennifer Anderson',
			title: 'Graduate Gemologist & Diamond Expert',
			picture: 'jennifer_anderson.jpg',
			email: 'JenniferA@DiamondsDirect.com',
			phone: '',
			bio: [
				'Jennifer Anderson, Graduate Gemologist, has been with Diamonds Direct since 2013. She has a Bachelor\'s Degree in Government from The University of Texas.',
				'Anderson has been in the diamond and jewelry industry for over 20 years. After college, she pursued her lifelong interest in gemstones and enrolled at the G.I.A., becoming a Graduate Gemologist. She moved to the New York area to attend the Fashion Institute of Technology where she learned jewelry design and fabrication from some of the most respected designers in the world. While studying at the Fashion Institute, Anderson worked for a major diamond wholesaler grading and evaluating loose diamonds.',
				'In her free time, Anderson enjoys yoga, water polo, collecting tropical plants and hanging out with her husband and son.',
			],
		},
		{
			name: 'Linnea Kullman',
			title: 'Diamond Expert',
			picture: 'linnea_kullman.jpg',
			email: 'Linnea@DiamondsDirect.com',
			phone: '',
			bio: [
				'Linnea Kullman, Diamond Expert, has been part of the Diamonds Direct family since 2014. She started in the jewelry business in 1997, and since then has worked in almost every aspect of the business including sales, management, buying, and diamond wholesaling. She has been certified as a Diamontologist by the Diamond Council of America and has earned a Diamond Essentials certificate from the Gemological Institute of America.',
				'Linnea is a native Texan, born in West Texas and raised in Austin. When she isn\'t busy at the work she loves, she enjoys cooking southern style, traveling, and spending time with her daughter, family, and friends.',
			],
		},
		{
			name: 'Aesuk Canterino',
			title: 'Diamond Expert',
			picture: 'aesuk_canterino.jpg',
			email: 'aesuk@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Julia Limas',
			title: 'Back Office',
			picture: 'julia_limas.jpg',
			email: 'JuliaL@DiamondsDirect.com',
			phone: '',
			bio: [
				'Julia has been with Diamonds Direct since 2015. Julia has sixteen years of experience in the jewelry industry.',
				'In her spare time Julia loves to read, watch movies, spend time with friends and family, and her cat Kido.',
			],
		},
		// {
		// 	name: 'Brooke Lopez',
		// 	title: 'Receptionist',
		// 	picture: 'brooke_lopez.jpg',
		// 	email: 'BrookeL@DiamondsDirect.com',
		// 	phone: '',
		// 	bio: [
		// 		'Brooke has been with Diamonds Direct Austin since it opened. In her spare time she enjoys going to Zilker Park, yoga, and fishing with her boyfriend and son.',
		// 	],
		// },
		// {
		// 	name: 'Megan Molina',
		// 	title: 'Bands Specialist & Receptionist',
		// 	picture: 'megan_molina.jpg',
		// 	email: '',
		// 	phone: '',
		// 	bio: [],
		// },
		// {
		// 	name: 'Cesar Rodriguez',
		// 	title: 'Bands Specialist',
		// 	picture: 'cesar_rodriguez.jpg',
		// 	email: 'cesar@diamondsdirect.com',
		// 	phone: '',
		// 	bio: [],
		// },

		{
			name: 'Dominic Ly',
			title: 'Shop Manager',
			picture: 'dominicly.jpg',
			email: 'dominic@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		// {
		// 	name: 'Kevin Dudley',
		// 	title: 'Jeweler',
		// 	picture: 'kevin_dudley.jpg',
		// 	email: '',
		// 	phone: '',
		// 	bio: [],
		// },
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://bit.ly/3oufhMm',
		googleWrite: 'https://bit.ly/3oufhMm',
	}
};

const BAY = {
	template: 'store',
	currentPromo: false,
	title: 'Diamonds Direct Houston (Baybrook) - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Baybrook Location Today!',
	name: 'Diamonds Direct Houston (Baybrook)',
	shortName: 'Houston (Baybrook)',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Baybrook to shop our latest arrivals and exclusive selection of diamond and fine jewelry.',
		'Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectbaybrook',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '18610 Gulf Frwy',
		line2: 'Friendswood, TX 77546',
	},
	googleMapsLink: 'https://www.google.com/maps/dir//18610+Gulf+Fwy,+Houston,+TX+77017/@29.6658102,-95.2634147,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x864097c92030883f:0xb9d528f9b9b18989!2m2!1d-95.261226!2d29.6658056!3e0',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '2816123632',
	email: 'infoHBB@diamondsdirect.com',
	team: [
		{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: [
				'Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.',
				'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.',
				'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.',
				'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.',
			],
		},
		{
			name: 'Tamir Shkargi',
			title: 'Vice President',
			picture: 'Tamir1.jpg',
			email: 'Tamir@diamondsdirect.com',
			phone: '',
			bio: [
				'Tamir Shkargi joined the Diamonds Direct team 2017. Originally from Israel, Tamir served in the Israeli Military for three years. Upon his completion of service, he embarked on a career with the Israeli government for over ten years. After receiving his degree in Business Administration at Ono Academic College, Tamir decided to move to the United States with his family.',
				'Tamir’s new chapter began in Austin, Texas which led him to pursue a career in retail management with Diamonds Direct. It was the remarkable culture and amazing group of people that made Diamonds Direct the perfect fit for Tamir.',
				'After managing the Frisco store for nearly two years, he was given the opportunity to bring his talents to Houston and grow the Diamonds Direct family. Tamir greatly looks forward to this new journey with his family and they are excited to call Houston home.',
				'Outside of work, Tamir enjoys playing soccer with friends and spending time with his wife and their precious two boys!',
			],
		},
		{
			name: 'Rashad Smith',
			title: 'General Manager',
			picture: 'Rashad.jpg',
			email: '',
			phone: '',
			bio: [
				'Rashad joined the Diamonds Direct team in 2021. With a wealth of diamond knowledge and leadership experience, Rashad is thrilled to lead the Baybrook team as the General Manager.',
				'Rashad was a DCA graduate and has earned additional education with the GIA Diamond, Gemstone and Jewelry Essentials as well as GIA Diamond Grading Class. He has also received his AGS Registered Jeweler certification. On top of his amazing diamond education, Rashad comes to Diamonds Direct with a wealth of experience. Rashad has 12 years of retail experience, 10 years of jewelry experience and 8 years of jewelry management experience. His goal is to foster growth within the store and ensure the work environment is always fun and inviting.',
				'Outside of work, Rashad enjoys spending time with his wife and his newborn son as well as exploring new places.',
			],
		},
		{
			name: 'Hector Hernandez',
			title: 'Bench Jeweler',
			picture: 'Hector.jpg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Rebecca Shanahan',
			title: 'Back Office Manager',
			picture: 'Rebecca.jpg',
			email: '',
			phone: '',
			bio: [
				'Rebecca serves as our Back Office Manager and has worked in the industry since 2015. She was born in Germany and grew up as an Army brat. Although she has lived in many places, Texas is the one that holds her heart.',
				'Before joining Diamonds Direct, Rebecca was in the retail industry for 15 years. She then made a seamless transition into the  jewelry world where she worked for a family-owned jeweler. In this role, she wore many hats ranging from marketing to HR to billing, so Rebecca brings with her a diverse set of skills that allows her to be a true team player.',
				'In her free time, she enjoys spending time with her husband and four kids, traveling and watching the Astros.',
			],
		},
		{
			name: 'Miranda Bishop',
			title: 'Back Office (FT)',
			picture: 'Miranda.jpg',
			email: '',
			phone: '',
			bio: [
				'Miranda is a member of the front and back office support staff. She joins Diamonds Direct with over 5 years in the restaurant industry.',
				'Miranda is passionate about learning new things, and she is willing to do whatever it takes to make magic happen. Her enthusiasm for life pours out into how she conducts business each day and her passion is in meeting new people and gaining new experiences.',
				'In her free time, Miranda loves spending time with her family and friends. She is thrilled for this new adventure in Baybrook!',
			],
		},
		{
			name: 'Daniella Garcia',
			title: 'Sales',
			picture: 'Daniella.jpg',
			email: '',
			phone: '',
			bio: [
				'Daniella joined Diamonds Direct in 2022. She is originally from Massachusetts  but came to Texas in 2009 and has never looked back! She has over 12 years of experience in the luxury retail industry as well as 6 years of experience in the jewelry industry. In addition, Daniella is DCA certified.',
				'Daniella has extensive experience in sales, customer service and jewelry design and also has a passion for excellence in the workplace. One of her major strengths is in custom design for her clients. In her spare time, Daniella loves to spend time with family and friends, travel and master the art of charcuterie boards.',
			],
		},
		{
			name: 'Clinton Richards',
			title: 'Sales',
			picture: 'Clinton.jpg',
			email: '',
			phone: '',
			bio: [
				'Clinton joined Diamonds Direct in 2022. Before joining the company, he worked in the industry for over 20 years and is DCA certified. Clinton is originally from Jamaica but loves the amazing city of Houston and all of the opportunities it has to offer.',
				'Clinton moved into the luxury industry first through his love of timepieces. He, himself, is an avid collector of fine watches. Throughout his career, Clinton has performed at a very high caliber, winning numerous performance honors. His passion for customer service and experience ensure that any time spent with him is nothing short of spectacular.',
				'In his spare time, Clinton loves traveling and watching sports.',
			],
		},
		{
			name: 'Kelly Muraco',
			title: 'Sales',
			picture: 'Kelly.jpg',
			email: '',
			phone: '',
			bio: [
				'Jewelry has been a part of Kelly\'s life since she was 12 years old, spending afternoons with her mother working on custom jewelry designing. Since then, Kelly has been in and around the jewelry industry. Kelly graduated with a Communications Degree and an Associates in Business, and she quickly put that to work in LA where she worked for Entertainment Tonight and Dick Clark Productions.',
				'Kelly has extensive experience, including 20 years in the retail industry, with 12 of the years being in luxury jewelry, and also 6 years at Diamonds Direct. She has earned her certification for GIA Applied Jewelry Professional (AJP). While in retail, she worked for clients such as Christian Dior and David Yurman. Her extensive experience and detail-oriented manner make her a stellar diamond expert for our Baybrook team. On top of that, she has an impeccable personality and humor that puts any customer at ease.',
				'In her spare time, Kelly enjoys spending time with her family, listening to live music and playing with her dog Bailee.',
			],
		},
		{
			name: 'Abbi Johnson',
			title: 'Front Office (FT)',
			picture: 'Abby.jpg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Giselle Diaz',
			title: 'Front Office (PT)',
			picture: 'Giselle.jpg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'DaNel Dotson',
			title: 'Diamond Expert',
			picture: 'DaNel.jpg',
			email: '',
			phone: '',
			bio: [
				'DaNel joined the Diamonds Direct team in February of 2020. She has over 20 years of experience in the jewelry industry, including serving as the General Manager for several jewelry stores. Before her time in the jewelry industry, DaNel served as a United States Navy Cryptologic Technician, where she supervised a communications center for worldwide military requests for highly classified material. She also served as an owner of a Montessori school for 11 years, which has contributed to her dedication to business, stellar communication skills and amazing character.',
				'In her free time, DaNel enjoys cooking for her family and hosting family gatherings. Outside of work, her passion is creating a loving experience for family, friends and kiddos!',
			],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://www.google.com/search?q=diamonds+direct+baybrook&rlz=1C5CHFA_enUS897US897&oq=diamonds+direct+baybrook&aqs=chrome..69i57j69i60l3.4511j0j4&sourceid=chrome&ie=UTF-8',
		googleWrite: 'https://www.google.com/search?q=diamonds+direct+baybrook&rlz=1C5CHFA_enUS897US897&oq=diamonds+direct+baybrook&aqs=chrome..69i57j69i60l3.4511j0j4&sourceid=chrome&ie=UTF-8',
	}
};

const BHM = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Birmingham',
	title: 'Diamonds Direct Birmingham - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Birmingham Location Today!',
	shortName: 'Birmingham',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Take a trip over to Cahaba Village in Mountain Brook and find the ring of your dreams. Our showroom may be the only place in the South where Auburn and Alabama fans can coexist since we love supporting both teams! These Best of BHAM-worthy diamond experts are ready to help you through any jewelry buying occasion.',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectbham',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '2800 Cahaba Village Plz.',
		line2: 'Birmingham, AL 35243',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Birmingham/@33.461258,-86.7565564,17z/data=!3m1!4b1!4m5!3m4!1s0x888919c328101159:0x4f5c52ea68cc0f92!8m2!3d33.4612535!4d-86.7543677',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '2052017400',
	email: 'infoBhm@diamondsdirect.com',
	team: [
		{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: [
				'Amit Berger, EVP, founded Diamonds Direct Birmingham in 2008. He joined the Diamonds Direct parent company in 1995 in Israel while working in the cutting facility and learning the trade\'s secrets.',
				'Born in Israel, Berger grew up working in his family restaurant business and developed his love of customer service and gregarious personality. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry. It was then when he started working for Diamonds Direct\'s parent company in the cutting facility with the founder of the company.',
				'In 1997, Berger came to the United States to begin working one on one with big diamond buyers. He traveled back and forth between Israel and 40 different states in the US working for Diamonds Direct\'s parent company in the wholesale division. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work with Diamonds Direct\'s parent company in the wholesale office and selling diamonds to top jewelry stores around the country. Eventually, Berger was running the wholesale division and was in charge of selecting diamonds from the cutting facility in Israel.',
				'In the meantime, his brother Itay, had opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the company. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.',
				'Berger made the move to Birmingham and opened the second Diamonds Direct location here in Birmingham, AL. He calls Birmingham his home and loves the friendly atmosphere. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. Their favorite thing to do as a family is play with their dog Ziggy and travel.',
			],
		},
		{
			name: 'Yoni Padan',
			title: 'Vice President, Birmingham',
			picture: 'yoni2.jpg',
			email: 'Yoni@DiamondsDirect.com',
			phone: '',
			bio: [
				'Yoni Padan joined Diamonds Direct in January of 2012. He was Born in Israel and moved to the United States in 1989. Padan graduated with an international business degree from the University in Herzliya. In 2008, Padan came back to the US and joined Diamonds Direct in 2012. Since the beginning of his career at Diamonds Direct, he made sure to always keep the special thing that makes Diamonds Direct what is, family. "The family spirit of Diamonds Direct penetrates from our staff to our customers and that is why the relationship between us and the customer is so special. I love what I do, and its great waking up every morning feeling that way."',
				'In July of 2012, Yoni met his beautiful wife Natasha. They are now very happily married with three boys, Brandon, Ariel and Daniel. He enjoys spending every free second he has with them.',
			],
		},
		{
			name: 'Irene Chucherilova',
			title: 'General Manager',
			picture: 'irene_chucherlova.jpg',
			email: 'irenes@diamondsdirect.com',
			phone: '',
			bio: [
				'Irene Chucherilova, Diamond Expert, began her career at Diamonds Direct in 2014. She has a Bachelor’s degree in International Business from Ukraine Khmelnytskyi National University. Chucherilova has lived in the United States for 6 years, originally from Ukraine. Before working for Diamonds Direct she worked as a manager of an Advertising company, Khmelnytskyi Bazar. While living in the United States she worked as a manager over La Premier Perfume chain.',
				'In her free time Chucherilova enjoys spending time with her son, Andrew, and husband, Luis. She also enjoys zoomba, and spending time with friends.',
			],
		},
		{
			name: 'Charles Collins',
			title: 'Diamond Expert',
			picture: 'charlie.jpg',
			email: 'CharlesC@DiamondsDirect.com',
			phone: '',
			bio: [
				'Charles Collins, Diamond Expert, has been with Diamonds Direct since 2008. He has a Bachelor\'s Degree in Business from The University of Alabama.',
				'Collins has been in the diamond and jewelry industry for fourteen years. Previously, Collins served as an Assistant Loose Diamond broker and Special Events Representative for Universal Pacific of New York. During that time, he was in charge of the Gulf Coast market, the Mid West market and the Pacific market. Collins also served at Service Merchandise in Brentwood, Tennessee for four years as a Special Events Representative and as an Assistant Buyer of loose Diamonds.',
				'In his free time, Collins likes to cook, play PS3 and spend time with his wife and family.',
			],
		},
		{
			name: 'Emily Lobdell',
			title: 'Diamond Expert',
			picture: 'emily_gray.jpg',
			email: 'EmilyL@DiamondsDirect.com',
			phone: '',
			bio: [
				'Emily Lobdell joined the Diamonds Direct team as a Diamond Expert in 2015. She has a Bachelor\'s Degree in Marketing from Union University in Jackson, Tennessee. Emily has over ten years of experience in the jewelry industry and has previously worked as a buyer and inventory manager for an independent jewelry company. Emily is certified by the Diamond Council of America. In her free time, she enjoys cooking, traveling, and spending time with her husband and cocker spaniel.',
			],
		},
		{
			name: 'Gerald Matherly',
			title: 'Diamond Expert',
			picture: 'gerald_matherly.jpg',
			email: 'GeraldM@DiamondsDirect.com',
			phone: '',
			bio: [
				'Gerald Matherly, Diamond Expert, joined the Diamonds Direct team in 2013. He has a Bachelor\'s Degree in International Studies from Auburn University in Montgomery. Matherly has been in the jewelry industry for over 20 years starting his career at Lorch Diamond Center in Birmingham, AL. He then worked for Brombergs for 13 years. He has also worked for Bailey Banks and Biddle, Kay\'s, and Helzbergs.',
				'In his free time Matherly spends time with his daughter, Katlin Rose, he also enjoys reading & cooking.',
			],
		},
		{
			name: 'Kimberly Powell',
			title: 'Diamond Expert',
			picture: 'kimberly.jpg',
			email: 'KimberlyP@DiamondsDirect.com',
			phone: '',
			bio: [
				'Kimberly Powell, Diamond Expert, has been with Diamonds Direct since 2010. She has a Bachelor\'s Degree in Business Administration from the University of Montevallo. Powell is certified by the Diamond Council of America.',
				'Previously, Powell was the top Elite Diamond Consultant at Zales Jewelers in Birmingham.',
				'Powell has lived in Maylene for five years with her husband and dog. In her free time, Powell enjoys fishing with her husband on their boat, traveling to new places, and exploring the outdoors.',
			],
		},
		{
			name: 'Ashley Nolen',
			title: 'Diamond Expert',
			picture: 'ashley-n.jpg',
			email: 'AshleyN@diamondsdirect.com',
			phone: '',
			bio: [
				'Ashley Nolen joined the Diamonds Direct team in spring of 2017. She is a GIA Accredited Jewelry Professional and has her Diamonds and Diamond Grading certificate through GIA.',
				'Nolen has been in the jewelry industry for over 12 years. She grew up in her parent\'s jewelry stores in Indiana and is the last of 7 children to still be in the business.',
				'In her free time she likes to read, cook, travel, and spend time outdoors.',
			],
		},
		{
			name: 'Yolande Louw',
			title: 'Diamond Expert',
			picture: 'yolande1.jpg',
			email: 'yolandel@diamondsdirect.com',
			phone: '',
			bio: [				
				'Born and raised in South Africa, Yolande started in sales at age 16, mined her first diamond age 17 and then fell in love with the diamond industry. Later, Yolande completed a Bachelor’s degree in Jewelry Design and Manufacture and an advanced CAD design course. She then started her own jewelry manufacturing and design company in South Africa focusing on custom jewelry. Yolande is very passionate about jewelry and her work has been exhibited in London, Las Vegas and other African countries. She is an adventurer at heart and in her spare time she loves the outdoors, traveling, socializing, hiking, art and painting.',
			],
		},
		{
			name: 'Dee Carvalho',
			title: 'Diamond Expert',
			picture: 'dee-c.jpg',
			email: 'dee@diamondsdirect.com',
			phone: '',
			bio: [				
				'Dee Carvalho joined the Diamonds Direct team in 2017.  She is from Rio de Janeiro, Brazil.  Carvalho graduated in Physical Education from UAB. She also lived in the Middle East for sixteen years where she worked in various different jewelry exhibitions before moving back to Birmingham.',
				'Carvalho enjoys spending time at the beach with her husband and exercising.',
			],
		},
		{
			name: 'Lisa Franklin',
			title: 'Sales Consultant',
			picture: 'lisa-franklin.jpg',
			email: 'lisaf@diamondsdirect.com',
			phone: '',
			bio: [				
				'Lisa Franklin joined the Diamonds Direct team in September 2014. She grew up in Mobile, AL and moved to Birmingham four years ago with her husband of 35 years. Franklin has been in the jewelry business for 7 years.',
				'In her spare time, she enjoys interior design and spending time with her granddaughter.',
			],
		},
		{
			name: 'Jason Manstream',
			title: 'Jeweler',
			picture: 'jason.jpg',
			email: 'Jason@DiamondsDirect.com',
			phone: '',
			bio: [
				'Jason Manstream has worked as a jeweler for over 20 years, and joined the Diamonds Direct team in Birmingham in 2012. Originally from New York, Manstream moved to Birmingham in 2011 with his wife and 4 kids.',
			],
		},
		{
			name: 'Tim Price',
			title: 'Jeweler',
			picture: 'tim-price.jpg',
			email: 'tim@diamondsdirect.com',
			phone: '',
			bio: [				
				'Tim Price joined the Diamonds Direct family in 2017.  He has been creating and repairing jewelry for almost 35 years.',
				'Originally from New Jersey, Price lived most of his life in Florida and moved to Birmingham with his wife and children in 2009. He has an affinity for "pop culture" and as a former Disc Jockey, a love for many types of music. He also has a dog named "Diamond," (he says he didn\'t name her).',
			],
		},
	],
	sponsorships: [
		{
			name: 'Birmingham Barons',
			image: 'barons.jpg',
		},
		{
			name: 'Auburn Tigers',
			image: 'ua.jpg',
		},
		{
			name: 'Alabama Crimson Tide',
			image: 'bama.jpg',
		},
	],
	awards: [
		{
			name: 'Best of Birmingham',
			image: 'bestof.png',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/3oybuNY',
		googleWrite: 'https://bit.ly/3oybuNY',
	},
};

const BOC = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Boca Raton',
	title: 'Diamonds Direct Boca Raton - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Boca Raton Location Today!',
	shortName: 'Boca Raton',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Boca Raton to shop our latest arrivals and exclusive selection of diamond and fine jewelry. Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectbocaraton',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	video: 'https://player.vimeo.com/video/528920910?badge=0&autopause=0&player_id=0&app_id=58479',
	address: {
		line1: '21078 St. Andrews Blvd',
		line2: 'Boca Raton, Florida 33433',
	},
	googleMapsLink: 'https://www.google.com/maps/dir//21078+St+Andrews+Blvd,+Boca+Raton,+FL+33433/@26.3642086,-80.1388102,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x88d91e78d7629795:0x7ba1f1317c20bdca!2m2!1d-80.1366215!2d26.3642038!3e0',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '5614142091',
	email: 'infoBoca@diamondsdirect.com',
	team: [
		{
			name: 'Dovy Klarberg',
			title: 'Partner | President South',
			picture: 'dovyk.jpg',
			email: 'Dovy@DiamondsDirect.com',
			phone: '',
			bio: [
				'Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design.',
				'After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.',
				'During Dovy\'s time with Diamonds Direct SouthPark, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.',
				'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts within Charlotte, NC. He is also focused on making Diamonds Direct SouthPark\'s brand more ingrained in the local community.',
				'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.',
			],
		},
		{
			name: 'Ayelet Gilady',
			title: 'Vice President',
			picture: 'ayelet.jpg',
			email: 'ayelet@DiamondsDirect.com',
			phone: '',
			bio: [
				'Ayelet Gilady, Vice President, joined Diamonds Direct in 2015. Prior to joining the Diamonds Direct family, Gilady worked in the Israeli Diamond Exchange where she received her education as a Graduate Gemologist. She made the move to Charleston in 2015 where she opened and led that location for five years.',
				'Although Gilady’s current focus is the diamond industry, her professional life began in advertising and business development working for over a decade with the most well established agencies in Israel. This elevated her to the role of CEO and co-owner of her own agency in Tel Aviv. Her aptitude for contracts led her to law school, where she fell in love with commercial and tort law. Gilady is a member of the Israeli Bar Association and was a practicing attorney for two years.',
				'Gilady brings a variety of experience to Diamonds Direct- she loves working with people and has a great appreciation for the details required to make the Diamonds Direct brand experience personal and impactful.',
				'Gilady also has an enthusiasm for philanthropy and a passion for the advancement of medical research in pediatric cancers as well as The Leukemia & Lymphoma Society and Susan G. Komen.',
				'In her free time, Gilady enjoys spending time with her husband and two sons, trying new restaurants and reading. She loves the South Florida sunshine, culture and world renowned beaches.',
			],
		},
		{
			name: 'Arne Espling',
			title: 'Master Jeweler/Service Manager',
			picture: 'arne.jpg',
			email: 'arnee@diamondsdirect.com',
			phone: '',
			bio: [
				'Arne Espling has been with Diamonds Direct since early 2017.',
				'Arne has completed several GIA courses, including ones focused on diamonds, diamond grading and colored stones. Arne is a second generation jeweler with over 30 years experience as a jeweler. He is skilled in many areas of fine jewelry including production, fabrication, casting, repair, advanced stone setting, appraisals and gem identification. Previously, Arne has owned and operated multiple independent jewelry stores in Jacksonville, Florida.',
				'In his free time, Arne enjoys listening to live music,visiting art museums, collecting vinyl albums and spending time with his family.',
			],
		},
		{
			name: 'Lennice Padilla',
			title: 'Diamond Expert',
			picture: 'lennice.jpg',
			email: 'lennicep@diamondsdirect.com',
			phone: '',
			bio: [
				'Lennice Padilla has been in the jewelry industry for over 15 years and recently joined Diamonds Direct in March of 2020.',
				'What she enjoys most about being in the industry is having the opportunity to build lasting relationships with each of her guests and being part of so many special occasions.',
				'When Lennince is not working, she enjoys time with family and friends and never skips a Sunday beach day!',
			],
		},
		{
			name: 'Ryan Smith',
			title: 'Diamond Expert',
			picture: 'ryan.jpg',
			email: 'ryans@diamondsdirect.com',
			phone: '',
			bio: [
				'Ryan Smith has been in the jewelry industry for over 18 years. Smith is a GIA Diamond Graduate.',
				'What he enjoys most about being in the industry is being part of an important milestone in their life.',
				'Outside of work he tries to spend as much time at the beach as possible and enjoy the paradise of living in South Florida.',
			],
		},
		{
			name: 'Elyse Forte',
			title: 'Diamond Expert',
			picture: 'elyse.jpg',
			email: 'elysef@diamondsdirect.com',
			phone: '',
			bio: [],
		},
	],
	sponsorships: [],
	awards: [],
	reviews: {
		googleRead: 'https://bit.ly/3ir46jF',
		googleWrite: 'https://bit.ly/3ir46jF',
	},
};

const CHS = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Charleston',
	title: 'Diamonds Direct Charleston - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Charleston Location Today!',
	shortName: 'Charleston',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Our Charleston showroom is actually located in the beautiful Mount Pleasant Towne Centre on Highway 17 North. We’re here to help tell your Lowcountry love stories, finish off your perfect Fashion Week look and pick the everyday piece for a stroll by the water. Just a quick trip over the Cooper River to find the diamond selection of your dreams.',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectcharleston',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '1911 Highway 17N',
		line2: 'Mt. Pleasant, SC 29464',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Charleston/@32.8322685,-79.8291257,17z/data=!3m1!4b1!4m5!3m4!1s0x88fe721d343de60d:0xca14486e34f940c1!8m2!3d32.832264!4d-79.826937',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '8436062558',
	email: 'infoCHS@diamondsdirect.com',
	team: [
		{
			name: 'Dovy Klarberg',
			title: 'Partner | President South',
			picture: 'dovy.jpg',
			email: 'dovy@diamondsdirect.com',
			phone: '',
			bio: [
				'Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design.',
				'After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.',
				'During Dovy\'s time with Diamonds Direct SouthPark, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.',
				'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts within Charlotte, NC. He is also focused on making Diamonds Direct SouthPark\'s brand more ingrained in the local community.',
				'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.',
			],
		},
		// {
		// 	name: 'Ayelet Gilady',
		// 	title: 'General Manager',
		// 	picture: 'ayelet_gilady.jpg',
		// 	email: 'ayelet@DiamondsDirect.com',
		// 	phone: '',
		// 	bio: [
		// 		'Ayelet Gilady, General Manager, joined Diamonds Direct in 2015. Before making the move to Charleston, she worked for Diamonds Direct\'s marketing and merchandising team in the Israeli Diamond Exchange in Tel Aviv, Israel. It was there that Gilady received her education as a Graduate Gemologist.',
		// 		'Before working in the diamond industry, Gilady worked for over a decade in advertising and business development in the most well established advertising agencies in Israel. This elevated her to the role to CEO and co-owner of her own agency in Tel Aviv. It was during this time Gilady became curious about the law, as she was working with contracts daily. She then turned her focus to law school, where she fell in love with commercial and Tort law. Gilady is member of the Israeli Bar Association and was a practicing attorney for two years.',
		// 		'Gilady brings a variety of experience to Diamonds Direct- she loves working with people and bringing the details together to solve a challenge. Gilady also plans to become active in the philanthropic community in Charleston, specifically women’s and children\'s organizations.',
		// 		'In her free time, Gilady enjoys spending time with her husband and two children, sightseeing in historic Charleston. The entire Gilady family has fallen in love with Charleston. She also loves reading and exploring the culinary scene in Charleston with her husband.',
		// 	],
		// },
		{
			name: 'Lynn Tu',
			title: 'Vice President, Charleston',
			picture: 'LynnTu.jpg',
			email: 'lynnt@diamondsdirect.com',
			phone: '',
			bio: [
				'Lynn Tu has been with Diamonds Direct since 2015. She has a Bachelor’s Degree in Marketing from Suffolk University. Tu is also a Diamond Graduate from the Gemological Institute of America (GIA).',
				'Tu has over 20+ years of experience in sales and management roles within the diamond and jewelry industry. Before making the move to Charleston, Tu worked in the original Diamonds Direct location in Charlotte, North Carolina where she was a Diamond Expert for four years. Tu brings a variety of experience to the Vice President role and is looking forward to settling into life in the Lowcountry.',
				'In her free time, Tu enjoys reading, practicing yoga and traveling.',
			],
		},
		{
			name: 'David Alexander',
			title: 'General Manager',
			picture: 'david.jpg',
			email: 'Davida@diamondsdirect.com',
			phone: '',
			bio: [
				'David Alexander has been with Diamonds Direct since 2016. He has an Associate’s Degree in Science and an Associate’s Degree in Arts. He is also certified by the Diamond Council of America.',
				'Alexander has over 6 years in the diamond and jewelry industry. Previously, he was a manager for Signet. Prior to starting his career in jewelry, Alexander was a demolition superintendent.',
				'In his free time, Alexander enjoys exercising and hanging out with his three kids.',
			],
		},
		{
			name: 'Ginny Kidd',
			title: 'Diamond Expert',
			picture: 'sept28/Ginny.jpg',
			email: 'ginny@diamondsdirect.com',
			phone: '',
			bio: [
				'Ginny Kidd has been with Diamonds Direct since 2008. She began in the Raleigh location and transferred to the Charleston location for its opening in 2016. She has a Bachelor of Arts degree in Communications from North Carolina State University, where she graduated Magna Cum Laude.',
				'Kidd has worn many hats at Diamonds Direct, including customer service, recruiting, and marketing. Previously she was the Marketing Director for a holistic healthcare practice and a Sales Executive for a software company.',
				'In her free time, she enjoys trying out new restaurants in Charleston, having cookouts with friends, watching sports, and spending time with her husband and daughter.',
			],
		},
		{
			name: 'Linsay Peninger',
			title: 'Diamond Expert',
			picture: 'linsay.jpg',
			email: 'Linsayp@diamondsdirect.com',
			phone: '',
			bio: [
				'Linsay Peninger has been with Diamonds Direct since 2007. She has a Graduate Diamonds Degree from the Gemological Institute of America (GIA) and has also completed the colored stones course.',
				'Peninger has over 20 years in the diamond and jewelry industry. Previously, she managed a local jewelry and watch repair shop and also worked in management for Signet Incorporated.',
				'In her free time, Peninger enjoys spending time with her friends, going to the beach, and fishing! She also has a rare hybrid Bengal cat named Reggie!',
			],
		},
		{
			name: 'Kim Patterson',
			title: 'Diamond Expert',
			picture: 'sept28/Kim.jpg',
			email: 'Kimp@diamondsdirect.com',
			phone: '',
			bio: [
				'Kim Patterson has been with Diamonds Direct since March 2017. She has been in the jewelry for over 6 years.',
				'Patterson previously worked for Kay Jewelers. Her favorite thing about the jewelry business is being able to work with guests during one of the most intimate purchases of their life.',
				'In her free time, Patterson enjoys horseback riding, camping and spending time with my family and good friends.',
			],
		},
		{
			name: 'Bo Cochran',
			title: 'Diamond Expert',
			picture: 'oct27/bo.jpg',
			email: 'boc@diamondsdirect.com',
			phone: '',
			bio: [
				'Bo Cochran has been with Diamonds Direct since August 2019. Cochran was a professional golfer and instructor for over 25 years with different cruise lines. Where he then started his career in the diamond industry. On his free time he enjoys golfing, hanging out at the beach, and spending time with his son and wife.',
			],
		},
		{
			name: 'Doug Brown',
			title: 'Diamond Expert',
			picture: 'sept28/Doug.jpg',
			email: 'DougB@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Pat Reilly',
			title: 'Diamond Expert',
			picture: 'sept28/Pat.jpg',
			email: 'PatR@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Cindy Musser',
			title: 'Back Office Manager',
			picture: 'cindy.jpg',
			email: 'cindym@diamondsdirect.com',
			phone: '',
			bio: [
				'Cindy Musser has been with Diamonds Direct since 2015.',
				'Musser previously worked as a bridal manager at Bridal House of Charleston where she helped brides select the perfect wedding gown and accessories for their big day.',
				'In her free time, she enjoys reading, cooking for her coworkers, and spending time with friends.',
			],
		},
		{
			name: 'Margaret Baker',
			title: 'Front Office Support',
			picture: 'sept28/Margaret.jpg',
			email: '',
			phone: '',
			bio: [],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://bit.ly/3a25W5S',
		googleWrite: 'https://bit.ly/3a25W5S',
	}
};

const CLE = {
	template: 'store',
	currentPromo: false,
	title: 'Diamonds Direct Cleveland - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Cleveland Location Today!',
	name: 'Diamonds Direct Cleveland',
	shortName: 'Cleveland',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Cleveland to shop our latest arrivals and exclusive selection of diamond and fine jewelry.',
		'Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectcleveland',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '2101 Richmond Rd.',
		line2: 'Beachwood, OH 44122',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Cleveland/@41.5006489,-81.498218,17z/data=!3m1!4b1!4m5!3m4!1s0x88310359022d7241:0x50393c6f790adefe!8m2!3d41.5006449!4d-81.4960293',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '2162732812',
	email: 'infoCLE@diamondsdirect.com',
	team: [
		{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: [
				'Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.',
				'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.',
				'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.',
				'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.',
				'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.',
			],
		},
		{
			name: 'Tery Vari',
			title: 'Vice President, OH',
			picture: 'tery.jpg',
			email: 'TeryV@DiamondsDirect.com',
			phone: '',
			bio: [
				'Tery Vari, Vice President, has been with Diamonds Direct since 2011. He received his Bachelors of Science in Marketing from Ohio State University.',
				'Vari has been in the diamond and jewelry industry for over 20 years. Previously, he was the General Manager for Jared, the Galleria of Jewelry and the District Manager for Reeds Jewelers.',
				'In his free time, Vari enjoys spending time with his wife and two sons and is active in the community.',
			],
		},
		{
			name: 'Steve Smith',
			title: 'General Manager',
			picture: 'oct7/STEVE.jpg',
			email: 'steves@diamondsdirect.com',
			phone: '',
			bio: [
				'Steve Smith, General Manager, has been with Diamonds Direct since 2012. Smith attended Winthrop University in Rock Hill, SC where he studied Business Administration.',
				'Smith has been in the diamond and jewelry industry for 13 years. Previously, he held positions as both Store Manager and Vice President with jewelers in Richmond.',
				'In his free time, Smith enjoys spending time with his son Josh, road trips to the beach and working in his yard.',
			],
		},
		{
			name: 'Derek Caron',
			title: 'Store Manager',
			picture: 'oct7/DEREK.jpg',
			email: 'derekc@diamondsdirect.com',
			phone: '',
			bio: [
				'Derek Caron, store manager, joined Diamonds Direct in September of 2017. He started with us in his home town of Virginia Beach, Virginia. Derek was excited to hear that we would be opening our 16th location in Cleveland. He has always loved the Cleveland area and is excited to share his experience and expertise with his new clients at our Beachwood Ohio Showroom.Derek has over 19 years of experience in the jewelry industry. He has completed both the certified gemologist and diamontologist courses with the Diamond Council of America. He attended the Gemological Institute of America and received accreditation as an Accredited Jewelry Professional and also completed the diamond grading laboratory class.Derek is also a musician and loves to find time to relax playing piano or violin. He has two children and loves rooting for Cleveland sports, especially the Cleveland Browns. “Here we go Brownies, here we go! Woof, woof!',
			],
		},
		{
			name: 'Craig Benson',
			title: 'Diamond Expert',
			picture: 'oct7/CRAIG.jpg',
			email: 'craigb@diamondsdirect.com',
			phone: '',
			bio: [
				'Craig has known fine jewelry for his entire life - he ran his family-owned jewelry store in Mentor for the last 30 years. Because Craig has grown up in this business, he is naturally passionate about all aspects of gemology and finding the perfect piece for his clients. He is active in his community, loves playing 18 holes of golf, beach getaways and spending time with his adorable grandson.',
			],
		},
		{
			name: 'Don Waddell',
			title: 'Diamond Expert',
			picture: 'oct7/DON.jpg',
			email: 'donw@diamondsdirect.com',
			phone: '',
			bio: [
				'Don joined the Diamonds Direct family in 2019 as a Diamond Expert and has been thriving in the fine jewelry industry for the last 20 years, working his way up at Jared before joining our Cleveland showroom team. He is a born and raised Ohioan and loves all Cleveland sports, the Buckeyes and good local food. Don loves to spend a day on the golf course and also quality  time with his son and daughter.',
			],
		},
		{
			name: 'Deena Novak',
			title: 'Shop Manager',
			picture: 'oct7/DEENA.jpg',
			email: 'deenan@diamondsdirect.com',
			phone: '',
			bio: [
				'Deena Novak joined Diamonds Direct in April of 2019. Deena was born and raised in the Cleveland area, and has been in the jewelry industry since 2014.',
				'Deena graduated from the University of Akron with her Bachelor of Fine Arts focused in metalsmithing. Deena enjoys making art in many different mediums, however hand fabrication of metals is her favorite.',
				'Deena loves to paint, spend time in nature, hike, bike and kayak. Deena spends most of her free time with her husband, Jon and her pit bull, Boomerang.',
			],
		},
		{
			name: 'Amy Bartkowski',
			title: 'Diamond Expert',
			picture: 'oct7/AMY.jpg',
			email: 'amyb@diamondsdirect.com',
			phone: '',
			bio: [
				'Amy is Ohio born and raised and has been in the jewelry industry since 2013. Amy joined us in 2021 and is thrilled to be a Diamond Expert on our Cleveland team! Amy enjoys walking, traveling, cooking and baking in her spare time and is also an avid animal lover. Besides the above, Amy is a Cleveland sports fan with her favorite team being the Browns. Amy has always loved many aspects of fine jewelry sales but her favorite part of her career is being part of special moments for guests.'
			],
		},
		{
			name: 'Jane Bidinger',
			title: 'Back Office Manager',
			picture: 'oct7/JANE.jpg',
			email: 'janeb@diamondsdirect.com',
			phone: '',
			bio: [
				'Jane joined the Diamonds Direct family in 2020. She has many years experience in fine jewelry, office, and inventory management. Customer service is one of her top priorities. She attended Louisville School of Art in Louisville, Kentucky where she studied English Composition, Photography and Design. She is an avid photographer and enjoys teaching her skills to new enthusiasts. She, her husband Rich, and their three dogs can be found out on the boat, going to the beach and spending time with family.'
			],
		},
		{
			name: 'Morgan Sanders',
			title: 'Receptionist',
			picture: 'oct7/MORGAN.jpg',
			email: 'clereception@diamondsdirect.com',
			phone: '',
			bio: [
				'Morgan joined our reception team at the Cleveland DD location in 2021. She has experience from Ashcroft and Oak and has used that great experience to become a staple to our team in customer service! While Morgan is a Cleveland native-born and raised, it is a goal of hers to relocate from Cleveland to warmer climates. When she is not greeting and helping our customers, she is studying! Currently, Morgan is enrolled as a Psychology major at Ohio University obtaining a Bachelor’s of Science, and is expecting to graduate in 2022. In between her work and school priorities, Morgan enjoys creating art, working out, relaxing, and shopping.'
			],
		},
		{
			name: 'Amber Hollinger',
			title: '',
			picture: 'Amber.jpg',
			email: '',
			phone: '',
			bio: [
				'Amber joined the Diamonds Direct family in 2021, and came by way of the hospitality industry out of Youngstown, Ohio. She holds a degree in hospitality management with a minor in business management from Youngstown State University. Amber has found excitement in learning more about the fine jewelry industry alongside her manager, Jane, who she has thoroughly enjoyed learning from.  On the weekends, you can find Amber spending quality time with her husband, Steven and their black, 12-year old Pitbull named Henry.'
			],
		},
		{
			name: 'Nick Arndt',
			title: 'Jeweler',
			picture: 'Nick.jpg',
			email: '',
			phone: '',
			bio: [
				'Nick joined the talented Diamonds Direct team in 2021 and so far a highlight of working in the Shop has been getting the opportunity to use what he’s learned over the years to bring quality work to customers, and also setting incredible diamonds! Prior to his jewelry artistry training, he was studying to become a paramedic, but sought a more creative career path.  In his spare time, Nick likes to spend time enjoying life with friends, going to concerts, playing games, and cheering on the Ohio State Buckeyes and the Cleveland Browns.'
			],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://bit.ly/3uw57Mc',
		googleWrite: 'https://bit.ly/3uw57Mc',
	}
};

const CLT = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Charlotte',
	title: 'Diamonds Direct Charlotte - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Charlotte Location Today!',
	shortName: 'Charlotte',
	runningPromo: false,
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Our flagship location in SouthPark, across from the Cheesecake Factory, is a hidden gem (pun intended!) nestled on the first floor of the Porter Building. These Panther-loving diamond experts are excited to help you find the ring of your dreams, just one of the reasons we\'re one of Charlotte Magazine’s Best of the Best.',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectsouthpark',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '4521 Sharon Road',
		line2: 'Charlotte, NC 28211',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Southpark/@35.1509199,-80.8307646,17z/data=!3m1!4b1!4m5!3m4!1s0x88569e15bb419ee5:0x907d95865d83ce9!8m2!3d35.1509155!4d-80.8285759',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '7045329041',
	email: 'infoCLT@diamondsdirect.com',
	team: [
		{
			name: 'Dovy Klarberg',
			title: 'Partner | President South',
			picture: 'apr21/DovyKlarberg.jpg',
			email: 'Dovy@DiamondsDirect.com',
			phone: '',
			bio: [
				'Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design.',
				'After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.',
				'During Dovy\'s time with Diamonds Direct SouthPark, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.',
				'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts within Charlotte, NC. He is also focused on making Diamonds Direct SouthPark\'s brand more ingrained in the local community.',
				'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.',
			],
		},
		{
			name: 'Mark Czarnecki',
			title: 'Vice President, Charlotte',
			picture: 'apr21/MarkCzarnecki.jpg',
			email: 'MarkC@DiamondsDirect.com',
			phone: '',
			bio: [
				'Mark Czarnecki, Vice President, Charlotte has been with Diamonds Direct since 2006. Mark has a certification from the Gemological Institute of America (GIA) and has also completed a Registered Jewelers course through the American Gemological Society (AGS).',
				'Mark has 28 years of experience in the jewelry industry. He has worked with many other fine jewelers such as Mayors Jewelers in Florida, Columbian Emeralds in St. Thomas, Virgin Islands, and has also worked for White Hall Jewelers as a multi-store supervisor.',
				'Mark was born and raised in Green Bay, Wisconsin. He has lived in many places before settling down in Charlotte such as Tampa Florida, Orlando Florida, and St. Thomas, In his free time, he enjoys cheering on the Green Bay Packers, spending time with his wife and three kids and fishing.',
			],
		},
		{
			name: 'Eyal Boaron',
			title: 'Store Manager',
			picture: 'apr21/EyalBoaron.jpg',
			email: 'eyal@diamondsdirect.com',
			phone: '',
			bio: [
				'Eyal Boaron has worked in the diamond and jewelry industry since 2011. Before joining the Diamonds Direct team, Eyal worked in the industry in the Caribbean for four years. In addition to working in the Charlotte store, Eyal has also worked in our Jacksonville and Salt Lake City locations.',
				'Eyal served in the Israeli military for three years, which taught him ethics and the true meaning of hard work. He’s taken lessons from his time in the military and applied that to his daily life.',
				'In Eyal\'s free time, he enjoys outdoor activities, working out and training to be a future American Ninja Warrior!',
			],
		},
		{
			name: 'Kim Tu-Chau',
			title: 'Diamond Expert',
			picture: 'apr21/KimTu-Chau.jpg',
			email: 'KimT@DiamondsDirect.com',
			phone: '',
			bio: [
				'Kim Tu-Chau, Diamond Expert, has been with Diamonds Direct since 2012. She studied Business Management at Suffolk University of Massachusetts.',
				'Tu-Chau has been in the diamond and jewelry industry for over 20 years. Previously, she worked in sales as the Timepiece Manager at Jared, The Galleria of Jewelry.',
				'In her free time, Tu-Chau enjoys traveling, listening to music and watching football with her two sons and her husband.',
			],
		},
		{
			name: 'Dave Lee',
			title: 'Diamantologist (DCA)',
			picture: 'apr21/DaveLee.jpg',
			email: 'DaveL@DiamondsDirect.com',
			phone: '',
			bio: [
				'Dave Lee, Diamantologist  (DCA), has been with Diamonds Direct since 2009. He studied law at Fordham University.',
				'Lee has worked in various levels in the business including owning his own jewelry store in New York, working in sales at Kay\'s Jewelry and managing Jared, the Galleria of Jewelry in Concord, NC. Before entering the diamond industry, Lee worked in Real Estate.',
				'In his free time, Lee enjoys swimming, playing golf and tennis and spending time with his three children.',
			],
		},
		{
			name: 'Asim Baksh',
			title: 'Diamond Expert',
			picture: 'apr21/AsimB.jpg',
			email: 'asim@diamondsdirect.com',
			phone: '',
			bio: [
				'Asim Baksh, Diamond Expert, has been in the luxury jewelry industry for over 14 years. Asim studied Information Technology and Management at the University of the West Indies in Barbados.',
				'Previously, Asim has worked with Tiffany & Company as well as family-owned diamond companies. After six years of traveling and loving the adventure, Asim moved to Charlotte to join the Diamonds Direct family. Asim found his passion in helping customers during one of the most amazing times of their life.',
				'Outside of work, Asim enjoys spending time with his wife, going to amazing restaurants, traveling, reading, meeting new friends, running and swimming.',
			],
		},
		{
			name: 'Evan Johnson',
			title: 'Diamond Expert',
			picture: 'apr21/EvanJohnson.jpg',
			email: 'evanj@diamondsdirect.com',
			phone: '',
			bio: [
				'Evan Johnson is a bright presence and is always passionate about helping others. Although born and raised in Colorado, he has called Charlotte home for the past ten years.',
				'Evan found his home amongst the team shortly after he had his own Diamonds Direct experience. Bringing with him a decade of high-performance customer care and sales experience, he now spends his days with clients helping them pick the ring of their dreams.',
				'He enjoys spending his free time with his wife and puppy, primarily watching movies, working out at the gym or trying new foods.',
			],
		},
		{
			name: 'Lana Hale',
			title: 'Diamond Expert',
			picture: 'apr21/LanaHale.jpg',
			email: 'lanah@diamondsdirect.com',
			phone: '',
			bio: [
				'Lana received a Bachelor\'s Degree in Business Management from the University of Rhode Island and is a GIA Accredited Jewelry Professional. Lana was a retail manager for 10 years and has found a true passion in selling diamonds, elevating the customer experience and developing long-term customer relationships.',
				'Lana was raised in Philadelphia and when her family moved down to Florida, she joined them after graduating from college. Lana and her husband met working at jewelry stores next to each other in Miami. They decided to buy a home in Charlotte where they could plant roots and start a family.',
				'In her free time, Lana loves to box and practice yoga, run marathons, travel and relax at home with their three animals.',
			],
		},
		{
			name: 'Christy Hill',
			title: 'Diamond Expert',
			picture: 'apr21/ChristyHill.jpg',
			email: 'christyh@diamondsdirect.com',
			phone: '',
			bio: [
				'Christy Hill, Diamond Expert has been with Diamonds Direct since 2014. She studied interior design at The Art Institute of Charlotte. Christy is a certified graduate with The Diamond Council of America.',
				'Christy has been in the diamond and jewelry industry for over 10 years. Previously, she was in management at Jared The Galleria of Jewelry. Christy was born and raised in Charlotte, North Carolina. In her free time, she enjoys spending time with her son, daughter, and husband. They enjoy the park, the zoo, and the beach.',
			],
		},
		{
			name: 'Morgan Quatrano',
			title: 'Diamond Expert',
			picture: 'apr21/MorganQuatrano.jpg',
			email: 'morganq@diamondsdirect.com',
			phone: '',
			bio: [
				'Morgan Quatrano has been with Diamonds Direct since 2015. Morgan has 6 years of experience in restaurant management and customer service.',
				'Morgan knew that wasn\'t her true calling and left that business to come to Diamonds Direct where she started out as a receptionist. From there she decided she to move to the sales floor where she could follow her true passion of helping customers find exactly what they were looking for. Making customers dreams come through is the most rewarding thing to Morgan.',
				'As a Charlotte native, Morgan spends her Sundays rooting for the Carolina Panthers. She also spends a lot of time walking her King Charles Cavalier Spaniel, Charlie at Freedom Park. She loves animals and also has a tuxedo cat named, Noel.',
			],
		},
		{
			name: 'Crystal Remsen',
			title: 'Diamond Expert',
			picture: 'apr21/CrystalRemsen.jpg',
			email: 'crystalr@diamondsdirect.com',
			phone: '',
			bio: [
				'Crystal Remsen, Diamond Expert, has been with Diamonds Direct since 2015 and has over 6 years experience in the diamond and Jewelry industry.',
				'Her career path took her through Dental Hygiene, Aviation, and Real Estate, ultimately finding her purpose and falling in love with the diamond and fine jewelry world. While she feels lucky enough to show diamonds and jewelry as a career, she finds greatest happiness being part of such a meaningful and special time in her customer\'s lives. She is truly humbled when a client sends her a picture captioning "She said YES!"',
				'In her free time Crystal has a love for traveling, boating, and spending time with her husband, their two rescue pups, Allie and Daphne, friends and family.',
			],
		},
		{
			name: 'Nancy Seeman',
			title: 'Diamond Expert',
			picture: 'apr21/NancySeeman.jpg',
			email: 'nancys@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Hami Raissi',
			title: 'Diamond Expert',
			picture: 'apr21/HamiRaissi.jpg',
			email: 'hamir@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Patricia Olivera',
			title: 'Diamond Expert',
			picture: 'apr21/PatriciaOlivera.jpg',
			email: 'patriciao@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Sawan Bhargava',
			title: 'Diamond Expert',
			picture: 'apr21/SawanBhargava.jpg',
			email: 'sawanb@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Madison Leopard',
			title: 'Diamond Expert',
			picture: 'apr21/MadisonLeopard.jpg',
			email: 'madisonl@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Beatriz Aguirre',
			title: 'Diamond Expert',
			picture: 'apr21/BeatrizA.jpg',
			email: 'beatriza@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Daniel Turgeon',
			title: 'Timepiece Advisor',
			picture: 'apr21/DanielTurgeon.jpg',
			email: 'danielt@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Diana Zepsa',
			title: 'GIA Diamonds Graduate',
			picture: 'apr21/DianaZepsa.jpg',
			email: 'DianaZ@DiamondsDirect.com',
			phone: '',
			bio: [
				'Diana Zepsa, Diamond Expert, has been with Diamonds Direct since 2004. She has an Associates Degree in Arts from Central Piedmont Community College. She also holds a Graduate Diamonds Degree from the Gemological Institute of America (GIA).',
				'Zepsa worked full-time at Diamonds Direct for six years. She is currently working part-time and is available by appointment only.',
				'In her free time, Zepsa enjoys hiking, camping and traveling with her husband and three sons.',
			],
		},
		{
			name: 'Sureyya Cam',
			title: 'Master Custom Jeweler',
			picture: 'apr21/SureyyaCam.jpg',
			email: '',
			phone: '',
			bio: [
				'Sureyya Cam, Master Jeweler, has been with Diamonds Direct for more than 10 years. Originally from Turkey, Cam studied with a Turkish Master Jeweler starting at the young age of nine.',
				'Cam moved to the United States at the age of 26 to further his career in Tuscaloosa, Alabama where we worked as the Master Jeweler for Benchmark. Shortly after settling in Alabama, Cam moved to Gastonia, North Carolina where he continued to advance his creative design expertise.',
				'With close to 50 years experience in the diamond and jewelry industry, Cam has worked for many notable jewelers in the Charlotte area specializing in repair work and custom jewelry design. Utilizing a CAD-CAM system, Cam is able to help you bring your dream, one of a kind, piece of jewelry to life.',
				'Although Cam spends much of his time designing jewelry, he enjoys spending time with his wife, three daughters, two son-in-laws and five grandchildren in his free time.',
			],
		},
		{
			name: 'Scott Fisher',
			title: 'Jeweler',
			picture: 'apr21/ScottFisher.jpg',
			email: '',
			phone: '',
			bio: [
				'Scott Fisher has been with Diamonds Direct for 10 years. Fisher received an Associate\'s Degree in Jewelry, Watch and Clock Repair from Wayne Community College in North Carolina.',
				'Fisher has been in the diamond and jewelry industry for over 30 years. Previously he worked as a custom jeweler and repair specialist at Huckaby Jewelers in Charlotte.',
				'In his free time, Fisher enjoys spending time with his wife and two daughters, boating and anything outdoors.',
			],
		},
		{
			name: 'Don Glefke',
			title: 'Jeweler',
			picture: 'apr21/DonGlefke.jpg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Lotte Sommer',
			title: 'Diamantologist (DCA)',
			picture: 'lotte.jpg',
			email: 'LotteS@DiamondsDirect.com',
			phone: '',
			bio: [
				'Lotte Sommer, Diamantologist  (DCA), has been with Diamonds Direct since 2011. She has a Bachelor’s Degree in Finance from Hallendorf University in Germany.',
				'Sommer has been in the diamond and jewelry business for nine years. Sommer moved to the US and worked as the Global Supply Chain Manager for Bausch & Lomb until 2002. After retiring, Sommer went back to work, this time in the diamond industry, as a sales associate for Whitehall Jewelry. She also worked in sales at Kays and Jared’s Jewelers.',
				'Sommer has lived in Charlotte for two years and enjoys reading and spending time with her family and grandchildren in her free time.',
			],
		},
	],
	sponsorships: [
		{
			name: 'Carolina Panthers',
			image: 'panthers.jpg',
		},
		{
			name: 'Charlotte Knights',
			image: 'knights.jpg',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/39WE4jF',
		googleWrite: 'https://bit.ly/39WE4jF',
	}
};

const COH = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Columbus',
	title: 'Diamonds Direct Columbus - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Columbus Location Today!',
	shortName: 'Columbus',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'OH, how we love our beautiful Columbus location in Polaris. The newly-renovated showroom houses thousands of styles for you and your love to browse through. Our Diamond Experts are always eager to walk you through the endless styles, diamonds and custom options that our designers have to offer!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectCOL/',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '1330 Polaris Pkwy',
		line2: 'Columbus, OH 43240',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Columbus/@40.1419728,-82.9845588,17z/data=!3m1!4b1!4m5!3m4!1s0x8838f46353500001:0xb3debb7599304027!8m2!3d40.1419687!4d-82.9823701',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '6145160515',
	email: 'infocol@diamondsdirect.com',
	team: [
		{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: [
				'Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.',
				'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.',
				'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.',
				'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.',
				'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.',
			],
		},
		{
			name: 'Tery Vari',
			title: 'Vice President, OH',
			picture: 'tery.jpg',
			email: 'TeryV@DiamondsDirect.com',
			phone: '',
			bio: [
				'Tery Vari, Vice President, has been with Diamonds Direct since 2011. He received his Bachelors of Science in Marketing from Ohio State University.',
				'Vari has been in the diamond and jewelry industry for over 20 years. Previously, he was the General Manager for Jared, the Galleria of Jewelry and the District Manager for Reeds Jewelers.',
				'In his free time, Vari enjoys spending time with his wife and two sons and is active in the community.',
			],
		},
		{
			name: 'Nick Stefano',
			title: 'General Manager',
			picture: 'nick-stefano.jpg',
			email: 'nicks@diamondsdirect.com',
			phone: '',
			bio: [
				'Nick has been with Diamonds Direct since November 2018. He has been in the Jewelry industry for over 13 years and has been in multiple leadership positions throughout Ohio and New Hampshire. Nick has a passion for guest service. He believes that bringing passion and energy to every interaction is tremendously important when building long term relationships personally and professionally.',
			],
		},
		{
			name: 'Kat Hoyt',
			title: 'Marketing Coordinator',
			picture: 'kat_hoyt.jpg',
			email: 'KatH@diamondsdirect.com',
			phone: '',
			bio: [
				'Kat Hoyt has been with Diamonds Direct since 2012.',
				'Hoyt has over a decade of experience in the Customer Service Industry. Previously, Hoyt practiced her managerial skills at Hallmark.',
				'She is mother to four sons and two dogs, Leo and Oscar. In her free time, she enjoys spending time with her husband, Vic, and her family.',
			],
		},
		{
			name: 'Ellen Moretti',
			title: 'Store Manager',
			picture: 'ellen_moretti.jpg',
			email: 'ellenm@diamondsdirect.com',
			phone: '',
			bio: [
				'Ellen has lived in Columbus, OH her whole life and joined Diamond Direct in February of 2018. She attended the Ohio State University majoring in Fashion Design, but decided to pursue a career in Gemology. She is a G.I.A. Graduate Gemologist and has been part of the industry managing small independent and corporate jewelry stores throughout the Columbus area since 1988. Her favorite part about her job is "I get to play people’s fairy godmother and make dreams come true, that they didn’t think were possible."',
			],
		},
		{
			name: 'Aimee Frollini',
			title: 'Diamond Expert',
			picture: 'aimee_frollini.jpg',
			email: 'aimee@diamondsdirect.com',
			phone: '',
			bio: [
				'Aimee Frollini is a diamond expert with over 27 years of diamond and jewelry experience in the industry.She began her career at an independent jeweler in Columbus Ohio, where she earned her Diamonds and Diamond Grading degree through The Gemological Institute of America.',
				'She enjoys cooking and spending time with her husband and two sons.',
			],
		},
		{
			name: 'Mary Davis',
			title: 'Diamond Expert',
			picture: 'mary-davis.jpg',
			email: 'maryd@diamondsdirect.com',
			phone: '',
			bio: [
				'Mary Davis has over 28 years of diamond and jewelry experience. She started her career in 1990 with Signet jewelers Ltd and stayed with them for 25 years managing several stores in the Columbus area. Mary comes with an extensive background in jewelry and a passion for customer service! In her spare time she enjoys gardening, cooking and spending time with family.',
			],
		},
		{
			name: 'Taryn Hensel',
			title: 'Diamond Expert',
			picture: 'taryn.jpg',
			email: 'Tarynh@diamondsdirect.com',
			phone: '',
			bio: [
				'Taryn joined the Diamonds Direct team in September 2019 after spending two years with another major jewelry company. She has an extensive background in customer service and sales. Taryn chose to join the jewelry industry in 2018 as a way to bring together her love for jewelry with her business management degree and customer service experience.',
				'Taryn graduated from Wittenberg University in 2008 with a major in Business Management and minor in Geography. While attending Wittenberg, she took a class in silver jewelry making where her love for the art of jewelry took off. Taryn grew up here in Ohio and loves sports, spending time with her family and friends, outdoor activities, beach vacations, and also has a real estate license she utilizes in her free time.',
			],
		},
		{
			name: 'Robin Condron',
			title: 'Back Office Manager',
			picture: 'robin.jpg',
			email: 'Robins@diamondsdirect.com',
			phone: '',
			bio: [
				'Robin Condron has been with Diamonds Direct since February of 2018. She has over 15 years of customer service experience and loves helping people. She has a diverse background in working with everything from animal husbandry to new brides. She can\'t wait to meet you and hear your story.',
				'In her spare time she loves spending time with her husband Chris and taking her puppy, Snickerdoddle, to the park.',
			],
		},
		{
			name: 'Steve Remias',
			title: 'Diamond Expert',
			picture: 'steve.jpg',
			email: 'StevenR@diamondsdirect.com',
			phone: '',
			bio: [
				'Steve has been with Diamonds Direct since 2021. He has been in the Jewelry industry for over 10 years and brings extensive experience and passion of luxury brands. Steve earned his Diamond and Diamond Grading certification thought the GIA Gemological Institute of America.',
				'Steve is honored to be a part of your special moment and is looking forward to helping you in selecting one of the most special gifts that symbolizes the love you have for one another.',
			],
		},
		{
			name: 'Jackie Adams',
			title: 'Back office support',
			picture: 'Jackie.jpg',
			email: 'Jaclyna@diamondsdirect.com',
			phone: '',
			bio: [
				'Jackie Adams has been with Diamonds Direct since September of 2021. She has a variety of experience in customer service and the hospitality industry. Her passion for providing guest experience has continued to grow at Diamonds Direct.',
				'In her spare time she enjoys spending time with her two cats Cinna and Bon and traveling to Arizona to visit her family.',
			],
		},
		{
			name: 'Cristian Garcia',
			title: 'Shop Manager',
			picture: 'Cristian.jpg',
			email: 'cristian@diamondsdirect.com',
			phone: '',
			bio: [
				'Cristian Garcia was born in the Dominican Republic in 1967. He learned the art of jewelry is 1988 and has been working in the industry ever since. Cristian came to the United States in 2000 and has been with Diamonds Direct since 2018.',
				'In his free time he enjoys spending time with his family, cooking, fishing and traveling.',
			],
		},
		{
			name: 'Ryan Choops',
			title: 'Diamond Expert',
			picture: 'ryan.jpg',
			email: 'Ryanch@diamondsdirect.com',
			phone: '',
			bio: [
				'Ryan has been in jewelry industry for over 14 years in both sales and management capacities. He has achieved his Diamonds and Diamonds Grading degree through the Gemological Institute of America. He enjoys having a customer first approach with the true goal of finding the perfect piece of jewelry for each and every person.',
				'In his off time he enjoys spending as much time with his beautiful wife, wonderful 1 year old son and the two old ladies of the house (dogs). He\'s a huge sports fan and a die hard fan of the one and only Buffalo Bills.',
			],
		},
	],
	sponsorships: [],
	awards: [
		{
			name: 'Best Of Columbus',
			image: 'bestof.png',
		},
		{
			name: 'Best Of Columbus',
			image: 'bob20.png',
		},
		{
			name: 'Best Of Columbus',
			image: 'bob21.jpg',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/3mj23Q0',
		googleWrite: 'https://bit.ly/3mj23Q0',
	}
};

const DFW = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Dallas',
	title: 'Diamonds Direct Dallas - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry & More. Visit Our Dallas Location Today!',
	shortName: 'Dallas',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Be the Star of the show at your next event after shopping with us at our Preston Hollow location. Whether you’re looking for the perfect way to say “I love you” or upgrading your already stunning set, we have the selection to make sure you never wonder if you found the one. Hang out with us long enough and you may see someone from America’s Team!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/DiamondsDirectDTX/',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '8127 Preston Rd.',
		line2: 'Dallas, TX 75225',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Dallas/@32.8619245,-96.8066824,17z/data=!3m1!4b1!4m5!3m4!1s0x864c20dc86a3ba85:0x22e31ce4169e20da!8m2!3d32.86192!4d-96.8044937',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '9723426663',
	email: 'infoDTX@diamondsdirect.com',
	team: [
		{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: [
				'Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.',
				'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.',
				'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.',
				'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.',
			],
		},
		{
			name: 'Yosi Mayer',
			title: 'Vice President, Dallas',
			picture: 'yosi_mayer.jpg',
			email: 'yosi@diamondsdirect.com',
			phone: '',
			bio: [
				'Yosi Mayer, Vice President, joined the Diamonds Direct family in 2016.',
				'Born in Israel, Mayer served in the Israeli Military for three years in the Paratroopers Brigade. For the past 16 years Mayer has worked in the diamond and jewelry industry all over the world with experience ranging from wholesale to retail.',
				'Mayer\'s career in the industry began in 2000, in retail sales for a major jewelry chain in Mexico and the Caribbean. From there, he worked his way up the ladder to manage several stores in a General Manager capacity. In 2008 Mayer decided it was time to move back to Israel, where he continued to work in the industry only this time as a Sales Manager and Buyer for leading wholesale firms at the Israeli Diamond Exchange.',
				'In 2016 Mayer met Itay Berger – President of Diamonds Direct and understood that joining the company would allow him to keep pursuing his passion for exceptional customer service, team leading and business development. For that reason, he made the decision to move his family to Dallas.',
				'Mayer is married to his high-school sweetheart Liz. They have two lovely daughters and a dog. He enjoys spending time with his family while exploring Dallas and the surrounding areas. He takes interest in learning different cultures and languages and is a self proclaimed foodie, always chasing the next great meal.',
			],
		},
		{
			name: 'Chen Glikman',
			title: 'Vice President',
			picture: 'Dallas_Chen.png',
			email: 'chen@diamondsdirect.com',
			phone: '',
			bio: [
				'Chen Glikman, Vice President, has been with Diamonds Direct since 2016. He attended The Open University in Israel where he studied Communication and Psychology. Previously, Chen was the owner and operator of an event production company in South Florida.',
				'Born in Beer Sheva, Israel, Chen joined The Israeli Defense Forces in 2003, where he served for three years as a parachuter. After completing his army service, Chen worked in sales in four different European countries and South Africa for three years. In Israel, he managed an advanced communication company while also working for a boutique event production in Tel Aviv.',
				'In 2014, he made his way to the United States where he opened his own events company, bringing and perfecting customer service to the people of South Florida. After discovering this passion, Chen joined the Diamonds Direct team in 2016, becoming a great addition with his sales and service background. He completed his Diamond Training in Diamonds Direct’s cutting facilities in Ramat Gan, Israel.',
				'After managing the Virginia Beach store for four years, he was given the opportunity to bring his talents to Dallas and grow the Diamonds Direct family. Chen greatly looks forward to this new journey with his family and they are excited to call Dallas home.',
				'In his free time Chen likes to spend time outdoors with his family and work with musicians.',
			],
		},
		{
			name: 'Matthew Cadwell',
			title: 'General Manager',
			picture: 'Dallas_Matthew.png',
			email: 'mattcadwell@diamondsdirect.com',
			phone: '',
			bio: [
				'Matthew Cadwell, General Manager, joined Diamonds Direct in July of 2021. As a native Californian, Matthew developed a love of the outdoors and finds beauty in many natural elements. While going to school for Political Science he started working in the industry and never left! In 2015 Matthew moved to Texas with his wife and 2 daughters. He often says that although he wasn\'t born in Texas, he got here as soon as he could and now feels this is home.',
				'In 1997, Matthew began his career in sales with Nordstrom and quickly fell in love with the retail industry, after learning to tailor his personal approach with customers. This passion led him to a career in fine jewelry where he has happily remained to this day.',
				'When given the opportunity to lead the Diamonds Direct Dallas team, Matthew was thrilled to join such an esteemed group. Matthew compares Diamonds Direct culture  to "a breath of fresh air" in that every team member has the same, top priority no matter the day - each guest and their experience being second to none.',
				'Matthew prides himself in his ability to mentor and enable growth for those with the desire. He enjoys team building and recognizing each individual for their own strengths that allow our team to run as a well-oiled machine. Matthew is also a Diamond Council of America Graduate.',
				'Outside of work, Matthew spends his time enjoying the great outdoors and even had the pleasure of being a rock climbing instructor for Joshua Tree National Park where he literally held people off the edge of a cliff! "It\'s amazing what you discover about people when you get to do that," Matthew explains. When he\'s not busy chasing his next great adventure, Matthew loves spending quality time with his wife, Monique and two daughters.',
			],
		},
		{
			name: 'Greg Keaton',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'greg_keaton.jpg',
			email: 'GregK@diamondsdirect.com',
			phone: '',
			bio: [
				'Greg Keaton is a Diamond Council of America graduate and has worked in the jewelry industry for more than 30 years in several capacities across the United States, Canada, the Caribbean, and the Pacific Rim. During this time, he has gained experience in operations, high-end Swiss watch brand management, sales management, and advertising and marketing on a national scale.',
				'Keaton grew up in Colorado before he played football and studied Psychology at Southwest Baptist University in Missouri. Keaton moved to Texas, in 1994, and has been with Diamonds Direct since the day they opened in Dallas. In his free time, Keaton enjoys traveling, music, playing golf, sporting events, spending time with his family, his 75lb rescue dog, and anything outdoors.',
			],
		},
		{
			name: 'Justin Lehn',
			title: 'Diamond Expert',
			picture: 'Dallas_Justin2.png',
			email: 'JustinL@diamondsdirect.com',
			phone: '',
			bio: [
				'As a graduate from the University of North Texas, Justin Lehn is a true, native Dallasite!',
				'Lehn has years of jewelry experience stemming from his time in diamond buying and management for a large jewelry store chain. Most recently, Lehn played a dual role as Director of Timepieces and Diamond Specialist for Diamond Doctor, making his transition to Diamonds Direct very smooth.',
				'In his free time, Lehn’s guilty pleasure is watching Gordon Ramsey\'s televisions shows. He\'s also an avid Dallas Cowboys fan (of course!) and is proud that Diamonds Direct is the official jeweler of the Dallas Cowboys!',
			],
		},
		{
			name: 'Graham Silberman',
			title: 'Diamond Expert',
			picture: 'jan17/Dallas_Graham.png',
			email: 'GrahamS@diamondsdirect.com',
			phone: '',
			bio: [
				'Graham Silberman was born and raised in Johannesburg, South Africa. Prior to dedicating more than 20 years to diamond and jewelry sales in a business to business capacity, Silberman was a professional tennis player.',
				'Silberman hung up his racket to become a professional in the jewelry industry here in Dallas. His decades of service in the Metroplex have made him a fixture in the local jewelry scene and he is truly proud to be a part of it.',
				'Silberman has been married to his lovely wife, Karen, for 38 years. They share two beautiful daughters and one precious granddaughter. In his free time, Silberman enjoys playing golf and poker.',
			],
		},
		{
			name: 'Leslie Zale Greco',
			title: 'Diamond Expert, GIA Graduate Gemologist',
			picture: 'leslie_zale_greco.jpg',
			email: 'LeslieG@diamondsdirect.com',
			phone: '',
			bio: [
				'Leslie Zale Greco, Graduate Gemologist, has a bachelor\'s degree from the University of Arizona and obtained her Graduate Gemologist degree from the Gemological Institute of America (GIA).',
				'Greco has been in the jewelry business for over 40 years. She started in the family business, Zale Corporation, which her grandfather William Zale founded.',
				'In her free time, she enjoys reading, cooking, traveling and spending time with her husband and two daughters.',
			],
		},
		{
			name: 'Charity Brown',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'jan17/Dallas_Charity.png',
			email: 'charityb@diamondsdirect.com',
			phone: '',
			bio: [
				'Charity Brown is a Diamond Council of America graduate and began her career in the jewelry industry in 2012. Before joining Diamonds Direct in February 2018, Brown managed Kay Jewelers and Zales stores and was a diamond expert at Bailey Banks and Biddle and Robbins Brothers.',
				'Brown\'s hobby is her job! She loves what she does and couldn\'t imagine doing anything else!',
				'In October 2012, Brown married her high school sweetheart and best friend, Levi. Together they have four Fur-babies and they love taking their dogs hiking and swimming in their free time.',
			],
		},
		{
			name: 'Robert Alvarado',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'jan17/Dallas_Robert.png',
			email: 'RobertA@diamondsdirect.com',
			phone: '',
			bio: [
				'Robert Alvarado, Diamond Council of America Graduate, joined Diamonds Direct in March of 2017. Born and raised in San Antonio, Texas, Alvarado graduated from Antonian College Preparatory High School and Sul Ross State University in Alpine, Texas where he majored in Wildlife Management and Minored in Biology--and is fluent in Spanish.',
				'Alvarado began his career in jewelry and luxury timepieces San Antonio in 1990, and successfully managed stores until beginning his career with Diamonds Direct. Being highly motivated, Alvarado puts his customers first and will go out of his way to do whatever it takes to make sure every customer’s experience is the best.',
				'Alvarado is also the on-site Tacori brand ambassador in Dallas.',
				'Outside of work Alvarado enjoys international travel. His recent destinations include Greece, Spain, Argentina and Mexico. He also thoroughly enjoys being outdoors and landscaping his home. Alvarado attends many basketball games with his son, watching their favorite team...the San Antonio Spurs (even though I’m in Dallas Mavs territory). He loves spending time with his spouse and their four grandchildren. They also recently welcomed a new dog to the family, Bella!',
			],
		},
		{
			name: 'Stephen Metcalf',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'stephen_matcalfe.jpg',
			email: 'Stephen@diamondsdirect.com',
			phone: '',
			bio: [
				'Stephen Metcalf joined Diamonds Direct in 2018 and is Diamond and Gemologist certified through the Diamond Council of America. He was born and raised in Dallas, Texas so he is a true local in the community!',
				'Metcalf has been in the jewelry industry since 2000. Over the past two decades, he has learned all aspects of the business starting with servicing merchandise when he was just 16 years old to becoming a Diamond Expert today. Prior to joining Diamonds Direct, Metcalf spent 15 years working for Zales.',
				'Metcalf is a great listener and he focuses on helping people, problem solving, critical thinking and entertaining.',
				'Outside of the office, Metcalf enjoys cooking, playing with his two fur babies - a Chihuahua named Pippy and a Schnauzer named Emerson—trying new restaurants, hosting barbeques around his backyard fire, gardening and going to sports games. His favorite things to do in his free time are to travel and to spend time with his family. Two of his favorite destinations are the Bahamas and Mexico. Metcalf is engaged and set to be married in the Fall of 2018 to his beautiful fiancée Courtney!',
			],
		},
		{
			name: 'Allan Abramowitz',
			title: 'Diamond Expert, GIA Graduate Gemologist',
			picture: 'jan17/Dallas_Allan.png',
			email: 'AllanA@diamondsdirect.com',
			phone: '',
			bio: [
				'Allan Abramowitz, Graduate Gemologist, has worked in the jewelry industry for more than 30 years, beginning in New York City where he owned his jewelry storefront. From there, Abramowitz developed a diverse professional background including earning his Graduate Gemologist certificate from the Gemological Institute of America (GIA) and gaining membership to the Diamond Dealers Club in New York City where he worked as an appraiser and diamond buyer.',
				'Abramowitz has only one greater passion than diamonds – and that’s cooking. In fact, few people know he took a sabbatical from the jewelry industry to nurture his passion for cooking in NYC where he became a chef at the French Culinary Institute.',
				'When he\'s not working with customers or cooking, Abramowitz also enjoys golfing and travel.',
			],
		},
		{
			name: 'Thanh Tran',
			title: 'Diamond Expert',
			picture: 'thanh.jpg',
			email: 'Thanht@diamondsdirect.com',
			phone: '',
			bio: [
				'Thanh Tran joined the Diamonds Direct team in 2020 and is looking forward to sharing her passion for luxury service with clients.',
				'Born in Vietnam, Thanh came to the United States at a very young age and is bilingual. She attended Georgia Institute of Technology pursuing a minor in textile engineering but graduated from University of Texas at Dallas in 1999 with a Bachelor of Science degree in Accounting.',
				'After completing her studies, Thanh decided to pursue a career in retail and has enjoyed working in the industry since 2004. Thanh\'s favorite part of her job is interacting with people and seeing them smile after handing off their perfect piece. Outside of work, Thanh loves to travel and experience different cultures and cuisines.',
			],
		},
		{
			name: 'Karren Garces',
			title: 'Diamond Expert',
			picture: 'Karen.png',
			email: 'karreng@diamondsdirect.com',
			phone: '',
			bio: [
				'Karren Garces received her Diamond Certification in 2018 and has been fulfilling her passion for fine jewelry and diamonds since 2016, although her years of sales experience span further and wider. She brings her talents of providing excellent customer service and experience to Dallas following her time as a Diamond Expert at the Austin and Frisco Diamonds Direct locations.',
				'Karren also has received her Bachelors of Fine Art Degree in Graphic Design and Illustration along with her Masters Degree in Advertising and Public Relations.',
				'Karren’s approach to people is genuine and authentic, while she enjoys connecting with her clients on a personal level! Outside of work, her hobbies include art, travel and playing with her furry friends! Above all else, Karren truly finds joy in bringing a smile across someone’s face for years to come.',
			],
		},
	],
	sponsorships: [
		{
			name: 'American\'s Team',
			image: 'cowboys.jpg',
		},
		{
			name: 'SMU',
			image: 'smu.jpg',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/3ishnZw',
		googleWrite: 'https://bit.ly/3ishnZw',
	}
};

const ECJ = {
	template: 'watch',
	name: 'Diamonds Direct\'s Exclusive Watch Collection',
	title: 'Diamonds Direct Luxury Watch Collection',
	description: 'ECJ Offers the Finest Selection of Watches. Visit Our ECJ Location Today!',
	shortName: 'ECJ',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Timepieces are one of the few items you wear on a daily basis, and it reflects your uniqueness. Here at Diamonds Direct, we offer a range of luxury watches that conform to your identity, personality, and lifestyle. No matter what you want to convey with your watch, our team will work with you to select the right luxury watch suited to your liking. Our watch styles range from classic, to sporty and rugged, and even ultra-modern and trendy. All of the watches we carry are meticulously chosen with form, function, luxury, and style in mind.',
	],
	bestsellers: {
		title: 'Sophistication is Timeless.',
		items: {
			primary: [
				{
					image: 'blancpain.jpg',
					title: 'Blancpain',
					subtitle: 'Villeret Wuantieme Phases de Lune',
				},
			],
			secondary: [
				{
					image: 'glashitte.jpg',
					title: 'Glashutte',
					subtitle: 'Senator Excellence',
				},
				{
					image: 'perrelet.jpg',
					title: 'Perrelet',
					subtitle: 'Jumping Hour',
				},
				{
					image: 'hublot1.jpg',
					title: 'Hublot',
					subtitle: 'Big Bang Tourbillion Power Reserve',
				},
				{
					image: 'hublot2.jpg',
					title: 'Hublot',
					subtitle: 'Big Bang Unico King Gold Ceramic',
				},
			],
		}
	},
	bestsellersNew: {
		title: 'Meet some of our best sellers',
		items: {
			primary: [
				{
					image: 'hublot1_large.jpg',
					title: 'Hublot',
					subtitle: '',
				},
			],
			secondary: [
				{
					image: 'franck_small.jpg',
					title: 'Franck Muller',
					subtitle: '',
				},
				{
					image: 'blancpain_small.jpg',
					title: 'Blancpain',
					subtitle: '',
				},
				{
					image: 'zenith_small.jpg',
					title: 'Zenith',
					subtitle: '',
				},
				{
					image: 'aandson_small.jpg',
					title: 'Arnold & Son',
					subtitle: '',
				},
			],
		}
	},
	facebookUrl: 'https://www.facebook.com/ecjluxe.charlotte',
	instagramUrl: 'https://www.instagram.com/ecjluxecharlotte/',
	address: {
		line1: '4521 Sharon Road',
		line2: 'Charlotte, NC 28211',
	},
	googleMapsLink: '',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '7042959190',
	email: 'watches@diamondsdirect.com',
	team: [
		{
			name: 'Dovy Klarberg',
			title: 'EVP | Market President',
			picture: 'dovyk.jpg',
			email: 'Dovy@DiamondsDirect.com',
			phone: '',
			bio: [
				'Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design.',
				'After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.',
				'During Dovy\'s time with Diamonds Direct SouthPark, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.',
				'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts within Charlotte, NC. He is also focused on making Diamonds Direct SouthPark\'s brand more ingrained in the local community.',
				'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.',
			],
		},
		{
			name: 'Christopher J. Ward',
			title: 'Timepiece Expert',
			picture: 'chrisw.jpg',
			email: 'ChrisW@DiamondsDirect.com',
			phone: '',
			bio: [
				'Christopher J. Ward, Timepiece Expert, has been part of the ECJ Luxe/Diamonds Direct family since September 2015. He studied business at UNC Wilmington. In addition to extensive timepiece training Chris also has multiple Diamond certifications from the Gemological Institute of America.',
				'Chris has worked in various levels including sales for Fink\'s Jewelers in Charlotte, North Carolina.',
				'In his free time Chris enjoys watching sports, playing basketball and hanging out with his Siberian Husky Kobi.',
			],
		},
	],
	sponsorships: [],
	reviews: {},
	designers: [
		{
			image: 'ap.png',
		},
		{
			image: 'b.png',
		},
		{
			image: 'brm.png',
		},
		{
			image: 'g.png',
		},
		{
			image: 'gl.png',
		},
		{
			image: 'h.png',
		},
		{
			image: 'ML.png',
		},
		{
			image: 'p.png',
		},
		{
			image: 'sf.png',
		},
		{
			image: 'z.png',
		},
	]
};

const FTX = {
	template: 'store',
	currentPromo: false,
	title: 'Diamonds Direct Frisco - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry & More. Visit Our Frisco Location Today!',
	name: 'Diamonds Direct Frisco',
	shortName: 'Frisco',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Frisco to shop our latest arrivals and exclusive selection of diamond and fine jewelry.',
		'Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectfrisco',
	instagramUrl: '',
	video: 'https://player.vimeo.com/video/365145124',
	address: {
		line1: '8440 State Hwy 121, Building A',
		line2: 'Frisco, TX 75034',
	},
	googleMapsLink: 'https://www.google.com/search?client=safari&rls=en&q=diamonds+direct+frisco&ie=UTF-8&oe=UTF-8',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '4698504270',
	email: 'infoFRISCO@diamondsdirect.com',
	team: [
		{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@diamondsdirect.com',
			phone: '',
			bio: [
				'Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.',
				'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.',
				'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.',
				'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.',
			],
		},
		{
			name: 'Yosi Mayer',
			title: 'Vice President',
			picture: 'yosi.jpg',
			email: 'yosi@diamondsdirect.com',
			phone: '',
			bio: [
				'Yosi Mayer, Vice President, joined the Diamonds Direct family in 2016.',
				'Born in Israel, Mayer served in the Israeli Military for three years in the Paratroopers Brigade. For the past 16 years Mayer has worked in the diamond and jewelry industry all over the world with experience ranging from wholesale to retail.',
				'Mayer\'s career in the industry began in 2000, in retail sales for a major jewelry chain in Mexico and the Caribbean. From there, he worked his way up the ladder to manage several stores in a General Manager capacity. In 2008 Mayer decided it was time to move back to Israel, where he continued to work in the industry only this time as a Sales Manager and Buyer for leading wholesale firms at the Israeli Diamond Exchange.',
				'In 2016 Mayer met Itay Berger – President of Diamonds Direct and understood that joining the company would allow him to keep pursuing his passion for exceptional customer service, team leading and business development. For that reason, he made the decision to move his family to Dallas.',
				'Mayer is married to his high-school sweetheart Liz. They have two lovely daughters and a dog. He enjoys spending time with his family while exploring Dallas and the surrounding areas. He takes interest in learning different cultures and languages and is a self proclaimed foodie, always chasing the next great meal.',
			],
		},
		{
			name: 'Olga Elmanovich',
			title: 'Vice President',
			picture: 'olga.jpg',
			email: 'Olga@diamondsdirect.com',
			phone: '',
			bio: [
				'Originally from Russia, Elmanovich made her home in the United States in Birmingham, Alabama with her husband, Richard. As she earned a degree in linguistics from the University of Alabama at Birmingham, Olga found her passion for diamonds while working part time for Diamonds Direct. Shortly after completing her college education, she joined Diamonds Direct Birmingham fulltime and switched gears to focus on her diamond education. Olga gained her certification as a GIA Accredited Jewelry Professional and enjoyed her career and growth with the company.',
				'In 2018, Olga moved to Kansas City and was brought on to manage the new location. After managing the Leawood store for over two wonderful years, she was presented the opportunity to move to Frisco and continue her journey with Diamonds Direct in Texas. Olga has loved every minute of spending time here in Frisco and looks forward to making new memories here with her family.',
				'Today, Olga proudly serves as Vice President of the company, now overseeing the Frisco, Kansas City and Oklahoma City markets.',
			],
		},
		{
			name: 'Matt Corbin',
			title: 'General Manager',
			picture: 'matt.png',
			email: 'MattC@diamondsdirect.com',
			phone: '',
			bio: [
				'Matt Corbin joined the Diamonds Direct team in 2020 and is delighted to be a part of the Frisco family. With over 25 years of experience in the industry, Matt’s passion for exceptional customer service and a top-tier experience remains second to none.',
				'Originally from Kansas City, Missouri, Matt set out in the industry working seasonally during the holiday season but shortly thereafter, fell in love with the business and helping guests commemorate life’s most important moments. When presented the opportunity to serve as General Manager, Matt was ecstatic to join such a wonderful team and feels fortunate to call Frisco home. Prior to working for Diamonds Direct, Matt obtained his certification as a GIA Accredited Jewelry Professional as well as his DCA Certification. His favorite part of the Diamonds Direct experience is helping guests create memories that will last a lifetime.',
				'Outside of the showroom, Matt loves spending time with his family and watching plenty of sports! He also can often be found cooking an amazing meal in the kitchen or enjoying grilling outdoors.',
			],
		},
		{
			name: 'Jessica Baker',
			title: 'Back Office Manager',
			picture: 'Frisco_Jessica.png',
			email: 'JessBaker@diamondsdirect.com',
			phone: '',
			bio: [
				'Jessica Baker joined Diamonds Direct in 2019 and is pursuing a Bachelor\'s degree in business management. Prior to her time at Diamonds Direct, Jessica worked in sales for over five years and eventually found her true passion working with fine jewelry.',
				'Jessica was born in Dover, Delaware and was raised in a military family with family members in both the Air Force and Army. She has lived in seven different states as well as England before calling Texas home!',
				'Throughout her time at Diamonds Direct, Jessica has enjoyed learning more about the diamond process and bringing her enthusiasm to the Frisco team. Outside of work, Jessica loves finding a good movie to watch and also enjoys spending time with her dog, Hennessy. As a true creative, Jessica loves to recharge with a good craft or by spending time outdoors.',
			],
		},
		{
			name: 'Keith Hudson',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'keithh.jpg',
			email: 'KeithH@diamondsdirect.com',
			phone: '',
			bio: [
				'Keith Hudson, a graduate of the Diamond Council of America, joined the team in 2019. He has been in the industry for over 30 years and most recently, was a District Manager for the last 25 years.',
				'One of Keith\'s favorite parts of working with fine jewelry is seeing customers\' faces light up as they see their final piece, from start to finish!',
				'Now happily helping customers celebrate life and love in a direct sales position, Keith is grateful to be a part of the Diamonds Direct family, serving the Frisco community.',
			],
		},
		{
			name: 'Heather Kim',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'heatherk.jpg',
			email: 'HeatherK@diamondsdirect.com',
			phone: '',
			bio: [
				'Heather Kim joined Diamonds Direct in 2019 and has been in the business for over 22 years. Heather was born in Seoul, South Korea and soon after, her family moved to the United States when she was very young. Her family settled down in Virginia where she attended George Mason University, which led her to finding her passion for fine jewelry. Heather\'s career took off as she began working for several other luxury brands as well as serving as eventually serving as a store manager. Learning about diamonds and gemstones is what first attracted Heather to the business and also the enjoyment of helping guests find the piece of their dreams. Heather has obtained both her DCA Diamond and Gemstone Certifications. Outside of work, Heather loves to spend time with her family, cats and puppy. She loves to travel, go to concerts and enjoy the outdoors. Heather has lived in Texas for over ten years and loves calling the Lone Star state home!',
			],
		},
		{
			name: 'Marcy Lingner',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'marcyl.jpg',
			email: 'MarcyL@diamondsdirect.com',
			phone: '',
			bio: [
				'Marcy Lingner, DCA Graduate, attended the University of Illinois and has worked in the industry since 1995 serving as both a manager as well as district manager in her decades of experience. Marcy is delighted to now step into sales which has always been her favorite part of the jewelry industry. Whether selling an engagement ring or a first pair of diamond studs, she loves being part of people’s journey and seeing their joy.',
				'Outside of work, Marcy enjoys traveling, cheering on the Buffalo Bills and spending quality time with her family as a loving Grandma!',
			],
		},
		{
			name: 'Mark Tremonte',
			title: 'Diamond Expert',
			picture: 'Frisco_Mark.png',
			email: 'MarkT@diamondsdirect.com',
			phone: '',
			bio: [
				'Mark Tremonte joined the Diamonds Direct team in 2020 and is delighted to assist customers with their most meaningful moments! Mark graduated from the University of South Carolina with a Bachelors degree in Retail Management. He also obtained his DCA Diamond certification and has had a passion for fine jewelry ever since!',
				'Mark has been in the business for over thirty years and has held a multitude of different roles, most recently serving as a Regional Sales Director. Mark truly values building relationships with his clients throughout all their exciting stages of life. His favorite part of the industry remains the same, helping clients find the perfect piece for any occasion and leave our doors feeling fantastic.',
				'Outside of work, Mark loves to spend time with family, travel, and can never pass up a good round of golf. A true sports aficionado, Mark loves cheering on the Dallas Mavericks and Dallas Stars. Outside of Texas sports, all three of his children are Alabama graduates so Mark also is a huge Crimson Tide fan!',
			],
		},
		{
			name: 'Remington Evans',
			title: 'Front Office Support',
			picture: 'Frisco_Remington.png',
			email: '',
			phone: '',
			bio: [],
		},
				{
			name: 'Allison Parks',
			title: 'Diamond Expert',
			picture: 'allison_parks.jpg',
			email: 'AllisonP@DiamondsDirect.com',
			phone: '',
			bio: [
				'Allison Parks, Diamond Expert, has been with Diamonds Direct since 2013. She graduated from Colorado State University with a Bachelor\'s degree in Human Development and Family Studies.',
				'Allison has been in the retail and jewelry industry for 8 years. She was previously with Bailey Banks & Biddle where she started in sales and was promoted to Assistant Manager.',
				'In her free time Allison enjoys spending time with her husband and 2 children, hiking, and entertaining friends.',
			],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://bit.ly/2ZFChh0',
		googleWrite: 'https://bit.ly/2ZFChh0',
	}
};

const GSC = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Greenville',
	title: 'Diamonds Direct Greenville - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Greenville Location Today!',
	shortName: 'Greenville',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Greenville to shop our latest arrivals and exclusive selection of diamond and fine jewelry. Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectgreenville',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '1113 Woodruff Rd.',
		line2: 'Greenville, SC 29607',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Greenville/@34.6844938,-82.1039085,10z/data=!4m8!1m2!2m1!1sdiamond+direct+greenville+sc!3m4!1s0x0:0xa6de24d19cee942d!8m2!3d34.8315593!4d-82.3059654',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '8645015090',
	email: 'infoGVL@diamondsdirect.com',
	team: [
		{
			name: 'Dovy Klarberg',
			title: 'Partner | President South',
			picture: 'DovyKlarberg.jpg',
			email: 'Dovy@diamondsdirect.com',
			phone: '',
			bio: [
				'Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design. After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.',
				'During Dovy\'s time with Diamonds Direct, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.',
				'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts. He is also focused on making Diamonds Direct’s brand more ingrained in the local communities.',
				'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.',
			],
		},
		{
			name: 'Lynn Tu',
			title: 'Vice President',
			picture: 'LynnTu.jpg',
			email: 'lynnt@diamondsdirect.com',
			phone: '',
			bio: [
				'Lynn Tu has been with Diamonds Direct since 2015. She has a Bachelor’s Degree in Marketing from Suffolk University. Tu is also a Diamond Graduate from the Gemological Institute of America (GIA).',
				'Tu has over 20+ years of experience in sales and management roles within the diamond and jewelry industry. Before making the move to Charleston, Tu worked in the original Diamonds Direct location in Charlotte, North Carolina where she was a Diamond Expert for four years. Tu brings a variety of experience to the Vice President role and is looking forward to settling into life in the Lowcountry.',
				'In her free time, Tu enjoys reading, practicing yoga and traveling.',
			],
		},
		{
			name: 'Igor Zak',
			title: 'Regional Manager',
			picture: 'Igor.JPG',
			email: 'igorz@diamondsdirect.com',
			phone: '',
			bio: [
				'Igor Zak joined the Diamonds Direct family in 2019. Originally from Israel, Zak made the move to join the team in our Charlotte, North Carolina showroom after working in our Israeli offices for over a year.',
				'Outside of work, Zak loves cheering on FC Barcelona, trying new local pizzerias and spending time with his wife.',
			],
		},
		{
			name: 'Arti Patel',
			title: 'Diamond Expert',
			picture: 'Arti.JPG',
			email: 'artip@diamondsdirect.com',
			phone: '',
			bio: [
				'Arti Patel joined the Diamonds Direct family in November 2020. Patel has been in the diamond and jewelry business since 2012. She enjoys helping people and becoming a part of their family.',
				'In her free time, Patel loves traveling, cooking and meeting new and interesting people.',
			],
		},
		{
			name: 'Ryan Czarnecki',
			title: 'GIA Diamonds Graduate',
			picture: 'Ryan.JPG',
			email: 'RyanC@diamondsdirect.com',
			phone: '',
			bio: [
				'Ryan Czarnecki, a GIA Diamonds Graduate, has been a part of the Diamonds Direct team since 2014. Ryan got his start as a Jeweler’s Apprentice in 2014 in the Charlotte, North Carolina location before transitioning to the online team in 2017. In 2021, Ryan made the move to Greenville to continue his career as a Diamond Expert.', 
				'In his free time, Ryan loves watching football, going fishing and hanging out with his dog Ava.', 
			],
		},
		{
			name: 'Trace Honeycutt',
			title: 'Diamond Expert',
			picture: 'trace.jpg',
			email: 'TraceH@DiamondsDirect.com',
			phone: '',
			bio: [
				'Trace Honeycutt, Diamond Expert, has been with Diamonds Direct since 2009. She has a Bachelor\'s Degree in Business Marketing and Business Finance from Gaston College and an Associate\'s Degree in Graphic Arts. Honeycutt also is certified by the Diamond Council of America.',
				'Honeycutt has been in the diamond and jewelry business since 2003. Previously, she worked in sales and was the Diamond Department Manager at Jared, The Galleria of Jewelry in Concord, North Carolina.',
				'In her free time, Honeycutt enjoys painting, reading and hanging out with her dog, Charlie.',
			],
		},
		{
			name: 'William Kraus',
			title: 'Master Jeweler',
			picture: 'William.JPG',
			email: 'williamk@diamondsdirect.com',
			phone: '',
			bio: [
				'William Kraus started his career in the jewelry industry in 2006. Kraus has been a part of the Diamonds Direct family since 2018.', 
				'Family adventures while creating memories is what drives William’s success.', 
			],
		},
		{
			name: 'Marni Hermecz',
			title: 'Back Office Manager',
			picture: 'aug08/MarniHermecz.jpg',
			email: 'marnih@diamondsdirect.com',
			phone: '',
			bio: [
				'Marni Hermecz has been a part of the Diamonds Direct family since 2017. Hermecz started in the Charlotte, North Carolina location where she worked in Customer Service for two years and Special Orders for two years.', 
				'Originally from Colorado, Hermecz loves now living in South Carolina with her husband. In her free time, she loves gardening, camping, scuba diving and spending time with her animals outside.', 
			],
		},
		{
			name: 'Bailey Wills',
			title: 'Back Office Support',
			picture: 'aug08/BaileyWills.jpg',
			email: 'baileyw@diamondsdirect.com',
			phone: '',
			bio: [
				'Bailey Wills, a Greenville native, joined the Diamonds Direct family in 2021.',
				'Outside of work, Wills enjoys taking road trips as well as cooking and baking in her tiny home with her boyfriend.',
			],
		},
		{
			name: 'Tania Mitar',
			title: 'Front Office Support',
			picture: 'aug08/TaniaMitar.jpg',
			email: 'taniam@diamondsdirect.com',
			phone: '',
			bio: [
				'Tania Mitar has been a part of the Diamonds Direct Greenville team opening in 2021. Mitar is a certified gemologist and has been a part of the industry since 2008.',
				'In her free time, Mitar loves traveling and spending time with her pets.',
			],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://bit.ly/3B3t9Ri',
		googleWrite: 'https://bit.ly/3B3t9Ri',
	}
};

const HOU = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Houston (Galleria)',
	title: 'Diamonds Direct Houston (Galleria) - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Houston (Galleria) Location Today!',
	shortName: 'Houston (Galleria)',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Houston to shop our latest arrivals and exclusive selection of diamond and fine jewelry. Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirecthouston',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '3115 West Loop S.',
		line2: 'Houston, TX 77027',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Houston/@29.7357531,-95.4603983,17z/data=!4m5!3m4!1s0x8640c1fcd9285f59:0x1fbae69128ca2661!8m2!3d29.7357485!4d-95.4582043',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '3462502054',
	email: 'infoHOU@diamondsdirect.com',
	team: [
		{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: [
				'Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.',
				'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.',
				'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.',
				'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.',
			],
		},
		{
			name: 'Tamir Shkargi',
			title: 'Vice President',
			picture: 'Tamir1.jpg',
			email: 'Tamir@diamondsdirect.com',
			phone: '',
			bio: [
				'Tamir Shkargi joined the Diamonds Direct team 2017. Originally from Israel, Tamir served in the Israeli Military for three years. Upon his completion of service, he embarked on a career with the Israeli government for over ten years. After receiving his degree in Business Administration at Ono Academic College, Tamir decided to move to the United States with his family.',
				'Tamir’s new chapter began in Austin, Texas which led him to pursue a career in retail management with Diamonds Direct. It was the remarkable culture and amazing group of people that made Diamonds Direct the perfect fit for Tamir.',
				'After managing the Frisco store for nearly two years, he was given the opportunity to bring his talents to Houston and grow the Diamonds Direct family. Tamir greatly looks forward to this new journey with his family and they are excited to call Houston home.',
				'Outside of work, Tamir enjoys playing soccer with friends and spending time with his wife and their precious two boys!',
			],
		},
		{
			name: 'Kevin Ferrin',
			title: 'General Manager',
			picture: 'kevin_ferrin.jpg',
			email: '',
			phone: '',
			bio: [
				'While he was born and raised in Virginia, Kevin Ferrin has deep roots in the Lone Star state and considers himself a Texan at heart. Kevin found his passion for jewelry at a young age, following in his mother’s footsteps. After years of working in “big box” stores, Kevin was ready for a big change. Ferrin joined the Diamonds Direct family in 2017 at the Austin location as a Diamond Expert. With more than two decades of jewelry and management experience, Ferrin quickly proved to be a valuable asset to the company. In 2021, Kevin transitioned into the role of General Manager for the Houston location after completing an extensive training program with Diamonds Direct.',
				'During his down time Kevin enjoys spending time with his husband, Sean, and their two fur babies. Kevin is also a passionate traveler having visited countries including Mexico, Ireland and Indonesia.',
			],
		},
		{
			name: 'Matt Baba',
			title: 'Store Manager',
			picture: 'Matt.jpg',
			email: '',
			phone: '',
			bio: [
				'Matt joined Diamonds Direct in 2020. Before joining the company, he worked in the industry for over 20 years and is DCA certified. He prides himself in understanding each customer that walks through the door and tailoring their experience to their needs. His goal is to make the diamond buying experience fun and stress-free for every customer.',
				'Matt is passionate about furthering his education and is consistently learning. In fact, he is fluent in English, Arabic and American Sign Language. Outside of work, he enjoys spending time with his family.',
			],
		},
		{
			name: 'Alvaro Mercado',
			title: 'Bench Jeweler',
			picture: 'Alvaro.jpg',
			email: '',
			phone: '',
			bio: [
				'Alvaro joined Diamonds Direct in 2020. He has 12 years of experience working as a jeweler. During that time he also managed to complete his Bachelor’s in supply chain management.',
				'As a lifelong learner and tinkerer, Alvaro loves that his job is both creative and technical.  It also offers him the ability to become a part, albeit a small one, of people’s life journey. Something that is truly magical.',
				'Born in Nicaragua, and raised in Houston, Texas,  he considers himself a Texan through and through. In his spare time he enjoys cooking for his family. Taking his two year old to the chicken farm and watching him try to pet the chickens. And in quieter moments, he has been known to get lost in a Wikipedia rabbit hole or two.',
			],
		},
		{
			name: 'Cynthia Cullen',
			title: 'Diamond Expert',
			picture: 'GA4A9168.jpg',
			email: '',
			phone: '',
			bio: [
				'Cynthia Cullen, diamond expert, is a graduate of Saddleback College in Southern California. In her early career, Cynthia had a career in show business where she worked as a professional jazz dancer in television and theatre in four different countries. For 21 years, she was based in Milan, Italy. In fact, she still is able to speak Italian fluently!',
				'Her passion for jewelry began in 2012. Leading up to this, Cynthia owned her own business of importing Murano Hand Blown Glass designer jewelry to Southern California. Cynthia is thrilled to join the Diamonds Direct team and bring her passion for life and jewelry straight to her clients.',
				'In her free time, Cynthia enjoys riding her motorcycle and living life to the fullest!',
			],
		},
		{
			name: 'Alexandra Sprague',
			title: 'Diamond Expert',
			picture: 'Alex.jpg',
			email: '',
			phone: '',
			bio: [
				'Alexandra, Diamond Expert, graduated from Le Cordon Bleu with a pastry degree. Although she had an early passion for pastries, diamonds were always curious to her. She eventually began to further her interest in diamonds and made the shift from pastries to diamonds. It was the best transition in her life!',
				'Alexandra comes to Diamonds Direct with over four years in the jewelry industry. She enjoys connecting with each guest on a personal level. Her goal is to continuously go above and beyond to ensure each guest has an amazing experience. She is truly passionate about making each and every guest encounter a special and memorable experience.',
				'In her spare time, she enjoys spending time with her 5 year old son, Leo.',
			],
		},
		{
			name: 'Callie Ahlfenger',
			title: 'Front Office Support',
			picture: 'Callie.jpg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Victoria Puentes',
			title: 'Front Office Manager',
			picture: 'Victoria.jpg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Natalie Baba',
			title: 'Diamond Expert',
			picture: 'Natalie.jpg',
			email: '',
			phone: '',
			bio: [
				'Natalie is originally from Orlando, Florida. She joined the Diamonds Direct team in November 2020 and has over ten years of retail sales experience. Her truest joy is building relationships with people, and she considers herself privileged to being a part of their memorable life moments. She prides herself on delivering excellent customer service.',
				'Outside of work, Natalie loves date nights with her husband. She is an avid cook and spends much of her time in the kitchen. She loves culture and language and speaks both English and Arabic.',
			],
		},
		{
			name: 'Jordan de los Santos',
			title: 'Diamond Expert',
			picture: 'jordan.jpg',
			email: '',
			phone: '',
			bio: [
				'Jordan joined Diamonds Direct as a Diamond Expert in early 2022. While new to the Diamonds Direct family (and Houston), Jordan has been in the jewelry industry for over six years and is DCA certified. She first started out in the industry by creating a custom piece, and immediately fell in love with the process! The driving force behind her success is her passion for fostering meaningful customer relationships; she gives her all to ensure each customer has an incredible experience.',
				'Outside of work, she is passionate about travel (one of her favorite destinations was the Argyle diamond mines in Australia) and music. She also enjoys trying out new recipes in the kitchen!',
			],
		},
		{
			name: 'Raven Boudreaux',
			title: 'Diamond Expert',
			picture: 'raven.jpg',
			email: '',
			phone: '',
			bio: [
				'Raven started with Diamonds Direct as a Diamond Expert in early 2022. She is a Houston native, and has worked in jewelry and luxury sales for over five years. Prior to working in the industry, she worked mainly in design, and has since found her passion in helping customers design their dream pieces. This passion allows her to make lifelong connections with her customers and provide them with amazing and memorable experiences. Most recently, she is working to hone her own knowledge and skill set by studying to become a Graduate Gemologist through GIA.',
				'In her spare time, Raven enjoys traveling, outdoor activities , live music, and spending time with her two fur babies.',
			],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://bit.ly/3l0y6EP',
		googleWrite: 'https://bit.ly/3l0y6EP',
	}
};

const IND = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Indianapolis',
	title: 'Diamonds Direct Indianapolis - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry & More. Visit Our Indianapolis Location Today!',
	shortName: 'Indianapolis',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Race on over to our beautiful showroom on North River Road for all of your jewelry buying occasions. With over 2,000 engagement ring settings you can be sure you’ve picked the perfect one! Looking for an unforgettable proposal? Ask about our annual Colts proposal giveaway!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/DiamondsDirectINDY',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '8557 North River Road',
		line2: 'Indianapolis, IN 46240',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Indianapolis/@39.9110903,-86.1077493,17z/data=!3m1!4b1!4m5!3m4!1s0x872b0d6dcd3f4c63:0x6a3338974955708e!8m2!3d39.9110862!4d-86.1055606',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '3175758555',
	email: 'infoindy@diamondsdirect.com',
	team: [
		{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: [
				'Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.',
				'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.',
				'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.',
				'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.',
				'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.',
			],
		},
		{
			name: 'Niv Ankawa',
			title: 'Vice President',
			picture: 'mar02/NivAnkawa.jpg',
			email: 'Niv@diamondsdirect.com',
			phone: '',
			bio: [
				'Niv joined Diamonds Direct in 2018. With over 12 years of experience in the fine jewelry and diamond business, Niv’s expertise comes from his many years managing a store in the Diamond District in New York City.  Prior to the Diamond District, Niv also managed a jewelry store in Miami for 7 years. His strength is his ability to connect with people. He believes client satisfaction is the key to a successful brand.  In his free time Niv enjoys being active, playing soccer, frequents the gym, and is an avid skier. He also loves trying new restaurants and traveling all over the world.',
			],
		},
		{
			name: 'Robert Violante',
			title: 'General Manager',
			picture: 'robert2.jpg',
			email: 'robert@diamondsdirect.com',
			phone: '',
			bio: [
				'Robert has been in the diamond and fine jewelry business for over 20 years. He has managed teams across the country, but for the last 8 years has been proud to call Indiana home.  During his time at Diamonds Direct, Robert has had the unique opportunity to work with his clientele to offer some of the most unique, rare, and one-of-a-kind heirlooms in the business. He also enjoys working with his team to bring customers the very best quality and value on certified diamonds anywhere in the United States. When you can’t find him in the showroom, Robert can typically be found on the lake, enjoying a cigar, or spending time with family.',
			],
		},
		{
			name: 'Kalyn Knapke',
			title: 'Diamond Expert',
			picture: 'mar02/KalynKnapke.jpg',
			email: 'Kalyn@diamondsdirect.com',
			phone: '',
			bio: [
				'Kalyn joined Diamonds Direct 2016, bringing 12 years of jewelry sales experience with her. She loves getting to know her clients and creating lifelong friendships with them. In her free time, Kalyn enjoys spending time with her 2 children and husband. She also loves to play euchre.',
			],
		},
		{
			name: 'Kris Cassady',
			title: 'Diamond Expert',
			picture: 'mar02/KrisCassady.jpg',
			email: 'Kris@diamondsdirect.com',
			phone: '',
			bio: [
				'Kris joined Diamonds Direct in 2012 and has been in the jewelry industry for over 21 years. She loves helping clients with their special occasions and life moments. Kris considers herself lucky to be involved in people’s love stories. When she is not working, Kris enjoys spending time with her two kids and animals. She enjoys landscaping, decorating, and cooking.',
			],
		},
		{
			name: 'Selena Powell',
			title: 'Diamond Expert',
			picture: 'mar02/SelenaPowell.jpg',
			email: 'Selena@diamondsdirect.com',
			phone: '',
			bio: [
				'Selena Powell joined Diamonds Direct in 2015 after working in the jewelry industry for 6 1/2 years, and in luxury sales and management for many years before that. She is the mom of 3 and the grandmother of 2 granddaughters  who she can\'t get enough of. She\'s passionate about her family, her career, and her Golden Doodles.',
			],
		},
		{
			name: 'Laura Ekram',
			title: 'Back Office Support, GIA Gemologist',
			picture: 'mar02/LauraEkram.jpg',
			email: 'laurae@diamondsdirect.com',
			phone: '',
			bio: [
				'Laura joined Diamonds Direct in 2018, after being in the jewelry industry since 2005. She is a GIA Graduate Gemologist, specializing in appraisals and loose diamonds. Laura has worked all over the country for independent & online jewelers as a head appraiser . After marrying her husband she moved to the Pacific Northwest where she worked for a large online diamond retailer as the head appraiser, evaluating all incoming stones and jewelry for the company. In her spare time, she enjoys spending time with her husband and two boys, being outdoors and reading.',
			],
		},
		{
			name: 'Deborah Coutcher',
			title: 'Reception',
			picture: 'jun9/Deborah.jpg',
			email: 'indyreception@diamondsdirect.com',
			phone: '',
			bio: [
				'Deborah joined Diamonds Direct in 2012, after being in jewelry sales and management for 15 years. She enjoys being a part of the support staff and connecting with new people every day. In her spare time, Deborah enjoys painting, playing games, reading, and spending time with her grandchildren.',
			],
		},
		{
			name: 'Jami Heffner',
			title: 'Store Operations Manager',
			picture: 'mar02/JamiHeffner.jpg',
			email: 'Jamih@diamondsdirect.com',
			phone: '',
			bio: [
				'Jami joined Diamonds Direct in 2009, and has over 20 years of experience in the jewelry industry. She has done sales, buying and inventory management. In her free time, Jami loves being a mother to her two sons and spending time with her husband of almost 20 years. She loves watching the many sporting events that her boys are involved in, reading a good book, and spending time outdoors.',
			],
		},
		{
			name: 'Kim West',
			title: 'Jeweler',
			picture: 'mar02/KimWest.jpg',
			email: 'kimw@diamondsdirect.com',
			phone: '',
			bio: [
				'Kim joined Diamonds Direct in 2008 bringing 20 years of experience with her. She started in the jewelry industry straight out of high school, and has been a bench jeweler ever since. She loves her work life at Diamonds Direct. In her spare time, Kim loves spending time with her 3 grown children and house full of animals.',
			],
		},
		{
			name: 'Kate Mills',
			title: 'Jeweler',
			picture: 'mar02/KateMills.jpg',
			email: 'kathleenm@diamondsdirect.com',
			phone: '',
			bio: [
				'Kate Joined Diamonds Direct in 2018 with 10 years of jewelry experience. She graduated from Ball State University with a Bachelor of Fine Arts Degree in Jewelry Design and Metal Smithing. Her daily goal is to drive for self-improvement and encourage others to be the best they can be. In her spare time, Kate loves to build things, craft and spend time with her family.'
			],
		},
		{
			name: 'Ross Arterberry',
			title: 'Jeweler',
			picture: 'mar02/RossArterberry.jpg',
			email: 'rossa@diamondsdirect.com',
			phone: '',
			bio: [
				'Ross joined Diamonds Direct in 2017 bringing 45 years of experience with him. He started his career as a bench jeweler right out of high school, after falling in love with industrial arts in school. Ross has won many design competitions for his work, and specializes in custom design & fabrication. In his spare time, he enjoys fixing up old cars, working on home improvement projects, & spending time with his wife, two children, and two grandchildren.',
			],
		},
		{
			name: 'Shelby Hubbard',
			title: 'Diamond Expert',
			picture: 'mar02/ShelbyHubbard.jpg',
			email: 'shelbyh@diamondsdirect.com',
			phone: '',
			bio: [
				'Shelby joined Diamonds Direct in 2019 after being in the jewelry industry for 5 years. She graduated from Indiana University-Purdue University Indianapolis with a degree in Criminal Justice but loved selling jewelry so much, she decided to continue it after graduation. Her favorite thing about being a Diamond Expert is being a part of the process and story that comes along with each and every client. In her free time, Shelby enjoys traveling, being a Dog Mom to her two fur-babies, and spending time with her boyfriend.',
			],
		},
		{
			name: 'Rachel Martin',
			title: 'Diamond Expert',
			picture: 'jun9/Rachel.jpg',
			email: 'rachelmartin@diamondsdirect.com',
			phone: '',
			bio: [
				'Rachel joined Diamonds Direct in 2019 after being in the jewelry business for 20 years in the greater Indianapolis area. She is honored to be a part of the Diamonds Direct Family. She takes pride in giving her guests the best customer experience, catering to them and creating forever friendships. Building relationships & creating special family heirlooms has been Rachel’s favorite part of her career. In her free time, Rachel loved spending time with her loving husband and 3 beautiful children. She enjoys refinishing furniture, painting murals, cooking, and learning to play the piano.',
			],
		},
		{
			name: 'Jenny Ervin',
			title: 'Diamond Expert',
			picture: 'mar02/JennyErvin.jpg',
			email: 'jennye@diamondsdirect.com',
			phone: '',
			bio: [
				'Jenny joined Diamonds Direct in 2019 with over 28 years in the jewelry industry in the greater Indianapolis area. Jenny specializes in custom design and creating heirloom pieces for her clients. To her, it is not selling jewelry, but creating memories for generations to come. Jenny is the mother of 7 wonderful children and wife to a wonderful man. In her free time, Jenny enjoys sitting on her back porch with her husband and children,reading and spending time with her parents. Family is the most important thing to Jenny, right next to diamonds.',
			],
		},
		{
			name: 'Grace Campbell',
			title: 'Back Office Support',
			picture: 'mar02/GraceCampbell.jpg',
			email: 'grace@diamondsdirect.com',
			phone: '',
			bio: [
				'Grace joined Diamonds Direct in 2011 starting her career in the jewelry industry. She started in reception, knows all departments, and has worked her way up. In her spare time, Grace loves spending time with her 2 beautiful children and 3 adorable dogs.',
			],
		},
		{
			name: 'Rebecca Byrd',
			title: 'Back Office Support',
			picture: 'mar02/RebeccaByrd.jpg',
			email: 'rebecca@diamondsdirect.com',
			phone: '',
			bio: [
				'Rebecca joined Diamonds Direct in 2013. She started in the Customer Care department and has knowledge of the whole store. Rebecca works part- time at the store & helps run her family’s farm the rest of the time. She loves spending time with her husband, baby girl, and 3 pets.',
			],
		},
		{
			name: 'Chrystal Behan',
			title: 'Diamond Expert',
			picture: 'jun9/Chrystal.jpg',
			email: '',
			phone: '',
			bio: [
				'Chrystal joined Diamonds Direct in 2020 with over a decade of fine jewelry and diamond experience. Chrystal loves getting to know her clients, and helping celebrate their life\'s most important moments. In her spare time she enjoys travel, watching football and bonfires.',
			],
		},
		{
			name: 'Michael Williams',
			title: 'Diamond Expert',
			picture: 'jun9/MichaelW.jpg',
			email: '',
			phone: '',
			bio: [
				'Michael joined the Diamonds Direct team in 2018 in our Richmond, VA location. He enjoys being a diamond expert with his clients because it allows him to be a part of one of the most important and memorable experiences of people’s lives. In his free time he has fun going out with his friends, visiting new places and enjoying what life has to offer.',
			],
		},
		{
			name: 'Claire Butler',
			title: 'Brand Ambassador',
			picture: 'Claire.jpg',
			email: '',
			phone: '',
			bio: [
				'Claire joined the Diamonds Direct family in December 2021. She has been in a customer service and marketing role since 2016. Claire enjoys community outreach in her role and loves philanthropy work. In her free time, you can find Claire shopping or going on walks with her dog, Kaiya.',
			],
		},
		{
			name: 'Jordan Geiger',
			title: 'Front Office Support',
			picture: 'Jordan.jpg',
			email: '',
			phone: '',
			bio: [
				'Jordan joined the Diamonds Direct family in January 2022. Jordan has been in a Customer Service role since 2017, and is very customer service oriented. In his free time, he enjoys photography, traveling, and loves trying different kinds of food.',
			],
		},
	],
	sponsorships: [
		{
			name: 'Indianapolis Colts',
			image: 'colts.jpg',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/2Y6ZisG',
		googleWrite: 'https://bit.ly/2Y6ZisG',
	}
};

const JAX = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Jacksonville',
	title: 'Diamonds Direct Jacksonville - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Jacksonville Location Today!',
	shortName: 'Jacksonville',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Diamonds always shine a little brighter in the Sunshine State! Visit our new showroom on Town Center Parkway for all your fashion and bridal jewelry needs. Located behind Firebirds, our stunning showroom hosts many fun events throughout the year. Keep an eye on our social media to see what’s coming up next.',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectJAX/',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	video: '',
	address: {
		line1: '4840 Town Center Parkway',
		line2: 'Jacksonville, FL 32246',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Jacksonville/@30.2524911,-81.5336816,17z/data=!3m1!4b1!4m5!3m4!1s0x88e5caa73f881a47:0x78dcc11fdfa9490b!8m2!3d30.2524865!4d-81.5314929',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 7pm',
			},
		],
		notice: '',
	},
	phone: '9045155959',
	email: 'infojax@diamondsdirect.com',
	team: [
		{
			name: 'Dovy Klarberg',
			title: 'Partner | President South',
			picture: 'dovyk.jpg',
			email: 'Dovy@DiamondsDirect.com',
			phone: '',
			bio: [
				'Dovy Klarberg, EVP, joined Diamonds Direct in 2008. He began his career in the diamond industry later in life after accepting a family offer. Klarberg served in the Israeli military in an elite unit until 1995. This experience gave him the opportunity to hold an important position in the Prime Minister\'s office until 2000. After retiring from the military, Klarberg began working in the software industry and became the Chief Operating Officer of one of the world\'s largest software companies, TesCom, headquartered in Israel. In this position, he led development of product quality assurance, configuration, and design.',
				'After seven years with TesCom, Dovy accepted a family offer to enter the diamond industry. This is when he joined Diamonds Direct\'s parent company and worked for the headquarters in Israel where he began learning the diamond trade. Klarberg became manager of the cutting facility and was finally asked to move to Charlotte, NC to help the retail location grow and develop as Senior Vice President.',
				'During Dovy\'s time with Diamonds Direct SouthPark, he has maintained focus on Diamonds Direct\'s unique concept and mission. As a result, Diamonds Direct has been honored as one of the top 20 independent jewelers in the United States. He continues to support and build the Diamonds Direct Foundation, a registered 501(c)3 organization, whose mission is to provide local women\'s and children\'s organizations with support, awareness, and fundraising tools so they may grow and thrive.',
				'His future aspirations include furthering the Diamonds Direct Foundation\'s impact and efforts within Charlotte, NC. He is also focused on making Diamonds Direct SouthPark\'s brand more ingrained in the local community.',
				'In his free time, Klarberg enjoys spending time with his wife, Keren, his two sons Bari and Ariel and his daughter Haylee. The family also enjoys exploring new restaurants and hosting friends and family for dinners and gatherings at their home.',
			],
		},
		{
			name: 'Kelly Flahardy',
			title: 'General Manager',
			picture: 'nov29/KellyLR.jpg',
			email: 'kellyf@diamondsdirect.com',
			phone: '',
			bio: [
				'Kelly Flahardy joined the Diamonds Direct family in 2018. He attended The University of Phoenix and has a BS in Business, with a concentration in Green and Sustainable Enterprise Management. In addition, he has achieved several Gemological Institute of America (GIA) certificates, including the GIA diamond grading laboratory. Flahardy has been in the jewelry industry for over 25 years. Previously, he was a multi-site operations manager in Boston and Central Florida. In his free time, Flahardy enjoys spending time with his wife and 3 sons. He is also an avid golfer and wine enthusiast.',
			],
		},
		{
			name: 'Heather Hutchinson',
			title: 'Back Office Manager',
			picture: 'nov29/HeatherLR.jpg',
			email: '',
			phone: '',
			bio: [
				'Heather Hutchinson, Back Office Manager is originally from Columbus, Ohio. Heather moved to Charlotte, NC to begin her career with Diamonds Direct in March 2017, before joining the Jacksonville team! With over 15 years in the industry, diamonds and gemstones are her hobby. She is currently pursuing a career dream by becoming a Graduate Gemologist through the Gemological Institute of America. In her free time she enjoys traveling to visit family all over the world, and spending time with her dog Hansel.',
			],
		},
		{
			name: 'Jordan Hardy',
			title: 'Special Orders Manager',
			picture: 'nov29/JordanLR.jpg',
			email: 'jordan@diamondsdirect.com',
			phone: '',
			bio: [
				'Jordan Hardy, Special Orders Manager has been with Diamonds Direct since August of 2017 and has over 5 years of retail experience. She was born and raised in Florida, and studied cosmetology before starting her career in retail. In her spare time, she does hair and makeup for weddings and special events. When she\'s not working, she enjoys spending time with her family, friends, and kittens.',
			],
		},
		{
			name: 'Amy Tomlinson',
			title: 'Diamond Expert',
			picture: 'nov29/AmyLR.jpg',
			email: 'amyt@diamondsdirect.com',
			phone: '',
			bio: [
				'Amy Tomlinson, Diamond Expert has been with Diamonds Direct since 05/2015. Amy is Diamond and Colored Gemstone certified by DCA (Diamond Council of America).',
				'Amy has 15 years of experience in the jewelry industry. She started her jewelry career in Albuquerque, New Mexico for Samuel’s Jewelers. Then she moved to San Antonio, Texas to become an Assistant General Manager for Jared The Galleria of Jewelry.',
				'Amy was born and raised in Jacksonville, Florida. After moving around the country for several years, she moved back to Jacksonville in 2015. She enjoys spending time with family, taking her dog for walks, and going out dancing.',
			],
		},
		{
			name: 'Nicole Alkhoury',
			title: 'Diamond Expert',
			picture: 'nov29/NicoleLR.jpg',
			email: 'nicolea@diamondsdirect.com',
			phone: '',
			bio: [
				'Nicole Alkhoury, Diamond Expert, has been with Diamonds Direct since June 2015. Nicole has recently graduated from University of North Florida with her Business Management and Marketing degree. She then received her certification from the Gemological Institute of America as an Applied Jewelry Professional. She absolutely loves being apart of her client\'s journey to pick out their perfect engagement ring and jewelry. Her goal is to make all of her clients feel at home by providing them with the best customer service and an overall memorable shopping experience! In Nicole\'s free time, she loves spending quality time with her family and friends. She also enjoys doing outdoor activities, working out, and trying new food! She loves to travel the world and will never pass up an opportunity to experience a new culture or tradition.',
			],
		},
		{
			name: 'Amanda Robinson',
			title: 'Diamond Expert',
			picture: 'nov29/AmandaLR.jpg',
			email: 'Amandar@diamondsdirect.com',
			phone: '',
			bio: [
				'Amanda has been with Diamonds Direct since January 2020. She has over 5 years in the jewelry industry and is a Certified GIA Applied Jewelry Professional. She is born and raised in Jacksonville, FL. In her free time she enjoys spending time with her husband, going to theme parks, and chasing around their many many fur babies.',
			],
		},
		{
			name: 'Zack Armour',
			title: 'Diamond Expert',
			picture: 'nov29/ZackLR.jpg',
			email: 'Zacharya@diamondsdirect.com',
			phone: '',
			bio: [
				'Zack began working in the jewelry industry as a teenager after high school. He’s been with Diamonds Direct since 2019. He has lived in Jacksonville since he was in elementary school and attended the University of North Florida with a focus in Marketing & Visual Design. Outside of his work at Diamonds Direct, Zack enjoys spending time with his daughter, teaching dance, collecting comic books, and doing graphic design.',
			],
		},
		{
			name: 'Alessandra Teodorescu',
			title: 'Diamond Expert',
			picture: 'nov29/AlessandraLR.jpg',
			email: 'alexandra@diamondsdirect.com',
			phone: '',
			bio: [
				'Alessandra Teodorescu, Diamond Expert has been with Diamonds Direct for since 2017. She has a Bachelor\'s Degree in Biomedical Sciences and Chemistry, and has 7 years of experience in retail and marketing. Alessandra was born and raised in Romania and moved to Jacksonville, Florida to reunite with her family at age 16. In her free time she enjoys cooking, working out, and spending time with her two fur babies Kyra and Esmee.',
			],
		},
		{
			name: 'Kayla Yarber',
			title: 'Jeweler',
			picture: 'nov29/KaylaLR.jpg',
			email: 'Kaylay@diamondsdirect.com',
			phone: '',
			bio: [
				'Kayla Yarber has been a Jeweler with Diamonds Direct since September of 2019. She spent several years overseas with her husband before moving back to the states to raise their two daughters. Finally in 2018 she found a passion for the jewelry industry. Having a background in commercial art provided a cornerstone to reaching the jewelers bench, where she has been for the past two years. In her spare time, she enjoys pursuing her passions of painting and sculpting.',
			],
		},
		
	],
	sponsorships: [
		{
			name: 'Jacksonville Jaguars',
			image: 'jags.jpg',
		},
	],
	awards: [
		{
			name: 'Bold City Best Finalist',
			image: 'finalist.png',
		},
		{
			name: 'The Fabulist',
			image: 'fabulist.png',
		},
		{
			name: 'Best in Jacksonville',
			image: 'best.jpg',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/2Wy4GVh',
		googleWrite: 'https://bit.ly/2Wy4GVh',
	}
};

const KCY = {
	template: 'store',
	currentPromo: false,
	title: 'Diamonds Direct Kansas City - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Kansas City Location Today!',
	name: 'Diamonds Direct Kansas City',
	shortName: 'Kansas City',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Kansas City to shop our latest arrivals and exclusive selection of diamond and fine jewelry.',
		'Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectkansascity',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '4500 W 119th Street',
		line2: 'Leawood, KS 66209',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Kansas+City/@38.9134995,-94.6407263,17z/data=!3m1!4b1!4m5!3m4!1s0x87c0e938d263b9cd:0x8cbade0dbc683b53!8m2!3d38.9134953!4d-94.6385376',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '9133121660',
	email: 'infoKSC@diamondsdirect.com',
	team: [
		{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: [
				'Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.',
				'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.',
				'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.',
				'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.',
			],
		},
		{
			name: 'Olga Elmanovich',
			title: 'Vice President',
			picture: 'sept10/Olga.jpg',
			email: 'olga@diamondsdirect.com',
			phone: '',
			bio: [
				'Originally from Russia, Elmanovich made her home in the United States in Birmingham, Alabama with her husband, Richard. As she earned a degree in linguistics from the University of Alabama at Birmingham, Olga found her passion for diamonds while working part time for Diamonds Direct. Shortly after completing her college education, she joined Diamonds Direct Birmingham fulltime and switched gears to focus on her diamond education. Olga gained her certification as a GIA Accredited Jewelry Professional and enjoyed her career and growth with the company.',
				'In 2018, Olga moved to Kansas City and was brought on to manage the new location. After managing the Leawood store for over two wonderful years, she was presented the opportunity to move to Frisco and continue her journey with Diamonds Direct in Texas. Olga has loved every minute of spending time here in Frisco and looks forward to making new memories here with her family.',
				'Today, Olga proudly serves as Vice President of the company, now overseeing the Frisco, Kansas City and Oklahoma City markets.',
			],
		},
		{
			name: 'Daniel Waters',
			title: 'General Manager',
			picture: 'sept10/DanielWaters.jpg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Angie Clow',
			title: 'Store Manager, DCA Graduate',
			picture: 'sept10/AngieClow.jpg',
			email: 'angiec@diamondsdirect.com',
			phone: '',
			bio: [
				'Angie Clow joined Diamonds Direct in September of 2018 with over 20 years of experience in luxury goods.',
				'Angie\'s experience includes store management, sales management, marketing and operations. She is a Diamond Council of America Graduate in Diamonds and Gemstones and has also completed several GIA courses. In her undergraduate years, Angie earned a Bachelor of Arts in Psychology and Business. Before entering the diamond business, Angie had a successful career as a banker before discovering her passion for jewelry. Throughout her career, Angie worked for national chains and also private jewelers.',
				'Angie and her husband have been married for over 20 years and have 3 children together—1 boy and 2 girls.',
			],
		},
		{
			name: 'Jodi Gray',
			title: 'Diamond Expert',
			picture: 'jodi_schoenberger.jpg',
			email: 'Jodi@DiamondsDirect.com',
			phone: '',
			bio: [
				'Jodi Schoenberger has been with Diamonds Direct since 2009. She has a Bachelor’s Degree in Exercise Science/Pre Med from Brigham Young University in Provo, Utah.',
				'Schoenberger was introduced to the jewelry industry after being a customer of Diamonds Direct., and then became part of the Diamonds Direct family. She was previously involved in the fitness industry helping others achieve their health goals.',
				'In her free time she enjoys teaching and taking Pure Barre, running, biking, and playing ball with her dog, Eddie.',
			],
		},
		{
			name: 'Enrique Chavez',
			title: 'Diamond Expert',
			picture: 'sept10/EnriqueChavez.jpg',
			email: 'enriquec@diamondsdirect.com',
			phone: '',
			bio: [
				'Enrique Chavez joined Diamonds Direct in September of 2018 as a Diamond Expert.',
				'Born and raised in Kansas City, Enrique graduated from Metropolitan Community College in Kansas City with a AAS Degree in Hotel and Restaurant Management.',
				'After a successful career in the insurance industry, Enrique found his passion for diamonds and entered the jewelry industry. Enrique has 18 years of jewelry experience in retail and performing jewelry remount shows.',
				'In his free time he loves cooking for family and friends. Enrique and his spouse Barbara play an integral part in raising their only grandson Chad who is 10.',
			],
		},
		{
			name: 'Astrid Cifuentes',
			title: 'Diamond Expert',
			picture: 'sept10/AstridCifuentes.jpg',
			email: '',
			phone: '',
			bio: [],
		},


		{
			name: 'Deborah Thompson',
			title: 'Front Office Support',
			picture: 'sept10/DeborahThompson.jpg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Eliana Harvey',
			title: 'Diamond Expert',
			picture: 'sept10/ElianaHarvey.jpg',
			email: '',
			phone: '',
			bio: [],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://bit.ly/2WuQtrY',
		googleWrite: 'https://bit.ly/2WuQtrY',
	}
}

const NOL = {
	template: 'store',
	currentPromo: false,
	title: 'Diamonds Direct New Orleans - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our New Orleans Location Today!',
	name: 'Diamonds Direct New Orleans',
	shortName: 'New Orleans',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in New Orleans to shop our latest arrivals and exclusive selection of diamond and fine jewelry.',
		'Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectnola',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '3230 Severn Ave',
		line2: 'Metairie, LA 70002',
	},
	googleMapsLink: 'https://www.google.com/maps/search/diamonds+direct+New+Orleans/@29.847419,-94.3551887,6z/data=!3m1!4b1',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '5043833900',
	email: 'infoNOLA@diamondsdirect.com',
	team: [
		{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'amit@diamondsdirect.com',
			phone: '',
			bio: [
				'Amit Berger, Executive Vice President and Market President, joined Diamonds Direct in 2008. Born in Israel, Berger grew up working in his family restaurant business and developed his gregarious personality and love of customer service. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry.',
				'In 1997, Berger came to the United States, working in the wholesale diamond trade. He traveled back and forth between Israel and 40 different states in the US selling diamonds to top jewelry stores across the US. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work in the wholesale diamond trade.',
				'In the meantime, his brother Itay, opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the industry. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.',
				'Berger moved to Birmingham, AL in 2008 to open Diamonds Direct’s second location. After years of successfully making the Birmingham store part of the fabric of the community, Berger and his family moved to Dallas, TX to help the Diamonds Direct brand flourish in the Longhorn State. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. They love Texas and the diverse culture the state has to offer. Their favorite thing to do as a family is play with their dog Ziggy and travel.',
			],
		},
		{
			name: 'Yoni Padan',
			title: 'Vice President',
			picture: 'Yoni.jpg',
			email: 'yoni@diamondsdirect.com',
			phone: '',
			bio: [
				'Yoni Padan joined Diamonds Direct in January of 2012. He was Born in Israel and moved to the United States in 1989. Padan graduated with an international business degree from the University in Herzliya. In 2008, Padan came back to the US and joined Diamonds Direct in 2012. Since the beginning of his career at Diamonds Direct, he made sure to always keep the special thing that makes Diamonds Direct what is, family. "The family spirit of Diamonds Direct penetrates from our staff to our customers and that is why the relationship between us and the customer is so special. I love what I do, and its great waking up every morning feeling that way."',
				'In July of 2012, Yoni met his beautiful wife Natasha. They are now very happily married with three boys, Brandon, Ariel and Daniel. He enjoys spending every free second he has with them.',
			],
		},
		{
			name: 'Cesar Fuentes',
			title: 'Store Manager',
			picture: 'Cesar.jpg',
			email: 'CesarF@diamondsdirect.com',
			phone: '',
			bio: [
				'Cesar Fuentes was born in Mexico and has been a long time native of New Orleans. He has spent 32 years in the jewelry industry on both the wholesale and retail sides. He is passionate about customer service and brings vast knowledge of diamonds to the team.',
				'Cesar joined the Diamonds Direct team in 2019 as a Diamond Expert.',
				'When Cesar is not assisting clients, he enjoys playing soccer, football, and basketball with his three sons. He also enjoys traveling to the beach with his family and exploring the wonderful things life has to offer.',
			],
		},
		{
			name: 'Adissack Chung',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'Adi.jpg',
			email: 'AdiC@diamondsdirect.com',
			phone: '',
			bio: [
				'Adissack "Adi" Chung has more fun selling jewelry than a flying squirrel at a trampoline park.  He has spent the last 32 years in the jewelry industry, owning his own store on the east coast, managing the entire west coast for a California based jeweler, traveling the United States as a sales representative of a major bridal designer, or floating down a lazy river in Texas.  After Studying at Wingate College in North Carolina, where he majored in business, he began his jewelry career as a salesman for a local jeweler. He enjoyed the area, and the connections that he shared with the community so much, that he purchased the business several years later.',
				'After years of successfully servicing the jewelry needs of both Carolinas, Adi needed to return home to his family in California and joined an up and coming local jeweler. When he was satisfied with his contributions and free to pursue his love of traveling, Chung joined a nationally recognized bridal designer and traveled the United States sharing new designs with jewelers and customers alike.',
				'When Diamonds Direct New Orleans opened in 2019, Adi joined them and enjoys the culture of Louisiana and the gulf coast.',
				'In Chung\'s time outside of work he loves to travel and spend time with his beloved Shelly and their adorable Yorkie puppies.',
			],
		},
		{
			name: 'Sasha Sergutin',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'Sasha.jpg',
			email: 'SashaS@diamondsdirect.com',
			phone: '',
			bio: [
				'Sasha Sergutin was born in the Ukraine and moved to the USA in 1995. She worked in the Automotive Industry as a financial specialist for Ford Motors in the Northeast and Southern States. While her financial career was fulfilling, what she really enjoyed was meeting new clients and finding the perfect solution to their needs. This led to her transition to the jewelry industry over ten years ago. She has worked in various sales and leadership roles where she most enjoyed meeting couples and hearing the stories of how they met and fell in love. Sasha finds that continually increasing her expertise in the world of diamonds helps her to meet the needs of her clients more effectively. She has obtained a Diamontology Certification from the Diamond Council of America and seeks new learning opportunities constantly.',
				'Her love of Diamonds and the culture of New Orleans led her to join Diamonds Direct New Orleans in 2019 as a Diamond Expert.',
				'When Sergutin is not helping couples in love find the perfect expression of love, she loves to travel the world, experiencing different beaches with her travel companion, a long haired dachshund named Mila (Meel-Meel, to her friends).',
			],
		},
		{
			name: 'Leslie Gambino',
			title: 'Back Office Manager',
			picture: 'Leslie.jpg',
			email: 'LeslieGambino@diamondsdirect.com',
			phone: '',
			bio: [
				'Leslie Gambino is a New Orleans native and graduated from Louisiana State University with a Bachelor of Interior Design. While in design school, she was a brand Ambassador with Dior cosmetics where she was introduced to luxury brands and their clientele in the area.  She’s been in the local jewelry industry for 12 years with Mignon Faget, Ltd. in many roles including sales and operations. Her keen eye for detail and ability to connect with everyone she meets has helped many of her clients find the perfect engagement ring for their love story.',
				'Outside of work, she has an extensive bucket list that includes many travel destinations. Currently, Iceland and Greece are on deck along with frequent trips to Disney World and her regularly scheduled 2 Saints away games per year. Who Dat?! When she’s not traveling, she’s making custom decorated sugar cookies and can be found at brunch on Sundays, trying out every new restaurant in the city.',
				'She and her boyfriend have 3 cats and 2 dogs and always have a lint roller handy.',
			],
		},
		{
			name: 'Geary McDonald',
			title: 'Jeweler',
			picture: 'geary.jpg',
			email: '',
			phone: '',
			bio: [
				'Geary McDonald has been with Diamonds Direct since we expanded to New Orleans in 2019. He graduated from Natchitoches Vo-Tech Jewelry Tech, and has been a jeweler for over 30 years. He has practiced his trade exclusively on the Gulf Coast for the entirety of his career. In his free time, he enjoys spending time with his wife and daughter.',
			],
		},
		{
			name: 'Amanda Fekete',
			title: 'Diamond Expert, DCA Graduate',
			picture: 'Amanda.jpg',
			email: '',
			phone: '',
			bio: [],
		},
	],
	sponsorships: [
		{
			name: 'Tulane',
			image: 'tulane.jpg',
		},
		{
			name: 'LSU',
			image: 'lsu.jpg',
		},
		{
			name: 'Jefferson Chamber of Commerce',
			image: 'jeff_chamber.jpg',
		},
		{
			name: 'LGBT Chamber of Commerce',
			image: 'gulfsouth_lgbq.jpg',
		},
		{
			name: 'New Orleans Chamber of Commerce',
			image: 'nola_chamber.jpg',
		},
		{
			name: 'New Orleans Yes Girls',
			image: 'nola_yesgirls.jpg',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/3mg8WBp',
		googleWrite: 'https://bit.ly/3mg8WBp',
	}
};

const NVA = {
	template: 'store',
	currentPromo: false,
	title: 'Diamonds Direct Tysons - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Tysons Location Today!',
	name: 'Diamonds Direct Tysons',
	shortName: 'Tysons',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Tysons to shop our latest arrivals and exclusive selection of diamond and fine jewelry.',
		'Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirecttysons',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '8113 Leesburg Pike',
		line2: 'Vienna, VA 22182',
	},
	googleMapsLink: 'https://www.google.com/maps/dir//8113+Leesburg+Pike,+Vienna,+VA+22182/@38.9146128,-77.2281991,17z/data=!4m9!4m8!1m0!1m5!1m1!1s0x89b64ae455273ecf:0x548765f386e31436!2m2!1d-77.2260104!2d38.9146086!3e0',
	hours: {
		default: [
			{
				days: 'Monday - Wednesday',
				hours: '10am - 7pm',
			},
			{
				days: 'Thursday',
				hours: '10am - 8pm',
			},
			{
				days: 'Friday',
				hours: '10am - 8pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 7pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '5713076220',
	email: 'infoTYS@diamondsdirect.com',
	team: [
		{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: [
				'Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.',
				'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.',
				'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.',
				'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.',
				'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.',
			],
		},
		{
			name: 'Ori Ben Amitai',
			title: 'Vice President, Virginia',
			picture: 'ori_amitai.jpg',
			email: 'Ori@DiamondsDirect.com',
			phone: '',
			bio: [
				'Ori Ben Amitai, Vice President, has been with Diamonds Direct since 2012. He attended Bar -Ilan University in Israel where he studied Industrial Practical Engineering. Previously, Ori was working for the diamond cutting facilities of the company in the Israeli diamond district.',
				'Born in Ramat Gan, Israel in 1984 and raised in Herzelia, Ben Amitai joined the Israeli defense forces in 2003 and served for 3 years. The military experience gave him great tools to appreciate the good things in life; his wife, family and close friends. The army experience also taught him a new way of life - always be on time never late, be honest with people, and never be afraid of the truth. In 2012 he started to explore the world of diamonds in the diamond cutting facilities of Diamond’s Direct in Ramat Gan, Israel, where he fell in love with them immediately. After one year of experience in the diamond district he was selected to join the company’s other side of the business, the direct-to-the-public stores. He started his way in the Raleigh location where he learned and work with Barak Henis (Vice President of the Raleigh and the Richmond location). Ori then relocated when the company opened its 4th location in Richmond, Virginia. He sees an amazing future to the Richmond market, and puts all his effort in establishing Diamonds Direct as a strong brand in the community. In his free time Ori likes to travel with his wife and his dog exploring Richmond and its surrounding cities.',
			],
		},
		{
			name: 'Rahul Vohra',
			title: 'General Manager',
			picture: 'jun26/Rahul.jpg',
			email: 'rahulv@diamondsdirect.com',
			phone: '',
			bio: [
				'Rahul Vohra has been with Diamonds Direct since 2020. He has a Bachelor Degree from University of Maryland and has over 25 years experience in the Jewelry industry.',
				'He  was born in Silver Spring, Maryland, but has also lived in:  New Jersey, Virginia,Washington DC , North Carolina before settling back home in Maryland. In his free time he enjoys cheering for the Washington Commanders Football Team,spending time with his wife and two kids, and exercising.',
			],
		},
		{
			name: 'Ray Sindac',
			title: 'Diamond Expert',
			picture: 'jun26/RAY.jpg',
			email: 'Ray@DiamondsDirect.com',
			phone: '',
			bio: [
				'Ray Sindac has been with Diamonds Direct since January 2018. He is certified by the Diamond Council of America and has a Bachelor\'s Degree in Business Administration & Management from the University of Maryland University College.',
				'Ray started his career in jewelry 13 years ago where he started as a Jewelry Consultant and ended a position as a District Manager. Ray is a father to a wonderful soon-to-be 4-year old boy who is currently obsessed with Monster Jams. He enjoys spending every minute with him.',
			],
		},
		{
			name: 'Andrea Mitchell',
			title: 'Diamond Expert',
			picture: 'jun26/ANDREA.jpg',
			email: 'Andreami@diamondsdirect.com',
			phone: '',
			bio: [
				'Andrea has an impressive luxury sales and management background with more than 15 years experience with Cartier, Bulgari, and Saks Fifth Avenue. She had been selected to attend training sessions in NY, Paris, Switzerland, Dubai, and Italy.',
				'Andrea loves spending time with family and friends and has a passion for travel. She is thankful that retail has allowed her to travel and experience many different cultures. She often says that she has been both student and teacher.',
			],
		},
		{
			name: 'Kay Suy',
			title: 'Diamond Expert',
			picture: 'jun26/KAY.jpg',
			email: 'Kays@diamondsdirect.com',
			phone: '',
			bio: [
				'Kay has been in the jewelry business for over 20 years and joined the Diamonds Direct family in 2021. He was born in Cambodia during the war also known as the "Killing Field". Kay and his family knew that they needed to flee Cambodia if they had any hope of any future and eventually landed in Montreal, Quebec Canada. He spent his childhood going to school in France and loved playing ice hockey.  Right after high school, he moved to the Washington, D.C. area and started a small jewelry business with his parents in Georgetown. He eventually left to study at the Gemological Institute of America (G.I.A) in Carlsbad, CA and graduated as an Graduate Gemologist in 2001. He is also a proud father of twin boys: Kayden and Jayden and a little girl named Akira.',
			],
		},
		{
			name: 'Linda Foy',
			title: 'Diamond Expert',
			picture: 'jun26/LINDA.jpg',
			email: 'Lindaf@diamondsdirect.com',
			phone: '',
			bio: [
				'Linda Foy joined the Diamonds Direct team in 2020, sharing her passion for luxury service with clients. Before joining the Diamonds Direct team, Linda worked in the jewelry industry onboard cruise ships in the Caribbean, Alaska and South America for seven years. In addition to working in the Tyson’s Corner store, Linda has also worked in our Dallas, Frisco, and Raleigh locations.',
				'In her free time Linda has a love for traveling, cooking, spending time with her daughter, and her pets.',
			],
		},
		{
			name: 'Tina Sindac',
			title: 'Back Office Manager',
			picture: 'jun26/TINA.jpg',
			email: 'TinaS@diamondsdirect.com',
			phone: '',
			bio: [
				'Tina Sindac rejoined the Diamonds Direct family back in May of 2021, and has over 9 years experience with Customer Service, holding many different positions with Diamonds Direct. She graduated from Carson-Newman University in 2011 with a Bachelor\'s Degree in Applied Psychology.   In her spare time she likes to spend time with her nephew and travel throughout the country to see family, friends, and new sights!',
			],
		},
		{
			name: 'Lora Price',
			title: 'Shop Manager',
			picture: 'jun26/LORA.jpg',
			email: 'lora@diamondsdirect.com',
			phone: '',
			bio: [
				'Lora Price has been with Diamonds Direct since 2016. She graduated from VCU with dual Bachelor’s degrees in English and Craft/Material Studies, and respective focuses in mythology and jewelry.',
				'In her spare time, she continues to create her own art, go for walks around Richmond, and explore various breweries and restaurants with her friends.',
			],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://www.google.com/search?q=diamonds+direct+tysons+corner&sxsrf=APq-WBs1_F_YMr4fPKw1kuas2wgk_edWXw%3A1646328568601&source=hp&ei=-PogYvXcHoTLkPIPw9OjgAE&iflsig=AHkkrS4AAAAAYiEJCDx4QFNGyj61yqf8Q_uS5KCFVXY7&oq=diamonds&gs_lcp=Cgdnd3Mtd2l6EAEYADIECCMQJzIECCMQJzIECCMQJzIOCC4QgAQQsQMQxwEQrwEyCwguEIAEEMcBEK8BMgUIABCRAjILCC4QxwEQrwEQkQIyCAguEIAEELEDMgUILhCABDIFCAAQgAQ6BwgjEOoCECc6DQguEMcBEKMCEOoCECc6CgguEMcBEK8BECc6CgguEMcBEK8BEEM6DgguEIAEELEDEMcBEKMCOggIABCxAxCDAToICAAQgAQQsQM6BAgAEEM6BAguEEM6BwguENQCEEM6CgguEMcBEKMCEEM6DQguELEDEMcBEK8BEEM6DgguELEDEMcBEK8BEJECULcJWNAOYMMeaAFwAHgBgAF8iAG_BpIBAzMuNZgBAKABAbABCg&sclient=gws-wiz',
		googleWrite: 'https://www.google.com/search?q=diamonds+direct+tysons+corner&sxsrf=APq-WBs1_F_YMr4fPKw1kuas2wgk_edWXw%3A1646328568601&source=hp&ei=-PogYvXcHoTLkPIPw9OjgAE&iflsig=AHkkrS4AAAAAYiEJCDx4QFNGyj61yqf8Q_uS5KCFVXY7&oq=diamonds&gs_lcp=Cgdnd3Mtd2l6EAEYADIECCMQJzIECCMQJzIECCMQJzIOCC4QgAQQsQMQxwEQrwEyCwguEIAEEMcBEK8BMgUIABCRAjILCC4QxwEQrwEQkQIyCAguEIAEELEDMgUILhCABDIFCAAQgAQ6BwgjEOoCECc6DQguEMcBEKMCEOoCECc6CgguEMcBEK8BECc6CgguEMcBEK8BEEM6DgguEIAEELEDEMcBEKMCOggIABCxAxCDAToICAAQgAQQsQM6BAgAEEM6BAguEEM6BwguENQCEEM6CgguEMcBEKMCEEM6DQguELEDEMcBEK8BEEM6DgguELEDEMcBEK8BEJECULcJWNAOYMMeaAFwAHgBgAF8iAG_BpIBAzMuNZgBAKABAbABCg&sclient=gws-wiz',
	}
};

const OKC = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Oklahoma City',
	title: 'Diamonds Direct Oklahoma City - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Oklahoma City Location Today!',
	shortName: 'Oklahoma City',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Shopping for your next piece of jewelry will come sooner than you think and our diamond experts are always here to make the purchase a breeze. You’ll leave our showroom across from Penn Square Mall feeling much better than OK about the gift in your bag.',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectokc/',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '5521 North Pennsylvania Ave',
		line2: 'Oklahoma City, OK 73112',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Oklahoma+City/@35.5249928,-97.5502213,17z/data=!3m1!4b1!4m5!3m4!1s0x87b21a6aeb42c02d:0xc3b558b8e6e2aa1b!8m2!3d35.5249885!4d-97.5480326',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '4056088802',
	email: 'infoOKC@diamondsdirect.com',
	team: [
		{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: [
				'Amit Berger, EVP, founded Diamonds Direct Birmingham in 2008. He joined the Diamonds Direct parent company in 1995 in Israel while working in the cutting facility and learning the trade\'s secrets.',
				'Born in Israel, Berger grew up working in his family restaurant business and developed his love of customer service and gregarious personality. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry. It was then when he started working for Diamonds Direct\'s parent company in the cutting facility with the founder of the company.',
				'In 1997, Berger came to the United States to begin working one on one with big diamond buyers. He traveled back and forth between Israel and 40 different states in the US working for Diamonds Direct\'s parent company in the wholesale division. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work with Diamonds Direct\'s parent company in the wholesale office and selling diamonds to top jewelry stores around the country. Eventually, Berger was running the wholesale division and was in charge of selecting diamonds from the cutting facility in Israel.',
				'In the meantime, his brother Itay, had opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the company. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.',
			],
		},
		{
			name: 'Yosi Mayer',
			title: 'Vice President',
			picture: 'yosi_mayer.jpg',
			email: 'yosi@diamondsdirect.com',
			phone: '',
			bio: [
				'Yosi Mayer, Vice President, joined the Diamonds Direct family in 2016.',
				'Born in Israel, Mayer served in the Israeli Military for three years in the Paratroopers Brigade. For the past 16 years Mayer has worked in the diamond and jewelry industry all over the world with experience ranging from wholesale to retail.',
				'Mayer\'s career in the industry began in 2000, in retail sales for a major jewelry chain in Mexico and the Caribbean. From there, he worked his way up the ladder to manage several stores in a General Manager capacity. In 2008 Mayer decided it was time to move back to Israel, where he continued to work in the industry only this time as a Sales Manager and Buyer for leading wholesale firms at the Israeli Diamond Exchange.',
				'In 2016 Mayer met Itay Berger – President of Diamonds Direct and understood that joining the company would allow him to keep pursuing his passion for exceptional customer service, team leading and business development. For that reason, he made the decision to move his family to Dallas.',
				'Mayer is married to his high-school sweetheart Liz. They have two lovely daughters and a dog. He enjoys spending time with his family while exploring Dallas and the surrounding areas. He takes interest in learning different cultures and languages and is a self proclaimed foodie, always chasing the next great meal.',
			],
		},
		{
			name: 'Olga Elmanovich',
			title: 'Vice President',
			picture: 'KC_Olga_Elmanovich.jpg',
			email: 'olga@diamondsdirect.com',
			phone: '',
			bio: [
				'Originally from Russia, Elmanovich made her home in the United States in Birmingham, Alabama with her husband, Richard. As she earned a degree in linguistics from the University of Alabama at Birmingham, Olga found her passion for diamonds while working part time for Diamonds Direct. Shortly after completing her college education, she joined Diamonds Direct Birmingham fulltime and switched gears to focus on her diamond education. Olga gained her certification as a GIA Accredited Jewelry Professional and enjoyed her career and growth with the company.',
				'In 2018, Olga moved to Kansas City and was brought on to manage the new location. After managing the Leawood store for over two wonderful years, she was presented the opportunity to move to Frisco and continue her journey with Diamonds Direct in Texas. Olga has loved every minute of spending time here in Frisco and looks forward to making new memories here with her family.',
				'Today, Olga proudly serves as Vice President of the company, now overseeing the Frisco, Kansas City and Oklahoma City markets.',
			],
		},
		{
			name: 'Ibrahim Arch',
			title: 'General Manager',
			picture: 'aug27a/Ib2.jpg',
			email: '',
			phone: '',
			bio: [
				'Ibrahim Arch, General Manager, joined the Diamonds Direct family in 2019.',
				'From growing up in the Cayman Islands, to living in the Middle East and his years spent traveling through Europe, Ibrahim brings a unique, international perspective to the Oklahoma City market. Ibrahim’s driving factor is his deep appreciation for and interest in interconnectivity and the human condition. He is passionate about the close relationships he is able to form with his Rhino team and OKC clients. These connections inspire him daily.',
				'In and out of the showroom, Ibrahim is a big believer in hard work and service leadership. In his personal time, he cultivates life balance by spending quality time with his family, taking care of his health by exercising and eating healthy and growing as a person through a constant pursuit of knowledge.',
			],
		},
		{
			name: 'Alicia Merrick',
			title: 'Marketing & Merchandising Manager',
			picture: 'aug27a/Alicia.jpg',
			email: '',
			phone: '',
			bio: [
				'Alicia Merrick, Marketing and Merchandising Manager, joined the Diamonds Direct family in 2021. She brings a blended creative background made up of event planning, marketing, and digital media. Originally from Yukon Oklahoma, she graduated with a degree from the University of Central Oklahoma in Strategic Communications and is a current student at the University of Oklahoma- College of Law. She has worked in event and marketing management for Oklahoma City based restaurants, residential housing, and the Chickasaw Nation.',
				'In her free time she enjoys traveling and enjoying Oklahoma Cities restaurants and culture.',
			],
		},
		{
			name: 'Stevie Barnes',
			title: 'Back Office Support',
			picture: 'steve_barnes.jpg',
			email: 'stevieb@diamondsdirect.com',
			phone: '',
			bio: [
				'Stevie Barnes, Back Office Support, joined the Diamonds Direct family in 2015.',
				'Stevie Barnes joined the Diamonds Direct team in 2015. Barnes began her career in the jewelry industry in 2004, previously working at Helzberg Diamonds and Samuel Gordon Jewelers. Stevie’s customer service skills are a continued asset to the Oklahoma City back office team.',
				'Barnes lives in Oklahoma City with her husband. She enjoys spending time with her family and dogs, watching football, and reading.',
			],
		},
		{
			name: 'Motoko Hulme-Baldwin',
			title: 'Diamond Expert',
			picture: 'motoko2.jpg',
			email: 'mhulme@diamondsdirect.com',
			phone: '',
			bio: [
				'From earning a degree in Criminal Justice from the University of Central Oklahoma and starting a family, Motoko brings a compassionate outlook to Diamonds Direct Oklahoma City. Being a DCA Graduate and bringing over 20 years of experience in the professional jewelry industry, Motoko is a light of knowledge to her team. She cares deeply for every customer that enters Diamonds Direct and includes them as the Diamonds Direct family.',
				'When she is not in the showroom, Motoko spends her quality time with her intimate family and friends. She can be found riding with her husband in their Slingshot and spending time with her grandsons. Motoko’s greatest achievements with Diamonds Direct have been developing her passion for custom designs while working as a sales representative for prestigious brands.',
			],
		},
		{
			name: 'James Harrison',
			title: 'GIA Graduate Gemologist',
			picture: 'aug27a/James.jpg',
			email: 'JamesH@diamondsdirect.com',
			phone: '',
			bio: [
				'James Harrison, Diamond Expert, joined the Diamonds Direct family in September 2018. His jewelry industry background began in 1982. He Graduated from the esteemed Gemological Institute of America in 1988 receiving his Graduate Gemologist Diploma. He has worked in almost every facet of the industry from diamond and gemstone buyer, Appraiser, Sales and Retail General Manager for the past 20 years.',
				'In his free time he enjoys writing songs and playing guitar as well as spending quality time with his wife and son.',
			],
		},
		{
			name: 'Steven McKnight',
			title: 'Shop Manager',
			picture: 'aug27a/Steven.jpg',
			email: '',
			phone: '',
			bio: [
				'Steven McKnight, Shop Manager, Joined the Diamonds Direct family in 2020. Steven is certified from the Institute of Jewelry Training. With a deep rooted knowledge of the jewelry industry, he adds over 30 years of experience to the Diamond Direct family. His knowledge helps to guide Diamonds Direct in all customer needs.',
				'In Steven’s free time, he can be found fishing and playing golf.',
			],
		},
		{
			name: 'Sarah Permenter',
			title: 'Back Office Manager',
			picture: 'aug27a/Sarah.jpg',
			email: '',
			phone: '',
			bio: [
				'Sarah Permenter, Back Office Manager, joined the Diamonds Direct family in 2018.',
				'Sarah has paved her way through the Oklahoma City store from beginning as the Front Office Manager in 2018. During the transition of moving to a new department- she took the opportunity and flourished! Sarah’s background in Early Childhood Care has enabled her to bring over vast skills such as; dedication and resistance to the Diamonds Direct back office team.',
				'In Sarah’s free time she enjoys hiking, watching movies, and spending time with friends.',
			],
		},
		{
			name: 'Dana Robinson',
			title: 'Diamond Expert',
			picture: 'aug27a/Dana.jpg',
			email: '',
			phone: '',
			bio: [
				'Dana Robinson, Diamond Expert, joined the Diamonds Direct family in 2019. Dana offers a extensive background in sales and the jewelry industry. Having spent over 19 years in the industry she has a deepened understanding of the value that each customer brings to the rhino family.',
				'When she is not dedicating her time to each of his customers, she enjoys spending time with her family.',
			],
		},
		{
			name: 'Nickie McCarty',
			title: 'Diamond Expert',
			picture: 'nickie.jpg',
			email: '',
			phone: '',
			bio: [
				'Nickie McCarty joined the Diamonds Direct team in 2020. Nickie has held numerous professional roles in sales and insurance. With a passion for people, she relocated from Kentucky to Oklahoma to pursue new career opportunities with Diamonds Direct. Nickie’s continued joy of growth is a continued asset to the Oklahoma City team.',
				'When not at Diamonds Direct, she can be found spending time with her friends and family exploring all things fun and exciting in the heart of Oklahoma City.',
			],
		},
		{
			name: 'Cindy Graham',
			title: 'Diamond Expert',
			picture: 'CindyG.jpg',
			email: '',
			phone: '',
			bio: [
				'Cindy Graham, Diamond Expert, joined Diamonds Direct in 2021. She has held over 20 years of experience in the diamond industry and sales as well as is GIA certified. Cindy is knowledgeable and informative for all current and new clients of Diamonds Direct. Cindy’s passion for her role is an asset to the Oklahoma City team.',
				'Cindy can be found spending time with her family when not dedicating herself to the Oklahoma City team. She enjoys sports, enjoying OKC’s local entertainment, and meeting everyone she can.',
			],
		},
	],
	sponsorships: [
		{
			name: 'Oklahoma Sooners',
			image: 'ou.jpg',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/3ipA0x6',
		googleWrite: 'https://bit.ly/3ipA0x6',
	}
};

const PIT = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Pittsburgh',
	title: 'Diamonds Direct Pittsburgh - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Pittsburgh Location Today!',
	shortName: 'Pittsburgh',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Pittsburgh to shop our latest arrivals and exclusive selection of diamond and fine jewelry. Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectpittsburgh',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '5004 McKnight Rd.',
		line2: 'Pittsburgh, PA 15237',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Pittsburgh/@40.5337875,-80.0126722,17z/data=!3m1!4b1!4m5!3m4!1s0x88348bbcfac54495:0xc67af54422512c31!8m2!3d40.5337834!4d-80.0104782',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '4128379070',
	email: 'infoPITT@diamondsdirect.com',
	team: [
		{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: [
				'Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.',
				'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.',
				'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.',
				'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.',
				'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.',
			],
		},
		{
			name: 'Tery Vari',
			title: 'Vice President, OH',
			picture: 'tery.jpg',
			email: 'TeryV@DiamondsDirect.com',
			phone: '',
			bio: [
				'Tery Vari, Vice President, has been with Diamonds Direct since 2011. He received his Bachelors of Science in Marketing from Ohio State University.',
				'Vari has been in the diamond and jewelry industry for over 20 years. Previously, he was the General Manager for Jared, the Galleria of Jewelry and the District Manager for Reeds Jewelers.',
				'In his free time, Vari enjoys spending time with his wife and two sons and is active in the community.',
			],
		},
		{
			name: 'Heidi Andrews',
			title: 'General Manager',
			picture: 'dec7/Heidi.jpg',
			email: 'HeidiA@diamondsdirect.com',
			phone: '',
			bio: [
				'Heidi Andrews started her journey with the Diamonds Direct family in Columbus Ohio in August 2018.',
				'In 2004, Andrews had started her career in the jewelry industry as various leadership roles in Ohio, Pennsylvania and North Carolina.', 
				'To this day she values all the relationships that she has made through the years and seeing all the special moments unfold with every one of them! In her spare time, she enjoys spending time with her husband Duane and their adorable Shih Tzu, Hank.',
			],
		},
		{
			name: 'Stuart Bowles',
			title: 'Shop Manager',
			picture: 'dec7/Stuart.jpg',
			email: 'Stuart@diamondsdirect.com',
			phone: '',
			bio: [
				'Stuart joined the Diamonds Direct family in 2016 in his home state of Indianapolis, and managed our Cleveland shop until Pittsburgh opened in early 2021. He has since earned certifications through Jewelers of America and Stuller.  Stuart maintains many hobbies outside of work such as 3D printing, tabletop gaming, Facebook Marketplace window shopping, as well as avidly pursing a revived passion for archery and outdoor life.  Stuart and his wife Ashley have two boys and have taken a great liking to the wooded hills of northern Pittsburgh, as well as the parks and unique foodie spots available all around them.',
			],
		},
		{
			name: 'Mikayla Wykle',
			title: 'Diamond Expert',
			picture: 'apr6/Mikayla.jpeg',
			email: 'MikaylaW@diamondsdirect.com',
			phone: '',
			bio: [
				'Mikayla Wykle, Diamond Expert, has been with Diamonds Direct since early 2020. She made her way to Diamonds Direct shortly after she received her Bachelors of Science Degree in December of 2019 from Ohio University. Wykle has been in the jewelry industry since roughly 2015. She worked as a Sales Associate and Inventory Control Specialist for five years with another major jewelry company before becoming a part of the Diamonds Direct family. She has a passion for creating an unsurpassed customer experience each and every time someone walks into the showroom.  In her free time, she enjoys playing pool, making music, and creating memories with friends and family.',
			],
		},
		{
			name: 'Jessica Hart',
			title: 'Back Office Manager',
			picture: 'apr6/Jessica.jpeg',
			email: 'JessicaH@diamondsdirect.com',
			phone: '',
			bio: [
				'Jessica Hart, joined the Diamonds Direct family in early 2021. Originally from Lafayette, Indiana, Jessica attended Indiana University Bloomington studying journalism and political science. She has over 14 years experience in the jewelry and retail industries. In her free time, Jessica enjoys reading, travelling with her husband, and watching movies.',
			],
		},
		{
			name: 'Melanie Burke-Pohl',
			title: 'Diamond Expert',
			picture: 'dec7/Melanie.jpg',
			email: 'melanieb@diamondsdirect.com',
			phone: '',
			bio: [
				'Melanie Burke-Pohl joined the Diamonds Direct family in 2021 as a Diamond Expert, but has been in the jewelry industry for over 28 years. She began selling and romancing diamonds at Service Merchandise in 1993. Following that, became a diamond and jewelry buyer for over 23 years at Goldstock Jewelers. After Goldstock closed their doors, she worked at Orr\'s Jewelers. In her spare time, she loves yoga, wine, and enjoying new experiences.', 
			],
		},
		{
			name: 'Emily Reinhart',
			title: 'Brand Ambassador',
			picture: 'dec7/Emily.jpg',
			email: 'emilyr@diamondsdirect.com',
			phone: '',
			bio: [
				'Emily came to Diamonds Direct in July 2021 from the fashion industry.  She graduated from the Fashion Institute of Technology in 2015 and started her career in New York City working in a luxury showroom on Fifth Avenue.  Having grown up in the South Hills of Pittsburgh, she moved back in 2018 where she spent some time as a pricing analyst, and more recently a personal stylist.  She loves natural gemstones and using her knowledge to help clients find the right styles for them!',
			],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://bit.ly/3okQzOy',
		googleWrite: 'https://bit.ly/3okQzOy',
	}
};

const RAL = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Raleigh',
	title: 'Diamonds Direct Raleigh - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Raleigh Location Today!',
	shortName: 'Raleigh',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Conveniently located outside Crabtree Valley Mall, Diamonds Direct has been proud to call Raleigh home since 2008. Whether you’re shopping for the perfect blue or red accessory for football or basketball season, or popping the question to the love of your life, our diamond experts have you covered!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectcrabtree',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '4401 Glenwood Avenue',
		line2: 'Raleigh, NC 27612',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Crabtree/@35.8391239,-78.678694,17z/data=!3m1!4b1!4m5!3m4!1s0x89acf63f665b90d5:0x31b889ab95b95172!8m2!3d35.8391196!4d-78.6765053',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '9195712881',
	email: 'infoRal@diamondsdirect.com',
	team: [
		{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'aug27/barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: [
				'Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.',
				'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.',
				'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.',
				'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.',
				'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.',
			],
		},
		{
			name: 'Lev Shnaidman',
			title: 'Vice President, Raleigh',
			picture: 'aug27/lev_shnaidman.jpg',
			email: 'Lev@DiamondsDirect.com',
			phone: '',
			bio: [
				'Lev Shnaidman, Vice President, has been with Diamonds Direct since 2012. He has a Bachelor\'s Degree in Hospitality Management from Florida International University where he graduated Magna Cum Laude.',
				'Shnaidman has over 25 years of customer service experience. Previously, he was the Operations Director of Bill Hansen Catering in Miami, Florida. He mastered his diamond education at the Arabov Diamond group headquarters in Tel Aviv, Israel, his native hometown.',
				'Shnaidman is husband to wife Nicole and father to two sons. He enjoys watching and playing sports, and spending time with family.',
			],
		},
		{
			name: 'Brian Dedrickson',
			title: 'General Manager & Director of Training and Development',
			picture: 'aug27/brian_dedrickson.jpg',
			email: 'BrianD@DiamondsDirect.com',
			phone: '',
			bio: [
				'Brian Dedrickson, General Manager & Director of Training and Development, has been with Diamonds Direct since 2010. He attended San Francisco State University where he studied Economic Analysis and Financial Forecasting.',
				'Dedrickson has been in the diamond and jewelry industry for 30 years. Previously, he was a trainer on diamonds and watches and has managed boutique and couture jewelry stores in Seattle, Washington DC, San Francisco and Saint Louis. Dedrickson has also appeared around the country as a guest speaker and educator on diamonds.',
				'In his free time, Dedrickson enjoys spending time with his wife Rhonda, daughter and two grandchildren. He also collects and restores Vintage pre-depression watches, unusual pens and participates in online diamond and vintage watch forums as a moderator.',
			],
		},
		{
			name: 'Tessa Kitko',
			title: 'Marketing Manager',
			picture: 'oct18/Tessa.jpg',
			email: 'TessaG@DiamondsDirect.com',
			phone: '',
			bio: [
				'Tessa has been with Diamonds Direct since 2014, starting in sales before transitioning to the marketing team. She has a BS in Brand Management and Marketing, and a minor in Art Studies, from the College of Textiles at North Carolina State University.',
				'Born and raised in Raleigh, Tessa is passionate about her community, as well as sustainable fashion and farming practices. In her free time she sings in an emo cover band and goes foraging with her husband.',
			],
		},
		{
			name: 'Laura Gallardo',
			title: 'Diamond Expert',
			picture: 'aug27/laura_gallardo.jpg',
			email: 'LauraG@DiamondsDirect.com',
			phone: '',
			bio: [
				'Laura Gallardo, Diamond Expert, has been with Diamonds Direct since 2010. She has an Associate\'s Degree in Business Administration. Gallardo also attended the Gemological Institute of America (GIA) in New York.',
				'Gallardo has been in the diamond and jewelry industry for over 25 years. Previously, she worked as a Diamond Consultant for Fortunoff on Long Island before moving to North Carolina with her family in 2007. Before getting involved in the industry, Gallardo worked in the Real Estate business.',
				'In her free time, Gallardo enjoys spending time with her two children.',
			],
		},
		{
			name: 'Lisa Johnson',
			title: 'Diamond Expert',
			picture: 'oct18/Lisa-Johnson.jpg',
			email: 'LisaJ@DiamondsDirect.com',
			phone: '',
			bio: [
				'Lisa Johnson, Diamond Expert, has been with Diamonds Direct since 2010. She is currently working toward a Bachelor\'s Degree in Business Administration with a concentration in Retail Management and a Minor in Marketing from Strayer University. Johnson currently holds an Associate\'s Degree in Recreation and Therapeutic Therapy from Vance Granville Community College.',
				'Johnson has been in the diamond and jewelry industry for twelve years. She was previously a manager at a local independent store and an assistant manager at a local mall retailer.',
				'In her free time, Johnson enjoys spending time with her beautiful little girl and family and friends.',
			],
		},
		{
			name: 'Liz Schuvart',
			title: 'Graduate Gemologist',
			picture: 'aug27/liz_schuvart.jpg',
			email: 'LizS@DiamondsDirect.com',
			phone: '',
			bio: [
				'Liz Schuvart, Graduate Gemologist, has been with Diamonds Direct Crabtree since the fall of 2013. She has a Graduate Gemology degree from the Gemological Institute of America and has a bachelor’s degree from Simmons College in Boston.',
				'Schuvart has over 20 years of experience in the jewelry field.',
				'Schuvart and her husband, along with their two kids and dog, moved from Boston to Raleigh in the summer of 2013. They enjoy exploring the area in their free time.',
			],
		},
		{
			name: 'Sylvia Wilcox',
			title: 'Diamond Expert',
			picture: 'oct18/Sylvia.jpg',
			email: 'SylviaW@DiamondsDirect.com',
			phone: '',
			bio: [
				'Sylvia Wilcox, Diamond Expert, has been with Diamonds Direct since 2010. She has studied the colored stone and diamond program at H. Stern, attended Mayors University and regularly attends sales seminars.',
				'Wilcox has been in the diamond and jewelry industry for 22 years and started her journey in St. Thomas where she managed three jewelry stores. She has also worked in management at White Hall Jewelers, Mayor\'s Jewelers, Little Switzerland and worked in sales at Wynn & Co. in Las Vegas.',
				'In her free time, Wilcox enjoys traveling, gardening and sailing.',
			],
		},
		{
			name: 'Tina Greene',
			title: 'Diamond Expert',
			picture: 'oct18/Tina.jpg',
			email: 'TinaG@DiamondsDirect.com',
			phone: '',
			bio: [
				'Tina Greene, Diamond Expert, joined Diamonds Direct in July of 2014. She attended North Carolina State University where she studied Meteorology.',
				'Greene has over 15 years of experience in the jewelry industry, earning several accreditations from the Gemological Institute of America (GIA) and the American Gemological Society (AGS). Previously she was a store manager for Helzberg Diamonds in the Raleigh area. She has also worked in the D.C. and Atlanta markets.',
				'In her free time, Greene enjoys cross-training, weight-lifting, and spending time with friends and family.  Nothing beats Mom\'s Sunday pot roast!',
			],
		},
		{
			name: 'Roxie Harden',
			title: 'Shipping & Receiving',
			picture: 'aug27/roxie_harden.jpg',
			email: 'RoxieH@DiamondsDirect.com',
			phone: '',
			bio: [
				'Roxie Harden, Customer Service Expert, joined Diamonds Direct in November 2015. She has earned several accreditations from Diamond Council of America (DCA), Gemological Institute of America (GIA), and American Gemological Society (AGS).',
				'Harden has over 15 years of experience in the jewelry industry and customer service. She has previously been a Store Manager for a small jewelry kiosk, as well as an Office Manager for Helzberg Diamonds in the Raleigh and Fayetteville areas.',
				'In her free time, Harden enjoys spending quality time with friends and family and her cat, Casper. She enjoys spending time at the lake. Harden is very active in her church and community outreach projects.',
			],
		},
		{
			name: 'Andres Gomez',
			title: 'Shop Manager',
			picture: 'jul15/andres.jpg',
			email: 'Andres@DiamondsDirect.com',
			phone: '',
			bio: [
				'Andres Gomez was born in Cuba in 1970. Gomez learned the profession of jewelry in 1991 from his talented father. Gomez came to the United States in 1994 and has been working in the industry ever since.In November of 2012, Gomez began a new stage of his life by joining Diamonds Direct and continues to love what he does.',
				'In his free time, Gomez likes to spend time with his family and play soccer and baseball with his kids.',
			],
		},
		{
			name: 'Cindy Parker',
			title: 'Virtual Diamond Expert',
			picture: 'aug27/cindy_parker.jpg',
			email: 'CindyP@DiamondsDirect.com',
			phone: '',
			bio: [
				'Cindy Parker has been with Diamonds Direct since April 2016. She attended NC State University where she studied Mechanical Engineering and has been in the jewelry business for over 25 years. She started out operating an independent store, then shifted to sales and management with Sterling Jewelers where she worked in the Cary/Raleigh area for 14 years.',
				'In her spare time, she enjoys traveling, flying and spending time with her husband and two children.',
			],
		},
		{
			name: 'Austin Witmer',
			title: 'Diamond Expert',
			picture: 'oct18/Austin.jpg',
			email: 'AustinW@DiamondsDirect.com',
			phone: '',
			bio: [
				'Austin Witmer joined the Diamonds Direct team in August of 2016. Witmer graduated from Liberty University in 2010 with a Bachelor’s degree in Business Finance. Witmer has over ten years of experience in the jewelry industry, both in Raleigh, NC, and in Virginia. He has a strong passion for timepieces and, of course, diamonds!  His easygoing, calm personality doesn’t make him your traditional salesperson, and his goal is for you to earn his trust so he can be your jeweler for life!',
				'He has been married to his high school sweetheart, Connie, since 2010, and they have 2 kids. In his free time, he enjoys spending time with his kids, family and friends, trying new restaurants around the Triangle, playing golf, and attending or watching any sports events. Some of his favorite teams are the UNC Tar Heels, Dallas Cowboys, and Baltimore Orioles.',
			],
		},
		{
			name: 'Eric Williams',
			title: 'Diamond Expert',
			picture: 'oct18/Eric.jpg',
			email: 'EricW@DiamondsDirect.com',
			phone: '',
			bio: [
				'Eric Williams, Diamond Expert, joined the Diamonds Direct Crabtree team in June 2016. Certified by the Diamond Council of America with 10 years of dedication to the jewelry industry, Williams offers extensive knowledge and a customer service level second to none.',
				'Originally from Richmond, VA, Williams began his career as a Personal Banker for Bank of America Merrill-Lynch. After committing five years to the financial industry specializing in financial planning and insurance, Williams decided to take a chance.',
				'In 2007, Williams made a lateral career move and began as a Sales Associate for Sterling Jewelers. Within one year, his work ethic propelled him to Timepiece Department Manager, and he earned a consecutive promotion every year following that. After successfully managing several departments and assisting managers, Williams was entrusted with a store of his own as General Manager in 2012. Williams continued to rise in the company with three more stand-alone stores located in Virginia, Maryland, and North Carolina until 2016 when he was referred to Diamonds Direct.',
				'Since bringing his unique and informed approached to his presentations, Williams not only becomes your personal Diamond Expert, but also a trusted friend.',
				'In his free time, Williams is a true family man and enjoys sports, travel, entertaining friends, and a good cigar.',
			],
		},
		{
			name: 'Paul James Testa',
			title: 'Bench Jeweler',
			picture: 'aug27/paul_testa.jpg',
			email: 'PaulT@DiamondsDirect.com',
			phone: '',
			bio: [
				'Paul James Testa joined the Diamonds Direct team in August 2017. He has worked in multiple facets of the jewelry industry including cast contracting, repair and assembly since 1992.',
			],
		},
		{
			name: 'Prem Sharma',
			title: 'Diamond Expert',
			picture: 'aug27/prem_sharma.jpg',
			email: 'PremS@DiamondsDirect.com',
			phone: '',
			bio: [
				'Prem Sharma, Diamond Expert, joined the Diamonds Direct family in July 2018.',
				'Sharma has been in the jewelry business for over 20 years in the Caribbean island of St. Thomas. He has a passion for selling rare gemstones and diamonds! He would love to help you find an engagement ring that would be a lifetime treasure!',
				'Sharma enjoys traveling with his family to new and different places around the world.',
			],
		},
		{
			name: 'Kirsten Hower',
			title: 'Customer Care',
			picture: 'jul15/kirsten.jpg',
			email: 'RaleighReception@DiamondsDirect.com',
			phone: '',
			bio: [
				'Kirsten Hower started at Diamonds Direct in April of 2019. She has had 10 years of customer service experience, in which she tries her best to exceed expectations. Hower plans on beginning her journey in college soon where she will study child development and psychology. She loves spending her free time with her lovely daughter; always teaching her new things, going out to the park, and having princess parties. Her little girl is the light of her life and the reason for everything that she does.',
			],
		},
		{
			name: 'Leslie Rosenfeld',
			title: 'Diamond Expert',
			picture: 'oct18/Leslie.jpg',
			email: 'LeslieR@DiamondsDirect.com',
			phone: '',
			bio: [
				'Leslie has been a part of the  Diamonds Direct Family since February 2021. She is originally from Long Island, New York and moved to North Carolina in March of 2020.',
				'Leslie comes with over 10 years of customer service and management experience. As a diamond expert she enjoys being a part of her client\'s special moment!',
				'When she’s not making customers smile in the showroom, she enjoys traveling around the country with her boyfriend competing in dart tournaments. She also likes exploring Raleigh and playing with her puppy!',
			],
		},
		{
			name: 'Daniel Peiffer',
			title: '',
			picture: 'oct18/Daniel.jpg',
			email: 'DanielP@DiamondsDirect.com',
			phone: '',
			bio: [
				'Daniel Peiffer joined the Diamonds Direct team in July of 2021. Peiffer graduated from Grove City College in 2018 with a Bachelor’s degree in Communication Studies and Design. Peiffer recently moved from Pittsburgh and brings with him over five years experience in customer service and care. His background blends perfectly with the jewelry industry as he has a strong passion for customers’ satisfaction and, of course, diamonds!',
				'Daniel spends his free time with friends, trying new bars around the Triangle, playing tennis, cycling and watching sports. Some of his favorite teams are the Pittsburgh Steelers, Carolina Hurricanes, and the New Zealand All Blacks.',
			],
		},
		{
			name: 'Sal Roccaforte',
			title: '',
			picture: 'oct18/Sal.jpg',
			email: 'SalR@DiamondsDirect.com',
			phone: '',
			bio: [
				'Salvatore Roccaforte is new to the Diamonds Direct family, joining the team in August of 2021. Though originally from New York, he recently moved to North Carolina from Seattle Washington to be closer to family.',
				'Salvatore has over 25 years of experience in management and customer service.',
				'In his free time he enjoys finding antiques, collectables, and under-valued companies.',
			],
		},
		{
			name: 'Destiny Allison',
			title: 'Front Desk',
			picture: 'oct18/Destiny.jpg',
			email: '',
			phone: '',
			bio: [
				'Destiny Allison started with Diamonds Direct in March of 2021 and always aims to put a smile on everyone\'s face with her bubbly personality!  She has over ten years of customer service experience in the restaurant industry, as well as retail. Before joining the team, Destiny attended culinary school with a major in baking and pastry arts.',
				'Destiny enjoys spending time with her little family that includes her husband and her two rescue fur babies, Bailey and Andrei. She is a huge advocate for "Adopt Don\'t Shop" and pit bulls.  In her free time she enjoys binge watching her favorite reality tv shows (the Below Deck Series and Dallas Cowboys Cheerleaders: Making the team), going to the dog park, and trying new recipes. Destiny is also known for being a huge Carolina Hurricanes fan and can be found at every home game!',
			],
		},
		{
			name: 'Andi Chappell',
			title: 'Front Desk',
			picture: 'oct18/Andi.jpg',
			email: '',
			phone: '',
			bio: [
				'Andi Chappell has been part of the Diamonds Direct family since July 2021. She has over ten years experience in customer service and retail.. Andi grew up in a military family and has lived in several states, but has called North Carolina home since 2002.',
				'In her free time, Andi enjoys traveling to new places, hunting, and spending time with her son and dog. Her son is the light of her life and the reason for everything she does. One day she plans to own a farmhouse with horses to operate as a venue.',
			],
		},
		{
			name: 'Ginger Hollifield',
			title: 'Diamond Expert',
			picture: 'oct18/Ginger.jpg',
			email: 'GingerH@DiamondsDirect.com',
			phone: '',
			bio: [
				'Ginger Hollifield  joined Diamonds Direct in June of 2021. She has worked in the jewelry industry for almost 20 years, including time spent with Friedman’s as both a sales associate and store manager, and Jared as a Sales consultant and Diamond manager. Prior to becoming part of the Diamonds Direct family, Ginger worked for a local jeweler Bailey’s Fine Jewelry for 10 years. Ginger is accredited with the Diamond Council of America (DCA) and American Gemological Society(AGS).',
				'Ginger has been married to her high school sweetheart for 31 years and has three wonderful children. In her free time she enjoys making memories and cookies with her two sweet granddaughters.',
			],
		},
		{
			name: 'Viviana Zuccardi',
			title: 'Diamond Expert',
			picture: 'oct18/Viviana.jpg',
			email: 'VivianaZ@DiamondsDirect.com',
			phone: '',
			bio: [
				'Viviana is a sales professional and social communicator with emphasis in digital marketing. She has her Master’s Degree in Marketing and Commercial Management and is experienced in B2C and B2B sales and advertising, with a focus on new market development and brand recognition. Viviana has been successful in fostering excellent relationships with customers and suppliers through exceptional service and deep understanding of their needs. We are fortunate to have had her join the Diamonds Direct team in April of 2021.',
				'Viviana Zuccardi comes from a family of three generations of jewelers in Colombia (the emerald capital of the world). Raised by experts and surrounded by diamonds and Colombian emeralds, it was inevitable that she grew to love and have a passion for the jewelry business! She has traveled the world and attended the best jewelry shows on each continent, discovering new designs and, with each new adventure, falls in love anew with the jewelry industry.',
			],
		},
	],
	sponsorships: [
		// {
		// 	name: 'North Carolina State',
		// 	image: 'ncstate.jpg',
		// },
		{
			name: 'Carolina Hurricanes',
			image: 'hurricanes.jpg',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/3mg7ora',
		googleWrite: 'https://bit.ly/3mg7ora',
	}
};

const RVA = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Richmond',
	title: 'Diamonds Direct Richmond - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Richmond Location Today!',
	shortName: 'Richmond',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Located in West Broad Village, our showroom is just a short drive from downtown Richmond. In such a historical city, it’s only natural you’d want to make your own history with the one you love. Our diamond experts are always here to help with any occasion you’re shopping for.',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectrichmond',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '11131 West Broad Street',
		line2: 'Glen Allen, VA 23060',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Richmond/@37.6482832,-77.6001329,17z/data=!3m1!4b1!4m5!3m4!1s0x89b13e0a4c7756af:0xb74962c2a45657cb!8m2!3d37.648279!4d-77.5979442',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '8049670500',
	email: 'infoRic@diamondsdirect.com',
	team: [
		{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: [
				'Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.',
				'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.',
				'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.',
				'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.',
				'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.',
			],
		},
		{
			name: 'Ori Ben Amitai',
			title: 'Vice President, Virginia',
			picture: 'ori_amitai.jpg',
			email: 'Ori@DiamondsDirect.com',
			phone: '',
			bio: [
				'Ori Ben Amitai, Vice President, has been with Diamonds Direct since 2012. He attended Bar -Ilan University in Israel where he studied Industrial Practical Engineering. Previously, Ori was working for the diamond cutting facilities of the company in the Israeli diamond district.',
				'Born in Ramat Gan, Israel in 1984 and raised in Herzelia, Ben Amitai joined the Israeli defense forces in 2003 and served for 3 years. The military experience gave him great tools to appreciate the good things in life; his wife, family and close friends. The army experience also taught him a new way of life - always be on time never late, be honest with people, and never be afraid of the truth. In 2012 he started to explore the world of diamonds in the diamond cutting facilities of Diamond’s Direct in Ramat Gan, Israel, where he fell in love with them immediately. After one year of experience in the diamond district he was selected to join the company’s other side of the business, the direct-to-the-public stores. He started his way in the Raleigh location where he learned and work with Barak Henis (Vice President of the Raleigh and the Richmond location). Ori then relocated when the company opened its 4th location in Richmond, Virginia. He sees an amazing future to the Richmond market, and puts all his effort in establishing Diamonds Direct as a strong brand in the community. In his free time Ori likes to travel with his wife and his dog exploring Richmond and its surrounding cities.',
			],
		},
		{
			name: 'Dianne Gatto',
			title: 'General Manager & GIA Graduate Gemologist',
			picture: 'dianne_gatto.jpg',
			email: 'DianneG@DiamondsDirect.com',
			phone: '',
			bio: [
				'Dianne Gatto, Graduate Gemologist, has been with Diamonds Direct since 2012. Gatto graduated from the Gemological institute of America (GIA) in New York City where she earned her Graduate Gemologist Degree.',
				'Gatto has been in the diamond and jewelry industry for 29 years. She previously worked for a large independent in the metropolitan DC area, where she was the Operations Manager.',
				'In her free time, Gatto enjoys cooking, boating, playing softball and spending time with her boyfriend and dog.',
			],
		},
		{
			name: 'Afton Sleichter',
			title: 'Regional Back Office Manager/Graduate Gemologist',
			picture: 'afton_sleichter.jpg',
			email: 'aftons@diamondsdirect.com',
			phone: '',
			bio: [
				'Afton Sleichter has been with Diamonds Direct since 2014. She has a Bachelor\'s Degree in Art History and a Minor in History from Virginia Commonwealth University.',
				'Sleichter has over five years of experience in the jewelry industry and earned her Graduate Gemologist designation from the Gemological Institute of America in 2011. Previously, she worked with an independent store in the Washington, D.C., region.',
				'In her free time, the Richmond native enjoys reading, sewing and spending time with her husband, son and dogs.',
			],
		},
		{
			name: 'Stephen Bittman',
			title: 'Diamond Expert',
			picture: 'stephen_bittman.jpg',
			email: 'StephenB@diamondsdirect.com',
			phone: '',
			bio: [
				'Stephen has been with Diamonds Direct since 2013. He was born and raised in Binghamton, New York, a small city in the beautiful upstate region on the New York and Pennsylvania border. He attended Syracuse University, where he studied economics and business. Stephen began his career working for a successful group of Binghamton investment bankers managing various real estate properties.',
				'After four years, he joined his Dad in his wholesale jewelry business in Binghamton. Stephen soon began to reshape the business into a retail operation and commenced by developing stores within a 90 mile radius of the home base. He ultimately operated 4 stores in the region, and became the President and Owner of the company. He ran the operations for 30 years and in 2006 chose to explore other opportunities, and left the jewelry business and came to Richmond to become involved in other business ventures. He welcomed the opportunity to re-enter the jewelry field and is very excited to be part of the Diamonds Direct team of professionals.',
				'Stephen is married to his wife, Nancy, and they have two children; a daughter and a son-in-law, and a son. They are the proud grandparents to two grandchildren. In his free time Stephen enjoys playing golf, traveling, reading novels and socializing with friends.',
			],
		},
		{
			name: 'Katia Clocicova',
			title: 'Diamond Expert',
			picture: 'katia.jpg',
			email: 'katiac@diamondsdirect.com',
			phone: '',
			bio: [
				'Katia Clocicova has joined Diamonds Direct team in February 2019. She studied global economy and international relations in her country of origin, Republic of Moldova.',
				'With over 7 years experience in retail, luxury cosmetics and customer service, Katia is thrilled to be able to guide and help couples to choose the best of what Diamonds Direct has to offer.',
			],
		},
		{
			name: 'Ashok Dhansinghani',
			title: 'Diamond Expert',
			picture: 'ashok_dhansinghani.jpg',
			email: 'ashd@diamondsdirect.com',
			phone: '',
			bio: [
				'Ashok Dhansinghani, known by friends and family as Ash, has been with Diamond Direct since 2013. He studied Business and Commerce in the Stanes University in India.',
				'He has been in the diamond and jewelry industry for 22 years. Previously he has worked in Princess Jewelers as an assistant manager. Dhansinghani has worked in diverse markets including Alaska and the U.S. Virgin Islands before finally making Richmond his home.',
				'In his free time, Dhansinghani enjoys spending time with his wife and watching sporting events with his two boys. He also enjoys going to movies, reading and spending time with friends.',
			],
		},
		{
			name: 'Deneen Ell',
			title: 'Diamond Expert',
			picture: 'deneen_ell.jpg',
			email: 'deneen@diamondsdirect.com',
			phone: '',
			bio: [
				'Deneen Ell joined the Diamonds Direct team in 2017. She is DCA certified and has experience in both the corporate and luxury jewelry industry. For Deneen, family is first and she is truly passionate about helping couples discover the perfect diamond and ring they have been dreaming of. She is committed to listening carefully to both the needs and the wants of each customer and then skillfully guiding them through the entire purchase process.',
			],
		},
		{
			name: 'Dmitriy Gerasimov',
			title: 'Diamond Expert',
			picture: 'dmitriy.jpg',
			email: 'dimag@diamondsdirect.com',
			phone: '',
			bio: [
				'Dmitriy was born in Russia and immigrated with his parents to Richmond when he was 8 years old. He started his jewelry career over a decade ago and quickly developed a passion for diamonds and helping customers celebrate love. Dmitriy’s favorite part of the job is the relationships that he develops with his clients. He believes it to be an honor to help people with celebrating their happiest life moments; engagements, weddings, anniversaries, the birth of children and everything in between. Dmitriy loves having a part in helping his clients with their most cherished moments.',
				'Dmitriy joined the Diamonds Direct Family in February of 2019. He has 12 years of jewelry experience, previously working for a national, corporate jewelry store, as well as a luxury family owned jeweler. He is excited to bring his experience and keen eye for quality to Richmond’s premier diamond retailer. His specialty is selection. Dmitriy meticulously analyzes thousands of diamonds and selects only the best value and quality for each client’s specific needs. He loves that Diamonds Direct gives him the best resources, with the largest inventory and best prices in the industry.',
				'When he is not working, Dmitriy loves spending time with his fiancée, Sarah, and daughter Savannah. Self-proclaimed “foodies”, Dmitriy and Sarah love the Richmond restaurant scene. He is also an avid fisherman and enjoys any activity on the water.',
			],
		},
		{
			name: 'Denise Popp',
			title: 'Diamond Expert',
			picture: 'popp.jpg',
			email: 'denisep@diamondsdirect.com',
			phone: '',
			bio: [
				'Denise Popp has been with Diamonds Direct since 2013. She attended Savannah College of Art and Design, where she received her degree in Painting and Art history. Popp has over a decade of customer service and jewelry experience.',
				'In her free time, Popp enjoys painting, reading, and spending time with her loved ones.',
			],
		},
		{
			name: 'Larisa Seamster',
			title: 'Diamond Expert',
			picture: 'larisa_seamster.jpg',
			email: 'larisas@diamondsdirect.com',
			phone: '',
			bio: [
				'Larisa started at Diamonds Direct Richmond in 2017, but has been in the jewelry industry since 2003. She is DCA Diamond certified and a graduate of the Gemological Institute of America. She came to the United States from Russia in 1999. She is happily engaged and has 2 amazing children named Victor and Yana. In her free time she loves fishing and boating.',
			],
		},
		{
			name: 'Gary Wakefield',
			title: 'Diamond Expert',
			picture: 'gary_wakefield.jpg',
			email: 'garyw@DiamondsDirect.com',
			phone: '',
			bio: [
				'Gary Wakefield has been living in the Richmond area almost all his life. He was worked in retail, happily serving the people of central Virginia with companies like Merry-Go-Round Enterprises, Sea Dream Leather, and Jared the Galleria of Jewelry. He is now enjoying his exciting journey with Diamonds Direct! Gary and his beautiful wife Charise, enjoy traveling and spending time with friends and their amazing dog, Manhattan (breed shih tzu).'
			],
		},
		{
			name: 'Angela Baker',
			title: 'Back Office Manager',
			picture: 'angela_baker.jpg',
			email: 'angelab@diamondsdirect.com',
			phone: '',
			bio: [
				'Angela Baker was born and raised in Sheffield, England. She has lived in the United States for 20 years, including Baltimore, MD for 18 years and now Richmond,VA. She has been with Diamonds Direct Richmond since March 2017. She has been apart of the Jewelry industry for 20 years and previously worked for a large family owned business in Baltimore. In her free time, she loves to go out to eat with her husband, sample new craft beers on the market and also loves to spend time with her dog.',
			],
		},
		{
			name: 'Kasey Bates',
			title: 'Special Orders Manager',
			picture: 'kasey_bates.jpg',
			email: 'kaseyb@diamondsdirect.com',
			phone: '',
			bio: [
				'Kasey Bates started at Diamonds Direct in 2012 as one of the first receptionists at the Richmond, Virginia location. In 2014, she headed up the Customer Care department, and in 2015 moved to the back office to be the Special Orders Manager.',
				'In her free time, Kasey likes to spend time with her husband and their two daughters.',
			],
		},
		{
			name: 'Kimary Bourret',
			title: 'Customer Care',
			picture: 'kimary_bourret.jpg',
			email: 'kimaryb@diamondsdirect.com',
			phone: '',
			bio: [
				'Kimary Bourret has been with Diamonds Direct since November 2016. She was born and raised in Findlay, Ohio but has lived in Virginia since 1986. She has 35 years in the customer service retail industry. She is a certified Master Floral Designer. In her free time she loves being outdoors, whether it be on land or water and especially enjoys spending time with her 6 children!',
			],
		},
		{
			name: 'Vickie Pyle',
			title: 'Customer Care',
			picture: 'vickie_pyle.jpg',
			email: 'vickiep@diamondsdirect.com',
			phone: '',
			bio: [
				'Vickie Pyle has been with Diamonds Direct since 2012. She was born and raised in Richmond, VA where she graduated from Hermitage High School. She has over 25 years in the customer service industry.',
				'In her free time, she enjoys dancing and spending time with her son, Andrew.',
			],
		},
		{
			name: 'Daniel Eaves',
			title: 'Jeweler',
			picture: 'daniel_eaves.jpg',
			email: 'daniele@diamondsdirect.com',
			phone: '',
			bio: [
				'Daniel Eaves is a graduate of Virginia Commonwealth University and Cranbrook Art Academy and has worked as a jeweler for over 25 years.',
				'He lives on a family farm and enjoys spending time with his wife and two daughters.',
			],
		},
		{
			name: 'Matt Silva',
			title: 'Jeweler',
			picture: 'matt_silva.jpg',
			email: 'MattS@DiamondsDirect.com',
			phone: '',
			bio: [
				'Matt Silva got his start in jewelry from his family. He has been professionally trained, but credits a lot of his learning from his family who own several jewelry stores in Massachusetts, where he apprenticed. Matt came to work at Diamonds Direct in 2014.',
				'After moving often as a child of a military family, Matt now calls Virginia home. He is a graduate of Community High School and lives in the Richmond area with his wife and children. He loves to fish and remodel his home in his off time.',
			],
		},
		{
			name: 'Jana Prinzivalli',
			title: 'Diamond Expert',
			picture: 'jana.jpg',
			email: 'Janap@diamondsdirect.com',
			phone: '',
			bio: [
				'Jana has been with Diamonds Direct since 2017. She was born in Western New York, but has called Richmond home for the past 4 years. Jana has over 8 years of customer service experience.',
				'In her free time she enjoys traveling and spending time with her husband and three dogs.',
			],
		},
		{
			name: 'Bryan Ames',
			title: 'Diamond Expert',
			picture: 'bryan.jpg',
			email: 'bryanames@diamondsdirect.com',
			phone: '',
			bio: [
				'Bryan Ames recently joined the Diamonds Direct family in November 2020, after having been a loyal customer for seven years previously. Bryan has been involved in luxury retail with over 15 years sales and management experience with Richmond Piano. He was also the owner/operator of a local youth sports franchise; i9 Sports, for several years before selling the business to a participating member. With a strong passion for customer experience, education, and a desire to assist in creating lasting memories with clients, Bryan believes listening intently while giving gentle guidance helps clients achieve these moments, all while having total confidence in their decision making.',
				'When Bryan is not in the amazing Diamonds Direct showroom, he and his wife will be found riding their Harleys on country roads exploring quaint little towns for places to eat, shop and just have fun. So far, they have ridden over 18,000 miles together through VA, WV, KY, TN, NC, PA, DC, MD, NY, VT, IN, OH, MI and are looking forward to many more.',
			],
		},
		{
			name: 'Jenna Holepit',
			title: 'Diamond Expert',
			picture: 'jenna.jpg',
			email: 'jennah@diamondsdirect.com',
			phone: '',
			bio: [
				'Jenna was born and raised in Alexandria, Virginia and has been living in the Richmond area on and off since 2013. She has been in the Jewelry industry since 2013, certified with the Diamond Council of America, and has a Bachelor’s Degree of Science in Criminal Justice. She has over 13 years of customer service experience, loves working with people, and enjoys being a part of their celebration experience at Diamonds Direct! Prior to jewelry, Jenna was a licensed hairstylist since 2008, specializing in color and cuts. She now does hair as a hobby. Jenna loves to have fun, laugh, have a good time and build relationships with people while assisting them to find the perfect gift for their loved ones! She truly loves what she does and is honored to be a part of their amazing experience!',
				'When Jenna isn’t working at Diamonds Direct, she enjoys spending time with her son, spa days, shopping, kickboxing, traveling different places and a total foodie!”',
			],
		},
	],
	sponsorships: [
		{
			name: 'Virginia Commonwealth University',
			image: 'vcu.jpg',
		},
		{
			name: 'University of Virginia',
			image: 'sabers.jpg',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/39VrcdN',
		googleWrite: 'https://bit.ly/39VrcdN',
	}
};

const STL = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct St. Louis',
	title: 'Diamonds Direct St Louis - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our St Louis Location Today!',
	shortName: 'St. Louis',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Meet us in St. Louis for every occasion! Shop one-on-one with one of our amazing Diamond Experts in our gorgeous showroom for an unmatched, luxury experience no matter your budget. With top bridal and fashion designers from around the world, you’re sure to get something to make all your friends jealous.',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectSTL',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '11619 Olive Blvd',
		line2: 'Saint Louis, MO 63141',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+St.+Louis/@38.6708739,-90.4414091,17z/data=!3m1!4b1!4m5!3m4!1s0x87df32bd1b83b255:0x5b0c0769af596ae5!8m2!3d38.6708697!4d-90.4392204',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '3149423777',
	email: 'infostl@diamondsdirect.com',
	team: [
		{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: [
				'Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.',
				'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.',
				'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.',
				'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.',
				'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.',
			],
		},
		{
			name: 'Niv Ankawa',
			title: 'Vice President',
			picture: 'niv.jpg',
			email: 'Niv@diamondsdirect.com',
			phone: '',
			bio: [
				'Niv joined Diamonds Direct in 2018. With over 12 years of experience in the fine jewelry and diamond business, Niv’s expertise comes from his many years managing a store in the Diamond District in New York City. Prior to the Diamond District, Niv also managed a jewelry store in Miami for 7 years. His strength is his ability to connect with people. He believes client satisfaction is the key to a successful brand. In his free time Niv enjoys being active, playing soccer, frequents the gym, and is an avid skier. He also loves trying new restaurants and traveling all over the world.',
			],
		},
		{
			name: 'Evan Newbill',
			title: 'General Manager',
			picture: 'evan.jpg',
			email: 'evan@diamondsdirect.com',
			phone: '',
			bio: [
				'Evan has been with Diamonds Direct since 2017, but started in the jewelry business at just 18 years old. He was born in Florida, raised in Virginia, and now enjoys his home in St. Louis. He has been able to enjoy all of the wonderful things life has to experience from the East Coast to the Midwest. His core philosophies always align with educating the customer, and the customer experience-- above all else. From collaborating with local businesses in the community to welcoming in new clients, he always knows how to make someone feel appreciated and valued. In his spare time, he enjoys going on new adventures with his  three sons.',
			],
		},
		{
			name: 'Veroniqua Kaighin',
			title: 'Diamond Expert',
			picture: 'veroniqua_kaighin.jpg',
			email: 'Veroniqua@diamondsdirect.com',
			phone: '',
			bio: [
				'Veroniqua has been with Diamonds Direct since 2016. Veroniqua has been in the diamond industry since 2006, both in sales and management. She is the mother of four boys, with whom she enjoys spending most of her time with. She also enjoys cooking, boating, running, and spending time on her family farm.',
			],
		},
		{
			name: 'Mark Medeiros',
			title: 'Diamond Expert',
			picture: 'aug3/MarkMedeiros.jpg',
			email: 'Markm@diamondsdirect.com',
			phone: '',
			bio: [
				'Mark has been with Diamonds Direct since 2015. He has over 20 years of experience in the diamond and jewelry industry. He\'s a certified Diamontologist from the Diamond Council of America. Formerly a professional dancer, Mark now spends his free time enjoying golf, tennis, bowling, and traveling, especially to the tropics.',
			],
		},
		{
			name: 'Gai Kranz',
			title: 'Diamond Expert, GIA Gemologist',
			picture: 'aug3/GaiKranz.jpg',
			email: 'Gai@diamondsdirect.com',
			phone: '',
			bio: [
				'Gai is a G.I.A. Graduate Gemologist, and a A.G.S. Certified Gemologist Appraiser. She has been with Diamonds Direct since 2017. She has over 41 years of experience in the St. Louis jewelry industry. In her free time she trains service dogs for handicapped people through Support Dogs Incorporated. She is an identical twin, and has two sons who work for the Saint Louis County Police Force.',
			],
		},
		{
			name: 'Sophie Imamovic',
			title: 'Front Office Manager',
			picture: 'aug3/SophieImamovic.jpg',
			email: 'Sophie@diamondsdirect.com',
			phone: '',
			bio: [
				'Sophie has been with Diamonds Direct since November 2016. Born in Germany she attained her diploma in Computer Programming from London. Sophie previously worked as an interpreter/translator for Bosnian refugees in Germany, and customer service and sales here in the United States. In her free time she loves traveling with her husband, and two daughters.',
			],
		},
		{
			name: 'Claudia Davis',
			title: 'Back Office Manager',
			picture: 'aug3/ClaudiaDavis.jpg',
			email: 'Claudiad@diamondsdirect.com',
			phone: '',
			bio: [
				'Claudia has been with Diamonds Direct since 2017. Claudia started her Diamonds Direct career as a receptionist, and has made her way to her home in the back office as the back office manager. Claudia loves being in the jewelry industry, her favorite part of her job is having the opportunity to be part of so many clients\' love stories. In her free time, Claudia enjoys watching the Saint Louis Blues, and spending time with her friends and family, especially her fur baby, Pacha.',
			],
		},
		// {
		// 	name: 'Adrijana Mehic',
		// 	title: 'Inventory Control',
		// 	picture: 'adrijana_mehic.jpg',
		// 	email: 'Adrijana@diamondsdirect.com',
		// 	phone: '',
		// 	bio: [
		// 		'Adrijana has been with Diamonds Direct since January 2017. She currently works in our back office as inventory control and special orders.',
		// 		'She has six years of customer service experience. She has a cosmetology license from Grabber School of Hair Design.',
		// 		'In her free time she enjoys spending time with family, hanging with friends, and trying new foods. Originally from Bosnia, she moved to California for 11 years and now resides in St. Louis. She enjoys experiencing new things in the St. Louis area.',
		// 	],
		// },
		{
			name: 'Guy Fellers',
			title: 'Master Jeweler',
			picture: 'aug3/GuyFellers.jpg',
			email: 'Guyf@diamondsdirect.com',
			phone: '',
			bio: [
				'Guy is a Master Jeweler and has been with Diamonds Direct since November 2016. He has over 43 years of experience in custom jewelry, restoration and repair. In his free time he enjoys food, watching the Cardinals, going to the shooting range, fishing, and spending time with his wife.',
			],
		},
		{
			name: 'Adam Creviston',
			title: 'Jeweler',
			picture: 'aug3/AdamCreviston.jpg',
			email: 'Adamc@diamondsdirect.com',
			phone: '',
			bio: [
				'Adam has been with Diamonds Direct since August of 2017.  Prior to working at Diamonds Direct, Adam was a lighting restorationist at an antique shop specializing in architectural style antiques. Adam is originally from Indianapolis, and worked at our sister store before making the move to beautiful Saint Louis. In his free time Adam enjoys spending time with his girlfriend, Portia, and his dog and cat. He also enjoys fishing, hiking, reading, and playing video games.',
			],
		},
		{
			name: 'Brendan Willers',
			title: 'Front Office Support',
			picture: 'aug3/BrendanWillers.jpg',
			email: 'brendanw@diamondsdirect.com',
			phone: '',
			bio: [
				'Brendan has been with Diamonds Direct since 2019. He graduated the University of Central Missouri with a bachelor\'s degree in Communication Studies with an emphasis in relational communication. He also played college soccer at Lewis and Clark Community College. Outside of work, you can catch him watching his beloved Saint Louis Blues and Cardinals. He also loves spending time with family and friends.',
			],
		},
		{
			name: 'Noah Wootten',
			title: 'Diamond Expert',
			picture: 'aug3/NoahWootten.jpg',
			email: 'noahw@diamondsdirect.com',
			phone: '',
			bio: [
				'Noah has been with Diamonds Direct since the summer of 2020. Noah began his employment with Diamonds Direct as Front Office Support, before being moved to Customer Care. His favorite part of the repair desk is taking in priceless family heirloom pieces, and doing whatever necessary to make it a fully functional piece of jewelry again. Noah aspires to grow his career with Diamonds Direct. When he\'s not studying diamonds, Noah enjoys watching Films, Baking, playing Guitar, and listening to Murder-mystery podcasts.',
			],
		},
	],
	sponsorships: [
		{
			name: 'St. Louis Blues',
			image: 'blues.jpg',
		},
	],
	reviews: {
		googleRead: 'https://bit.ly/3acPArz',
		googleWrite: 'https://bit.ly/3acPArz',
	}
};

const SLC = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Salt Lake City',
	title: 'Diamonds Direct Salt Lake City, Utah - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Salt Lake City, Utah Location Today!',
	shortName: 'Salt Lake',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Located across from Fashion Place Mall, Diamonds Direct Salt Lake is the Deseret’s destination for bridal and fashion jewelry. Jazz up your everyday wardrobe with a piece from one of our many world-renowned designers. Looking for something unique and custom? No problem! Our private label is here to create the ring of your dreams.',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/DiamondsDirectSLC',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '196 E Winchester Street',
		line2: 'Murray, UT 84107',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Salt+Lake+City/@40.6324776,-111.8881016,17z/data=!4m5!3m4!1s0x875289b94525712b:0xdc3f6fd1a50e6dd0!8m2!3d40.6324776!4d-111.8859129',
	hours: {
		default: [
			{
				days: 'Monday - Saturday',
				hours: '12pm - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '3853884353',
	email: 'infoslc@diamondsdirect.com',
	team: [
		{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: [
				'Amit Berger, EVP, founded Diamonds Direct Birmingham in 2008. He joined the Diamonds Direct parent company in 1995 in Israel while working in the cutting facility and learning the trade\'s secrets.',
				'Born in Israel, Berger grew up working in his family restaurant business and developed his love of customer service and gregarious personality. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry. It was then when he started working for Diamonds Direct\'s parent company in the cutting facility with the founder of the company.',
				'In 1997, Berger came to the United States to begin working one on one with big diamond buyers. He traveled back and forth between Israel and 40 different states in the US working for Diamonds Direct\'s parent company in the wholesale division. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work with Diamonds Direct\'s parent company in the wholesale office and selling diamonds to top jewelry stores around the country. Eventually, Berger was running the wholesale division and was in charge of selecting diamonds from the cutting facility in Israel.',
				'In the meantime, his brother Itay, had opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the company. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.',
				'Berger made the move to Birmingham and opened the second Diamonds Direct location here in Birmingham, AL. He calls Birmingham his home and loves the friendly atmosphere. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. Their favorite thing to do as a family is play with their dog Ziggy and travel.',
			],
		},
		{
			name: 'Michelle Lewis',
			title: 'General Manager',
			picture: 'michelle_lewis.jpg',
			email: 'michellelewis@diamondsdirect.com',
			phone: '',
			bio: [
				'After working as a sales consultant at Diamonds Direct for 3 years, Michelle became the general manager at Diamonds Direct\'s Salt Lake branch. Michelle is a GIA graduate and has been certified through the Diamond Council of America. She has been in the diamond and jewelry industry for more than 10 years.',
				'Michelle worked in the bridal department at Jared\'s for almost 3 years. Prior to her time at Jared\'s she opened a new Helzberg Diamond location and was manager for 6 years.',
				'In her free time, Michelle enjoys hiking, skiing, cooking and spending time with her family and her two dogs.',
			],
		},
		{
			name: 'Michael Fisher',
			title: 'Diamond Expert',
			picture: 'michael_fisher.jpg',
			email: 'michaelf@diamondsdirect.com',
			phone: '',
			bio: [
				'Michael has been in the jewelry industry for 43 years. He is an A.G.S and G.I.A. graduate and Diamond expert.',
				'In addition to owning and operating his own jewelry store for nearly a decade, Michael has worked his way up and excelled in every capacity in the industry. Along with running Michael Fisher Fine Jewelry, he also owned and operated Fisher Custom Homes for over twenty years building several award-winning million-dollar custom homes.',
				'In his spare time, Michael enjoys spending time with his twenty-five grandchildren and lovely wife Stacy.',
			],
		},
		{
			name: 'Franzi Kobel',
			title: 'GIA Graduate Gemologist',
			picture: 'franzi_kobel.jpg',
			email: '',
			phone: '',
			bio: [
				'Franzi\'s journey into the jewelry world started over ten years ago when she worked for an auction company specializing in fine arts, antiques, and estate jewelry. This is where she grew a passion for jewelry and gems and decided to move from Munich to sunny California to attend the Gemological Institute of America. She graduated in 2011 earning the title of Graduate Gemologist.',
				'After graduating she returned to Munich but soon realized the U.S. offers a much more exciting market. She put roots in Utah and worked for a small local jewelry store for four years. Franzi joined the Diamonds Direct family in May of 2018. She is passionate about eating, going to concerts, and laughing with her fiance Adam and the friends she calls her "American family."',
			],
		},
		{
			name: 'Michelle Lassig',
			title: 'Master Jeweler',
			picture: 'michelle_lassig.jpg',
			email: 'michellelassig@diamondsdirect.com',
			phone: '',
			bio: [
				'Michelle joined Diamonds Direct Salt Lake City as a Master Jeweler with 20 years of jewelry industry experience, ranging from working in small mom-and-pop shops and large corporations to running her own business.',
				'"Yes" is Michelle\'s favorite word. Her ultimate goal is to provide superior customer service, with kindness and gratitude. In her spare time, Michelle enjoys being with family and her dog Moses. Michelle loves music, broadway, and chess.',
			],
		},
		{
			name: 'Kacey Roberts',
			title: '',
			picture: 'kacey_roberts.jpg',
			email: 'Kaceyr@diamondsdirect.com',
			phone: '',
			bio: [
				'Kasey Roberts joined the Salt Lake Diamonds Direct team in August of 2018. She has over a decade of experience in the diamond and jewelry industry in the role of sales, customer service, management, training and new store operations.',
				'Kasey left jewelry and retail altogether pursuing the opportunity to manage and coordinate operations for several brands of start-ups including event centers, sandwich shops and a financial coaching program. While she found working with front line teams and executive staff rewarding, she missed working face to face with clients and helping them with their most joyous occasions.',
				'During her free time, Kacey loves spending time with her two daughters and husband, reading, traveling and spending time with friends.',
			],
		},
	],
	sponsorships: [
		{
			name: 'University of Utah',
			image: 'utes.png',
		},
	],
	reviews: {
		googleRead: 'https://www.google.com/search?hl=en&ei=Xv50W7X1BITctQWQ6bzABQ&q=diamonds+direct+slc&oq=diamonds+direct+slc&gs_l=psy-ab.3..0.19125.19452.0.20308.3.3.0.0.0.0.110.299.1j2.3.0....0...1c.1.64.psy-ab..0.3.299...0i67k1j0i22i30k1.0.bR4dCBszo1E#lrd=0x875289b94525712b:0xdc3f6fd1a50e6dd0,1,,,',
		googleWrite: 'https://www.google.com/search?hl=en&ei=Xv50W7X1BITctQWQ6bzABQ&q=diamonds+direct+slc&oq=diamonds+direct+slc&gs_l=psy-ab.3..0.19125.19452.0.20308.3.3.0.0.0.0.110.299.1j2.3.0....0...1c.1.64.psy-ab..0.3.299...0i67k1j0i22i30k1.0.bR4dCBszo1E#lrd=0x875289b94525712b:0xdc3f6fd1a50e6dd0,1,,,',
	}
};

const SAN = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct San Antonio',
	title: 'Diamonds Direct San Antonio - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our San Antonio Location Today!',
	shortName: 'San Antonio',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit our beautiful showroom at the Shops at La Cantera to find that perfect gift. Spur on your loved one to come during one of our many events throughout the year, just keep an eye on our website and social media for dates! Don’t forget to tag us in all of your fun photos using #DDFamilyAlbum',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectsanantonio/',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '15900 La Cantera Pky, Bldg 18',
		line2: 'San Antonio, TX 78256',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+San+Antonio/@29.5930009,-98.6204149,17z/data=!3m1!4b1!4m5!3m4!1s0x865c6687423fc153:0x909f03c2b027ea46!8m2!3d29.5929963!4d-98.6182262',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '2102479197',
	email: 'infoSAT@diamondsdirect.com',
	team: [
		{
			name: 'Amit Berger',
			title: 'Partner | President West',
			picture: 'amit.jpg',
			email: 'Amit@DiamondsDirect.com',
			phone: '',
			bio: [
				'Amit Berger, EVP, founded Diamonds Direct Birmingham in 2008. He joined the Diamonds Direct parent company in 1995 in Israel while working in the cutting facility and learning the trade\'s secrets.',
				'Born in Israel, Berger grew up working in his family restaurant business and developed his love of customer service and gregarious personality. When he turned 18, Berger served in the Israel Defense Force in the air force division for three years. After the military, Berger spent two years in an Israeli University and enrolled in a professional diamond course where he fell in love with the industry. It was then when he started working for Diamonds Direct\'s parent company in the cutting facility with the founder of the company.',
				'In 1997, Berger came to the United States to begin working one on one with big diamond buyers. He traveled back and forth between Israel and 40 different states in the US working for Diamonds Direct\'s parent company in the wholesale division. Berger married wife Liat in 1998 and decided to move permanently to the United States. They made their home in Rockville, Maryland where he continued to work with Diamonds Direct\'s parent company in the wholesale office and selling diamonds to top jewelry stores around the country. Eventually, Berger was running the wholesale division and was in charge of selecting diamonds from the cutting facility in Israel.',
				'In the meantime, his brother Itay, had opened the first Diamonds Direct retail location in Charlotte, NC and convinced Berger to come visit and check out the retail side of the company. Berger fell in love with the excitement and reward with working face to face with customers rather than businesses.',
				'Berger made the move to Birmingham and opened the second Diamonds Direct location here in Birmingham, AL. He calls Birmingham his home and loves the friendly atmosphere. Berger lives with his wife, Liat, and three daughters, Lynn, Lielle, and Leia. Their favorite thing to do as a family is play with their dog Ziggy and travel.',
			],
		},
		{
			name: 'Tamir Shkargi',
			title: 'Vice President',
			picture: 'Tamir1.jpg',
			email: 'Tamir@diamondsdirect.com',
			phone: '',
			bio: [
				'Tamir Shkargi joined the Diamonds Direct team 2017. Originally from Israel, Tamir served in the Israeli Military for three years. Upon his completion of service, he embarked on a career with the Israeli government for over ten years. After receiving his degree in Business Administration at Ono Academic College, Tamir decided to move to the United States with his family.',
				'Tamir’s new chapter began in Austin, Texas which led him to pursue a career in retail management with Diamonds Direct. It was the remarkable culture and amazing group of people that made Diamonds Direct the perfect fit for Tamir.',
				'After managing the Frisco store for nearly two years, he was given the opportunity to bring his talents to Houston and grow the Diamonds Direct family. He is thrilled to also take on the San Antonio store to assist in the growth in this market.',
				'Outside of work, Tamir enjoys playing soccer with friends and spending time with his wife and their precious two boys!',
			],
		},
		{
			name: 'Yaniv Azulay',
			title: 'General Manager',
			picture: 'feb10/yaniv.jpg',
			email: 'YanivA@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Dee Dee Watkins',
			title: 'Store Manager',
			picture: 'feb28/Deedee.jpeg',
			email: 'debraw@DiamondsDirect.com',
			phone: '',
			bio: [
				'Dee Dee has been passionate about the jewelry industry for over 10 years. She is certified with The Diamond Council of America. Along with her previous education and experience, Diamond\'s Direct has made her a top notch Diamond Expert. She is the proud mother of 5 children, which includes a set of identical twin boys. She enjoys spending time with her family, especially her two grand babies.',
			],
		},
		{
			name: 'Nicole Rosenfield',
			title: 'Marketing and Merchandising Manager',
			picture: 'dec21/Nicole-Final.jpg',
			email: 'nicoler@diamondsdirect.com',
			phone: '',
			bio: [
				'Nicole Rosenfield, Marketing and Merchandising Manager, joined the Diamonds Direct family in 2021. She graduated with a degree in Public Relations and a minor in Business Management from the University of Texas at San Antonio. She brings a blended creative background made up of event planning, marketing, digital media, and project management.',
				'In her free time she enjoys reading, trying local restaurants, and being involved in the San Antonio community.',
			],
		},
		{
			name: 'Jessica Dean',
			title: 'Back Office Manager',
			picture: 'feb10/jessica.jpg',
			email: 'jessicad@diamondsdirect.com',
			phone: '',
			bio: [
				'Jessica Dean has been with Diamonds Direct since November 2014. She earned her Bachelor’s Degree in Communication from Meredith College.',
				'Dean has been pursuing her career and working in customer service for eight years. Jessica currently works as our Back Office Manager and is a customer service excellence expert.',
				'In her free time, Dean enjoys being outside and taking care of her fur baby. She is a Wilmington native and escapes to the beach whenever possible.',
			],
		},
		{
			name: 'Theresa Medina-Gholson',
			title: 'Diamond Expert',
			picture: 'feb10/theresa.jpg',
			email: 'theresam@DiamondsDirect.com',
			phone: '',
			bio: [
				'Theresa Medina-Gholson graduated from The University of the Incarnate Word with a Bachelor of Arts in Theatre as well as her Diamond Council of America certification.',
				'Theresa Medina-Gholson was a professional musical theatre actress who performed as a lead vocalist for The Hodge Podge Blues Band, and began selling diamonds in 2010.',
				'In her spare time, she enjoys cooking with her new husband, Tracey and is the proud mother of Annabella, age 10.',
			],
		},
		{
			name: 'Hilda Mendoza',
			title: 'Diamond Expert',
			picture: 'feb10/hilda.jpg',
			email: 'hilda@diamondsdirect.com',
			phone: '',
			bio: [
				'Hilda Mendoza is fluent in English/Spanish speaking. First generation American with family native to Mexico.  Hilda has over 14 years of customer service experience and management professionalism. Hilda attended University Primerica in Financial Analyst.  She is a mother of three and the youngest of seven brothers and sisters. In her free time she likes to spend it outdoors in nature enjoying the small things in life.'
			],
		},
		{
			name: 'Seth Cornelison',
			title: 'Diamond Expert',
			picture: 'dec21/Seth-Final.jpg',
			email: 'sethc@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Carlos Pazmino',
			title: 'Jeweler',
			picture: 'feb10/carlos.jpg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Jim Litz',
			title: 'Diamond Expert',
			picture: 'feb28/Jim.jpeg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Jocelyn Solis',
			title: 'Back Office Support',
			picture: 'feb28/Jocelyn.jpeg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Brenna Brazzill',
			title: 'Customer Care Representative',
			picture: 'feb28/Brenna.jpeg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Laura Powers',
			title: 'Diamond Expert',
			picture: 'feb28/Laura.jpeg',
			email: '',
			phone: '',
			bio: [],
		},
		{
			name: 'Veronica Kluver',
			title: 'Back Office Support',
			picture: 'dec21/Veronica-Final.jpg',
			email: 'veronicak@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Sidney Garza',
			title: 'Front Office Reception',
			picture: 'dec21/Sidney-Final.jpg',
			email: 'sidneyg@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Amelia Gomez',
			title: 'Front Office Reception',
			picture: 'Emily.jpg',
			email: 'ameliag@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Tad Garcia',
			title: 'Diamond Expert',
			picture: 'dec21/Tad-Final.jpg',
			email: 'tadg@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Siddharth Suresh',
			title: 'Diamond Expert',
			picture: 'dec21/siddharth.jpg',
			email: 'siddharths@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Rick Souddress',
			title: 'Diamond Expert',
			picture: 'Rick.png',
			email: 'ricks@diamondsdirect.com',
			phone: '',
			bio: [],
		},
		{
			name: 'Jared Lott',
			title: 'Diamond Expert',
			picture: 'Jared.jpg',
			email: 'JaredL@diamondsdirect.com',
			phone: '',
			bio: [
				'Jared Lott, Diamond Expert, joined the Diamonds Direct family in 2020. Jared offers a wide ranging background in sales. After attaining a bachelor\'s degree in education he transitioned to new opportunities. Having spent over three years with Samuel Jewelers, he has a deepened understanding of the value that each customer brings to the rhino family.',
				'When he is not dedicating his time to each of his customers, he enjoys golfing and fishing.',
			],
		},
		{
			name: 'Allison Ramos',
			title: 'Diamond Expert',
			picture: 'ALLISON.jpg',
			email: 'allisonr@diamondsdirect.com',
			phone: '',
			bio: [
				'Allison Ramos, diamond expert, joined Diamonds Direct in June 2019.  She received a Bachelors of Art in Social Work from the University of Akron.',
				'Allison was a practicing Social Worker for Summit County Children\'s Services for 8 years, then left to start a career in the jewelry industry.',
				'Allison has been in the diamond and jewelry industry for over 20 years.  Previously she was the General Manager for Jared, the Galleria of Jewelry, and a manager for Alson Jewelers. She enjoys designing jewelry to create the perfect masterpiece for her guests.',
				'Allison is an avid animal lover, and currently has two rescue dogs:  Marsh, an American Bulldog, and Gigi, a brindle boxer.  In her free time she enjoys spending time with her son, Brandon and his girlfriend Michelle, and her mother Jacquelyn, as well as many wonderful friends.',
			],
		},
		{
			name: 'Juliet Kent',
			title: 'Front Office Support',
			picture: 'Juliet.jpg',
			email: '',
			phone: '',
			bio: [],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://bit.ly/3uxgS58',
		googleWrite: 'https://bit.ly/3uxgS58',
	}
};

const TRY = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Troy',
	title: 'Diamonds Direct Troy - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our San Antonio Location Today!',
	shortName: 'Troy',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Visit us in Troy to shop our latest arrivals and exclusive selection of diamond and fine jewelry. Stay tuned for promotional events, designer showcases, and more!',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirecttroy',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '1985 West Big Beaver Rd. Ste 100',
		line2: 'Troy, MI 48084',
	},
	googleMapsLink: '',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '2485095435',
	email: 'infoTROY@diamondsdirect.com',
	team: [
		{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: [
				'Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.',
				'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.',
				'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.',
				'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.',
				'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.',
			],
		},
		{
			name: 'Niv Ankawa',
			title: 'Vice President',
			picture: 'NivAnkawa.jpg',
			email: 'Niv@diamondsdirect.com',
			phone: '',
			bio: [
				'Niv joined Diamonds Direct in 2018. With over 12 years of experience in the fine jewelry and diamond business, Niv’s expertise comes from his many years managing a store in the Diamond District in New York City.  Prior to the Diamond District, Niv also managed a jewelry store in Miami for 7 years. His strength is his ability to connect with people. He believes client satisfaction is the key to a successful brand.  In his free time Niv enjoys being active, playing soccer, frequents the gym, and is an avid skier. He also loves trying new restaurants and traveling all over the world.',
			],
		},
		{
			name: 'Jennifer Alter',
			title: 'General Manager',
			picture: 'Jennifer2.jpg',
			email: 'jenniferal@diamondsdirect.com',
			phone: '',
			bio: [
				'Jennifer Alter began her jewelry career at just 15 years old as a shop jeweler. She worked for a wholesale gemstone company, but one day was recruited to work at a local jewelry store.  This sparked a true passion in Alter, and for the last 30 years, she has worked at two local family owned businesses in the Troy area.  Alter is GIA certified in diamonds as well as design. Today, she is proud to lead the DIamonds Direct Troy team, with over 36 years of jewelry knowledge.   In her spare time, she treasures the time she gets to spend with her son, mutually enjoying his love of hockey.  When she can get away, Alter and her husband love to explore new places in their RV.  Additionally, one of Jennifer’s main passions is spending time in the local community and giving back to local charities as much as possible.  Her favorite quote and the secret to her success is, "Treat others how you want to be treated".',
			],
		},
		{
			name: 'Vik Sehdev',
			title: 'Store Manager',
			picture: 'Vik.jpg',
			email: 'viks@diamondsdirect.com',
			phone: '',
			bio: [
				'Vik Sehdev join the Diamonds Direct family in 2021, but has over 17 years of experience in fine jewelry and diamonds. Sehdev has been apart of almost every aspect of the jewelry industry. From being in the manufacturing and wholesale side, to managing a retail store for the largest Canadian owned jewelry company and to being an owner of an independent jewelry store. Vik’s main strengths include his ability to connect with people, and build strong relationships with them for life. In his free time, he loves to cook, golf, travel the world and explore new restaurants.',
			],
		},
		{
			name: 'Jessica LaPonse',
			title: 'Back Office Manager',
			picture: 'Jessica.jpg',
			email: 'Jessical@diamondsdirect.com',
			phone: '',
			bio: [
				'Jessica LaPonse was born and raised in Michigan. While she is new to the jewelry industry, she has worked in customer service for over 20 years. She first worked as a manager/bartender, as well as in sales as a store manager for two different companies, one in North Carolina and one in Michigan. She loves to learn new things and is looking forward to expanding her knowledge as she grows with the Diamonds Direct team. Jessica is excited about her new adventure into the jewelry business. Jessica is a single mother, who enjoys spending her days away from work with her two fabulous boys. She loves to attend their hockey, soccer practices, and games. She loves to read and travel with her boys and wonderful boyfriend, as well as enjoys going fishing. She also loves being outside, especially if it is on the beach in the sun.',
			],
		},
		{
			name: 'Katie VanDuyn',
			title: 'Diamond Expert',
			picture: 'Katie.jpg',
			email: 'katiev@diamondsdirect.com',
			phone: '',
			bio: [
				'Katie joined the Diamonds Direct family in October 2021. Originally from Grand Rapids, MI, she is now so excited to call the east side her home! Katie began her career in the jewelry industry in 2015 after graduating from Grand Valley State University. Her favorite aspect of the jewelry business is hearing every client’s unique love story! At the end of the day, she wants to help you find the perfect piece to represent your love story.  Outside of work, Katie loves spending time watching movies with her boyfriend and their two cats, Kanye and Chloe.',
			],
		},
		{
			name: 'Jennifer (Jen) Evola',
			title: 'Diamond Expert',
			picture: 'JenniferEvola.jpg',
			email: 'jennifere@diamondsdirect.com',
			phone: '',
			bio: [
				'Jennifer\'s love for jewelry drove her to join the Diamonds Direct family after being in customer service for close to 30 years.  She enjoys nothing more than creating unforgettable memories for life and acquiring new found friendships. Her passion and excitement for her clients’ is what has made her successful in all paths of her career.  Her favorite thing about being a Diamond Expert is being a part of the process and story that comes along with each and every client. Jennifer spends her free time with her sweet husband Greg, and her baby Yorkie, Chloie Coco Chanel.  She enjoys golfing, boating, and spending time with family.',
			],
		},
		{
			name: 'Szymon Grochowski',
			title: 'Shop Manager/Jeweler',
			picture: 'Syzmon.jpg',
			email: 'szymong@diamondsdirect.com',
			phone: '',
			bio: [
				'Szymon Grochowski was born in Warsaw, Poland in 1982 and moved with his family to the United States in 1991. He began learning the trade by working with his master jeweler father in 2005. Since then he worked in numerous companies in North Carolina specializing in repairs, setting, fabrication and design.',
				'He has been with Diamonds Direct for over five years and is very excited to continue in Troy, Michigan. In his spare time he loves to spend time with his lovely wife, Aline and two and a half year old daughter, Emily. He stays active by running and practicing Taekwondo. He’s also an avid collector of heavy metal albums on vinyl, loves to travel, and drive fast cars.',
			],
		},
		{
			name: 'Eldhose Abraham',
			title: 'HQ Jeweler',
			picture: 'Eldhose.jpg',
			email: '',
			phone: '',
			bio: [
				'Eldhose Abraham, is originally from India and came to the United States in 2000. He started working as a jeweler at Jared’s in Utica, Michigan. Since then he gained experience and confidence in repairs and diamond setting. He’s excited to continue in Diamonds Direct’s newest location in Troy, Michigan. In his spare time he loves to travel and spend time with his wife, two sons, and daughter.',
			],
		},
		{
			name: 'Samatha Douglas',
			title: 'Front Office Support',
			picture: 'Sam.jpg',
			email: 'Samdo@diamondsdirect.com',
			phone: '',
			bio: [
				'Samantha Douglas joined the Diamonds Direct family in 2021. She is recently engaged and excited to get married in May 2023! She has spent several years in customer service, but is new to the diamond industry. In her spare time, she likes to hang out with friends and family, have game nights, enjoys bike rides, visiting new places and loves to take pictures. She also has a 7-year old french bulldog named Titan.',
			],
		},
		{
			name: 'Kristine Parubi',
			title: 'Diamond Expert',
			picture: 'KristineParubi.jpg',
			email: 'kristinep@diamondsdirect.com',
			phone: '',
			bio: [
				'Kristine joined Diamonds Direct in 2018 with over 16 years of experience working in the Diamond District in New York City. Kristine, first, worked for Diamonds Direct’s manufacturer in New York before moving to Saint Louis to become a Diamond Expert in 2020. Kristine was born in Albania, raised in Bronx, New York, and speaks seven languages. She went to college for nursing, but loved the diamond industry too much to leave. In her spare time, she enjoys being active, watching documentaries, listening to music, and spending time with her family.',
			],
		},
		{
			name: 'Hunter Wesley',
			title: 'Front Desk',
			picture: 'Hunter.jpg',
			email: 'Hunterw@diamondsdirect.com',
			phone: '',
			bio: [
				'Hunter Wesley joined Diamonds Direct in 2022. He is a recent high school graduate from Macomb, MI and is extremely excited to be a part of the Diamonds Direct family! Hunter will also begin studying part-time at a local community college to work towards his bachelor\'s degree. Outside of work, he loves playing hockey and going bowling. In fact - Hunter has been playing hockey for over 15 years!',
			],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://www.google.com/search?q=diamonds+direct+troy&rlz=1C5CHFA_enUS897US897&sxsrf=APq-WBtkdmzSN73RI14XPPsWegEFmWJP1w%3A1650483428234&ei=5GBgYtf-DYGw0PEPxOmLWA&ved=0ahUKEwjXgMrzsaP3AhUBGDQIHcT0AgsQ4dUDCA4&uact=5&oq=diamonds+direct+troy&gs_lcp=Cgdnd3Mtd2l6EAMyEAguEIAEEIcCEMcBEK8BEBQyBggAEBYQHjIFCAAQhgMyBQgAEIYDMgUIABCGAzIFCAAQhgM6BwgAEEcQsAM6BwgAELADEEM6CggAEOQCELADGAE6EgguEMcBENEDEMgDELADEEMYAjoMCC4QyAMQsAMQQxgCOg8ILhDUAhDIAxCwAxBDGAI6BAgjECc6BAguEEM6DgguEIAEELEDEMcBEKMCOgsILhCABBDHARCjAjoICC4QsQMQgwE6DgguEIAEELEDEMcBENEDOgsIABCABBCxAxCDAToFCAAQkQI6CwguEMcBEK8BEJECOg0ILhCxAxDHARCjAhBDOgcIABCxAxBDOgQIABBDOgoILhDHARCvARBDOgcILhCxAxBDOgoILhDHARCjAhBDOggIABCABBCxAzoICAAQsQMQkQI6CwguEIAEEMcBEK8BOggILhCABBCxAzoFCC4QgAQ6CAguEIAEENQCOgUIABCABDoHCCMQsQIQJzoHCAAQsQMQCjoECAAQCjoKCC4QxwEQrwEQCjoHCCMQsAIQJzoKCC4QxwEQrwEQDToECAAQDUoECEEYAEoECEYYAVDVBViOKmCxLGgGcAF4AIABvwGIAcoWkgEEMy4yMJgBAKABAcgBEMABAdoBBggBEAEYCdoBBggCEAEYCA&sclient=gws-wiz',
		googleWrite: 'https://www.google.com/search?q=diamonds+direct+troy&rlz=1C5CHFA_enUS897US897&sxsrf=APq-WBtkdmzSN73RI14XPPsWegEFmWJP1w%3A1650483428234&ei=5GBgYtf-DYGw0PEPxOmLWA&ved=0ahUKEwjXgMrzsaP3AhUBGDQIHcT0AgsQ4dUDCA4&uact=5&oq=diamonds+direct+troy&gs_lcp=Cgdnd3Mtd2l6EAMyEAguEIAEEIcCEMcBEK8BEBQyBggAEBYQHjIFCAAQhgMyBQgAEIYDMgUIABCGAzIFCAAQhgM6BwgAEEcQsAM6BwgAELADEEM6CggAEOQCELADGAE6EgguEMcBENEDEMgDELADEEMYAjoMCC4QyAMQsAMQQxgCOg8ILhDUAhDIAxCwAxBDGAI6BAgjECc6BAguEEM6DgguEIAEELEDEMcBEKMCOgsILhCABBDHARCjAjoICC4QsQMQgwE6DgguEIAEELEDEMcBENEDOgsIABCABBCxAxCDAToFCAAQkQI6CwguEMcBEK8BEJECOg0ILhCxAxDHARCjAhBDOgcIABCxAxBDOgQIABBDOgoILhDHARCvARBDOgcILhCxAxBDOgoILhDHARCjAhBDOggIABCABBCxAzoICAAQsQMQkQI6CwguEIAEEMcBEK8BOggILhCABBCxAzoFCC4QgAQ6CAguEIAEENQCOgUIABCABDoHCCMQsQIQJzoHCAAQsQMQCjoECAAQCjoKCC4QxwEQrwEQCjoHCCMQsAIQJzoKCC4QxwEQrwEQDToECAAQDUoECEEYAEoECEYYAVDVBViOKmCxLGgGcAF4AIABvwGIAcoWkgEEMy4yMJgBAKABAcgBEMABAdoBBggBEAEYCdoBBggCEAEYCA&sclient=gws-wiz',
	}
};

const VAB = {
	template: 'store',
	currentPromo: false,
	name: 'Diamonds Direct Virginia Beach',
	title: 'Diamonds Direct Virginia Beach - Engagement Rings, Jewelry, and More',
	description: 'Diamonds Direct Offers the Finest Selection of Engagement Rings, Wedding Bands, Loose Diamonds, Fine Jewelry and More. Visit Our Virginia Beach Location Today!',
	shortName: 'Virginia Beach',
	bannerPromo: 'promo.jpg',
	mainDescription: [
		'Looking for the perfect VAB-ulous gift for that special someone? Don’t worry, we’ve got the best selection and diamond experts that Hampton Roads has ever seen. We’re here to make sure you leave knowing you’ve gotten the very best for your budget. Did we mention our heroes in uniform discount?',
	],
	midBanner: 'banner.jpg',
	midText: [
		'You are invited to travel throughout our showroom and visit our world-renowned designers. Grab your passport in store, get some stamps, and be entered to win!',
	],
	midBannerInfo: 'info.jpg',
	facebookUrl: 'https://www.facebook.com/diamondsdirectvabeach/',
	instagramUrl: 'https://www.instagram.com/diamondsdirect/',
	address: {
		line1: '4452 Virginia Beach Blvd',
		line2: 'Virginia Beach, VA 23462',
	},
	googleMapsLink: 'https://www.google.com/maps/place/Diamonds+Direct+Virginia+Beach/@36.8439769,-76.1316678,17z/data=!3m1!4b1!4m5!3m4!1s0x89ba950ad92519f5:0xc9f56c5efdc70504!8m2!3d36.8439726!4d-76.1294791',
	hours: {
		default: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: 'Closed',
			},
		],
		holiday: [
			{
				days: 'Monday - Friday',
				hours: '10am - 7pm',
			},
			{
				days: 'Saturday',
				hours: '10am - 6pm',
			},
			{
				days: 'Sunday',
				hours: '12pm - 5pm',
			},
		],
		notice: '',
	},
	phone: '7578370288',
	email: 'infoVAB@diamondsdirect.com',
	team: [
		{
			name: 'Barak Henis',
			title: 'Partner | President North',
			picture: 'barak_henis.jpg',
			email: 'Barak@DiamondsDirect.com',
			phone: '',
			bio: [
				'Barak Zeev Henis, EVP, founded Diamonds Direct Crabtree in 2008. He joined Diamonds Direct\'s parent company in 2004 as Sales Manager of the jewelry wholesale division where he climbed his way up in the diamond industry starting as a traveling sales person covering 30 states and supplying diamond jewelry to more than 150 retail jewelry stores.',
				'Born in Jerusalem, Israel in 1978, and raised in Tel Aviv, Henis joined the Israel Defense Force service in 1996 for three years. He claims the military service approach of fun and discipline helped him bring the special spark to his wonderful lethal unit at Diamonds Direct Crabtree.',
				'After exploring the world during a one year trip to South and Central America, the Far East, and New Zealand, Henis got his Bachelor\'s Degree in Business from Ben Gurion University. During his second year of Master studies in Law at Bar Ilan University, he met with Mr. Alon Arabov, the President and founder of Diamonds Direct Group and The Diamond Manufacturers. Henis knew right away he had found his true passion and path in life and started his professional gemology studies at the Diamond College in Ranat Gan. After working and specializing in loose diamonds, Henis started his natural move in 2004 to the world\'s largest diamond market in the USA.',
				'Henis started in the wholesale offices in Rockville, Maryland, moved with the company to the Diamond District in New York City and finally ended in Raleigh to open the third Diamonds Direct store.',
				'Henis is husband to wife Morgan and father to two sons and a daughter. He enjoys watching European soccer and playing with his international group of friends on Sundays. He sees Raleigh as his true home and is involved as a sponsor in many local fundraising events for non-profit organizations such as NCAAT, Make-A-Wish, American Heart Association, Chabad House, and many more through the Diamonds Direct Foundation.',
			],
		},
		{
			name: 'Ori Ben Amitai',
			title: 'Vice President, Virginia',
			picture: 'ori_amitai.jpg',
			email: 'Ori@DiamondsDirect.com',
			phone: '',
			bio: [
				'Ori Ben Amitai, Vice President, has been with Diamonds Direct since 2012. He attended Bar -Ilan University in Israel where he studied Industrial Practical Engineering. Previously, Ori was working for the diamond cutting facilities of the company in the Israeli diamond district.',
				'Born in Ramat Gan, Israel in 1984 and raised in Herzelia, Ben Amitai joined the Israeli defense forces in 2003 and served for 3 years. The military experience gave him great tools to appreciate the good things in life; his wife, family and close friends. The army experience also taught him a new way of life - always be on time never late, be honest with people, and never be afraid of the truth. In 2012 he started to explore the world of diamonds in the diamond cutting facilities of Diamond’s Direct in Ramat Gan, Israel, where he fell in love with them immediately. After one year of experience in the diamond district he was selected to join the company’s other side of the business, the direct-to-the-public stores. He started his way in the Raleigh location where he learned and work with Barak Henis (Vice President of the Raleigh and the Richmond location). Ori then relocated when the company opened its 4th location in Richmond, Virginia. He sees an amazing future to the Richmond market, and puts all his effort in establishing Diamonds Direct as a strong brand in the community. In his free time Ori likes to travel with his wife and his dog exploring Richmond and its surrounding cities.',
			],
		},
		{
			name: 'Mike Beem',
			title: 'General Manager',
			picture: 'beem.jpg',
			email: 'mikeb@diamondsdirect.com',
			phone: '',
			bio: [
				'Mike Beem, who recently joined Diamonds Direct in October 2018, has been involved in all facets of the jewelry business for more than 36 years.  What started as a part-time job, that enabled him to pay for 100% of his college tuition, evolved into a entire career specializing in fine jewelry.  Mike has managed jewelry stores on both the east and west coasts for large national retailers, family-owned independent stores in Northern Virginia, and even operated his own store, M. Beem Jewelers, in Reston, Virginia for over 12 years.',
				'Mike grew up in a military family and graduated from George Mason University with a Bachelors of Science Degree in Public Administration.  He has earned many certifications including Diamonds and Diamond Grading from the Gemological Institute of America (GIA). He has extensive experience with colored gemstones, jewelry design, and estate jewelry.  His biggest joy comes from the loyal following he has built – knowing that his clients return happy and refer their friends and family for his creativity, attention to detail, and outstanding service.  Mike is excited to be apart of the Diamonds Direct family where he can offer the absolute best selection and value in the industry.',
				'When not at work, you can find Mike avidly following the Washington Nationals and his beloved GMU Patriots men’s basketball team…and occasionally on the golf course or at the gym.  He, his wife, Maria, and their three sons have just relocated to Virginia Beach and are already ensconced in school, scouts, sports, music and theater.  They’re looking forward to all that Hampton Roads has to offer!',
			],
		},
		{
			name: 'Marcella Wishom',
			title: 'Store Manager',
			picture: 'mar09/MarcellaWishom.jpg',
			email: 'marcellaw@diamondsdirect.com',
			phone: '',
			bio: [
				'Marcella Wishom joined the Diamonds Direct family in October of 2019. She brings with her over 19 years of experience in the jewelry industry working for both national retailers and family-owned independent stores located in the Hampton Roads Region.',
				'Marcella holds a Bachelor of Arts Degree in Paralegal Studies from Hampton University. She is certified as a Diamontoligist by the Diamond Council of America (DCA) and she has received an Applied Jewelry Professional Diploma from the Gemological Institute of America (GIA).',
				'Marcella is a charismatic, energetic, motivational leader who is passionate about serving others. In her spare time she enjoys volunteering and singing in the community. Marcella’s life mantra is “ Do what you love!”',
			],
		},
		{
			name: 'Kim Kellam',
			title: 'Director of Sales',
			picture: 'kim_kellam.jpg',
			email: 'KimK@diamondsdirect.com',
			phone: '',
			bio: [
				'Kim Kellam is a diamond expert with 27 years of experience in the jewelry industry. She began working for Diamonds Direct in Virginia Beach in January 2016 and is excited to share her knowledge and expertise of diamonds and fine jewelry while providing an excellent atmosphere of great service.',
				'Kim grew up in Dubuque, Iowa in a family with 11 siblings, one of whom is her twin sister Kelly.',
				'She earned her Bachelors degree from the University of Northern Iowa, then moved to Oklahoma City, where she worked in the retail services industry for several years, in the area of cosmetics and as a store trainer. Kim began her fine jewelry career managing federated lease departments and then worked for an established independent jeweler in Oklahoma City, where she earned her GIA diamonds certification. Kim moved to Virginia Beach, Virginia in 1996 where she continued her work as a sales professional in management, as well as a buyer for a local independent jewelry company for 18 years.',
				'Kim is married to her husband Phil and has two stepsons Alex and Jay. In her spare time, she enjoys attending charity events, running, book clubs, being involved in women\'s faith groups, and doing community volunteer service.',
			],
		},
		{
			name: 'Tabatha Dennis',
			title: 'Back Office Manager',
			picture: 'Tabatha.jpg',
			email: 'tabathad@diamondsdirect.com',
			phone: '',
			bio: [
				'Tabatha Dennis joined Diamonds Direct in April 2018 as part of the back office team and was promoted to back office manager a short time later. Tabatha has over 16 years of customer service including 14 years of management experience in a specialty retail store. Tabatha has a passion for coaching and training in a positive and forward-thinking environment.',
				'Tabatha has lived all over the United States and came to Virginia Beach in 2005 from a military move and has never left because of building roots with her family. In her spare time, she enjoy going to the beach and spending time with her fiancé.',
			],
		},
		{
			name: 'Lonnie L. Phillips, Jr.',
			title: 'Diamond Expert',
			picture: 'lonnie_phillips.jpg',
			email: 'LonnieP@Diamondsdirect.com',
			phone: '',
			bio: [
				'Lonnie L. Phillips, Jr. has been in sales for over 20 years now. He joined the jewelry industry after leaving the Army in 2010. Lonnie has worked for Reed\'s Jewelers and Jared the Galleria of Jewelry before joining the Diamonds Direct team.',
				'In his free time, Lonnie enjoys skiing, attending football games, and mountain biking with his son.',
			],
		},
		{
			name: 'Jeff Hawkins',
			title: 'Diamond Expert',
			picture: 'hawkins.jpg',
			email: 'jeffh@diamondsdirect.com',
			phone: '',
			bio: [
				'Jeff Hawkins joined the Virginia Beach Diamonds Direct team in September 2018 as a Diamond Expert. He brings with him nearly 30 years of jewelry sales and management experience. Twenty-five of those years were spent with Signet Jewelers, where he won numerous awards, including two Manager of the Year Awards and a Hall of Fame Award.',
				'Jeff studied Business Management at the University of West Florida and is DCA Certified in diamonds and gemstones. His passion for jewelry stems from the great joy he receives from playing an integral part in his clients gift-giving occasions.  Building a trusting relationship with each of his clients is Jeff\'s goal.  "I want the client to feel confident and fully informed about their choice" says Jeff.',
				'During his free time, Jeff loves spending time with family and friends. He is involved in many networking organizations and is an avid soccer player still to this day. Indoor, outdoor, or in the sand, Jeff will play!',
			],
		},
		{
			name: 'Jackie Thorne',
			title: 'Diamond Expert',
			picture: 'thorne.jpg',
			email: 'jackiet@diamondsdirect.com',
			phone: '',
			bio: [
				'Jackie Thorne joined the Diamonds Direct family in October 2018. With over 20 years of experience in the jewelry industry, she demonstrates the highest standards and passion for customer service. Jackie\'s prior roles have included a series of sales and manager positions working for national jewelry retailers as well as local jewelry stores in Hampton Roads.',
				'During Jackie\'s free time she loves to cook, travel, and spend time with her family.',
			],
		},
		{
			name: 'Anne Pitt',
			title: 'Master Jeweler',
			picture: 'anne_pitt.jpg',
			email: 'AnneP@diamondsdirect.com',
			phone: '',
			bio: [
				'Anne Pitt has been working as a jeweler for 33 years. She began her Diamonds Direct career in 2015 working as the Corporate Jeweler in Richmond. Anne earned her Bachelors of Fine Arts from Virginia Commonwealth University’s Art School with a major in metals.',
				'Through the years Anne has won awards for her craftsmanship, earning Best in Show in metals and a William F. Kehoe award. She also has designed and crafter her own pieces and spent time crafting gallery pieces in her early career.',
				'After working in independent jewelry stores Anne moved to work for Jared the Galleria of Jewelry. After several years there Anne found her home with Diamonds Direct. She is now the Master Jeweler for Diamonds Direct in Virginia Beach.',
			],
		},
		{
			name: 'Cindy Zhang',
			title: 'Graduate Gemologist',
			picture: 'zhang.jpg',
			email: 'cindyz@diamondsdirect.com',
			phone: '',
			bio: [
				'Jing \'Cindy\' Zhang, joined the Diamonds Direct family in May 2018. Cindy moved to the United States in 2013, after receiving a bachelor\'s degree in international business in China. For the past 16 years, she has worked in a variety of different industries including print and news editing, international trading, and jewelry sales. Her biggest passions are Fine Jewelry and Gemstones, and is currently a GIA student. Cindy enjoys to travel and loves studying different cultures.',
			],
		},
		{
			name: 'Tricia Ramsbottom',
			title: 'Diamond Expert',
			picture: 'Tricia.jpg',
			email: 'PatriciaR@diamondsdirect.com',
			phone: '',
			bio: [
				'Tricia joined the Diamonds Direct family in November of 2020, but has over 25 years of jewelry experience and has worked in management for other jewelers including Reeds Jewelers and Signet Jewelers. Tricia is also DCA diamond certified. While, of course she has a passion for jewelry and diamonds, the true passion comes from each customer. Every experience and encounter is different and she love helping find that jewel that will forever be a sentiment.  In her spare time, she loves spending time at church, with family, cooking, and finding a new purpose for old things!',
			],
		},
		{
			name: 'Tal Feldman',
			title: 'Brand Ambassador',
			picture: 'Tal.jpg',
			email: 'Talf@diamondsdirect.com',
			phone: '',
			bio: [
				'Tal Feldman joined the Diamonds Direct family in 2020, where she has held multiple roles including: front desk, back office, and now the Brand Ambassador position.',
				'Tal was born in Israel, served two years in the Israel Defense Force and after that moved to Switzerland to do her BA in Hospitality. She has worked in the hotel industry for companies like Sandals and the Ritz Carlton where she held roles in wedding planning, restaurant management, event services, and customer service. It was in this industry that she met her husband, who was a Chef in one of the fine dining restaurants. The two moved to Israel for two years, where Feldman worked as an event planner in the hotel and bridal industry. They now live in Virginia Beach and enjoy spending time with their daughter.',
			],
		},
	],
	sponsorships: [],
	reviews: {
		googleRead: 'https://bit.ly/3D3qkjF',
		googleWrite: 'https://bit.ly/3D3qkjF',
	}
};


export const ALL = {
	'atx': ATX,
	'bay': BAY,
	'bhm': BHM,
	'boc': BOC,
	'chs': CHS,
	'cle': CLE,
	'clt': CLT,
	'coh': COH,
	'dfw': DFW,
	'ecj': ECJ,
	'ftx': FTX,
	'gsc': GSC,
	'hou': HOU,
	'ind': IND,
	'jax': JAX,
	'kcy': KCY,
	'nol': NOL,
	'nva': NVA,
	'okc': OKC,
	'pit': PIT,
	'ral': RAL,
	'rva': RVA,
	'stl': STL,
	'slc': SLC,
	'san': SAN,
	'try': TRY,
	'vab': VAB,
};







// WEBPACK FOOTER //
// ./src/constants/stores.jsx